import * as React from "react";

const BoneMetastasesDMIImage = React.forwardRef<SVGSVGElement, {}>((_, ref) => {
  return (
    <svg
      id="BoneMetastasesImage"
      ref={ref}
      viewBox="0 0 1024 768"
      width="100%"
      height="100%"
      fill="none"
      style={{ maxHeight: "77vh" }}
    >
      <rect width={1024} height={768} fill="#E5E5E5" />
      <g id="Diffuse SVG" clipPath="url(#clip0_BONEDMI)">
        <rect width={1024} height={768} fill="white" />
        <g id="Group 86">
          <g id="Back">
            <g id="Skeleton Shape back" filter="url(#filter0_f_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M548.155 173.517C532.984 161.235 512.923 133.05 510.287 119.115C505.273 124.099 510.15 142.01 514.4 157.619C516.861 166.656 519.111 174.922 519.111 179.462C519.111 195.307 527.208 209.168 539.26 216.667C538.701 217.658 538.383 218.802 538.385 220.022C538.39 222.694 539.934 225.005 542.177 226.116C539.926 227.23 538.38 229.552 538.385 232.234C538.389 234.193 539.219 235.958 540.546 237.198C539.213 238.444 538.381 240.218 538.385 242.187C538.387 243.533 538.78 244.787 539.456 245.843C536.945 246.849 535.174 249.307 535.177 252.177C535.178 252.812 535.266 253.426 535.429 254.008C531.908 254.629 527.875 255.629 523.633 257.232C516.439 259.95 508.707 264.392 501.92 271.509C501.513 271.424 501.101 271.341 500.682 271.261C489.763 269.182 474.809 269.193 458.802 277.426C455.485 279.133 454.221 283.239 455.979 286.599C457.738 289.958 461.853 291.298 465.17 289.592C473.657 285.227 481.69 283.764 488.648 283.75C484.711 286.659 481.009 290.124 477.734 294.249C475.489 295.635 473.43 297.211 471.63 299.005C467.688 302.934 464.951 307.955 464.365 314.104C463.969 318.254 464.582 322.611 466.119 327.152C465.463 328.902 465.003 330.769 464.778 332.753C464.177 338.056 465.324 343.609 468.024 349.329C466.142 352.318 464.829 355.701 464.479 359.479C464.058 364.007 465.073 368.538 467.352 372.977C465.823 375.889 464.776 379.076 464.474 382.526C464.074 387.104 465.026 391.681 467.269 396.151C465.779 399.152 464.764 402.399 464.47 405.874C463.981 411.667 465.553 417.455 469.182 423.008C471.259 426.188 475.478 427.124 478.605 425.1C481.731 423.076 482.582 418.858 480.504 415.679C478.37 412.413 477.815 409.671 478.016 407.291C478.226 404.801 479.325 402.057 481.568 399.043C486.177 392.852 494.613 386.857 504.605 381.53C514.429 376.29 525.037 372.067 533.26 369.14C534.36 368.748 535.415 368.38 536.417 368.038C537.136 368.538 537.965 368.906 538.875 369.102C539.1 369.15 539.325 369.197 539.549 369.244C536.771 369.555 534.36 371.57 533.678 374.447C532.811 378.107 535.076 381.776 538.736 382.641C542.807 383.603 546.886 384.292 550.972 384.718C550.977 386.123 550.981 387.527 550.984 388.932C547.93 388.553 544.875 388.014 541.818 387.319C538.151 386.485 534.501 388.782 533.665 392.45C532.83 396.117 535.125 399.766 538.792 400.6C542.843 401.521 546.906 402.206 550.98 402.643C550.974 404.63 550.965 406.617 550.954 408.604C550.951 409.133 550.948 409.662 550.944 410.192C547.897 409.823 544.858 409.292 541.825 408.599C538.158 407.761 534.506 410.055 533.667 413.722C532.827 417.389 535.119 421.04 538.786 421.877C542.775 422.789 546.775 423.457 550.785 423.882C550.759 425.455 550.731 427.028 550.701 428.601L540.298 428.618C536.537 428.624 533.491 431.677 533.495 435.439C533.499 439.2 536.552 442.244 540.313 442.238L550.393 442.222C550.338 444.32 550.281 446.418 550.221 448.516L540.298 448.531C536.536 448.537 533.491 451.591 533.495 455.352C533.499 459.113 536.551 462.158 540.313 462.152L549.8 462.137C549.747 463.76 549.692 465.383 549.637 467.006L540.298 467.021C536.536 467.027 533.491 470.081 533.495 473.842C533.499 477.603 536.551 480.648 540.313 480.642L549.16 480.628L549.053 483.64L540.298 483.654C536.537 483.659 533.491 486.713 533.495 490.475C533.499 494.236 536.552 497.28 540.313 497.274L548.564 497.261C548.498 499.121 548.433 500.982 548.368 502.841L537.991 502.858C534.229 502.864 531.183 505.917 531.186 509.679C531.189 513.44 534.24 516.484 538.001 516.478L547.914 516.463C547.853 518.397 547.793 520.331 547.735 522.264L537.99 522.279C534.229 522.285 531.183 525.339 531.186 529.1C531.189 532.862 534.24 535.906 538.001 535.9L547.366 535.885C547.34 536.969 547.314 538.052 547.29 539.135C544.865 538.627 542.44 537.995 540.012 537.245C536.419 536.134 532.604 538.147 531.491 541.741C530.378 545.335 532.388 549.148 535.981 550.258C539.647 551.391 543.331 552.297 547.033 552.962C547.016 554.204 546.999 555.447 546.985 556.689C544.662 556.192 542.338 555.582 540.012 554.863C536.419 553.753 532.604 555.766 531.491 559.359C530.378 562.953 532.388 566.766 535.981 567.876C539.6 568.995 543.238 569.893 546.893 570.555C546.892 571.488 546.892 572.421 546.893 573.353C544.601 572.86 542.307 572.256 540.012 571.547C536.419 570.437 532.604 572.45 531.491 576.043C530.378 579.637 532.388 583.45 535.981 584.56C539.635 585.69 543.309 586.594 547 587.258C547.007 587.758 547.014 588.258 547.022 588.759C544.687 588.26 542.35 587.647 540.012 586.925C536.419 585.814 532.604 587.827 531.491 591.421C530.378 595.014 532.388 598.828 535.981 599.938C539.75 601.103 543.54 602.028 547.348 602.697C547.372 603.443 547.396 604.189 547.421 604.935C543.994 604.185 540.507 606.179 539.457 609.593C538.351 613.189 540.37 616.998 543.965 618.101C545.316 618.515 546.671 618.885 548.031 619.209C548.151 621.514 548.282 623.818 548.424 626.122C548.205 626.521 548.022 626.949 547.883 627.401C546.778 630.997 548.796 634.806 552.391 635.909C558.348 637.736 564.586 637.914 570.903 635.848C574.478 634.678 576.431 630.832 575.264 627.258C574.974 626.37 574.519 625.582 573.944 624.917C574.017 623.095 574.084 621.273 574.147 619.45C575.87 619.057 577.596 618.579 579.326 618.013C582.902 616.843 584.855 612.997 583.688 609.422C582.521 605.848 578.676 603.898 575.101 605.068C574.994 605.103 574.887 605.137 574.78 605.171C574.699 605.197 574.618 605.223 574.537 605.248C574.553 604.48 574.568 603.713 574.583 602.945C578.809 602.26 583.052 601.227 587.308 599.824C590.881 598.646 592.825 594.796 591.65 591.224C590.475 587.652 586.626 585.711 583.053 586.888C580.283 587.801 577.521 588.528 574.764 589.076C574.768 588.563 574.771 588.049 574.775 587.536C578.938 586.851 583.116 585.828 587.308 584.446C590.881 583.269 592.825 579.418 591.65 575.846C590.475 572.274 586.626 570.333 583.053 571.511C580.293 572.42 577.541 573.145 574.794 573.692C574.791 572.745 574.787 571.798 574.782 570.851C578.943 570.166 583.119 569.143 587.308 567.762C590.881 566.585 592.825 562.734 591.65 559.162C590.475 555.59 586.626 553.649 583.053 554.827C580.247 555.751 577.449 556.485 574.656 557.035C574.64 555.778 574.622 554.52 574.604 553.262C578.823 552.577 583.059 551.545 587.308 550.144C590.881 548.967 592.825 545.116 591.65 541.544C590.475 537.972 586.626 536.031 583.053 537.208C580.147 538.166 577.25 538.919 574.358 539.475C574.332 538.265 574.307 537.054 574.28 535.843L585.185 535.826C588.946 535.82 591.993 532.766 591.99 529.005C591.987 525.244 588.936 522.199 585.174 522.205L573.951 522.223C573.9 520.29 573.848 518.356 573.795 516.422L585.185 516.404C588.947 516.398 591.993 513.344 591.99 509.583C591.987 505.822 588.936 502.778 585.174 502.783L573.407 502.802C573.352 500.943 573.296 499.083 573.241 497.222L582.882 497.207C586.643 497.201 589.688 494.147 589.684 490.386C589.68 486.625 586.628 483.581 582.866 483.587L572.831 483.602L572.741 480.591L582.881 480.575C586.643 480.569 589.688 477.515 589.684 473.754C589.68 469.992 586.628 466.948 582.866 466.954L572.343 466.971C572.297 465.348 572.252 463.725 572.207 462.102L582.881 462.085C586.643 462.079 589.688 459.025 589.684 455.264C589.68 451.503 586.628 448.458 582.866 448.464L571.855 448.482C571.805 446.385 571.756 444.287 571.71 442.189L582.882 442.171C586.643 442.165 589.688 439.111 589.684 435.35C589.68 431.589 586.628 428.545 582.866 428.551L571.445 428.569C571.42 427.026 571.395 425.483 571.373 423.94C575.701 423.509 580.038 422.799 584.382 421.811C588.05 420.977 590.348 417.327 589.515 413.66C588.682 409.992 585.034 407.696 581.366 408.53C577.972 409.302 574.591 409.879 571.221 410.26L571.219 409.992C571.202 407.578 571.187 405.164 571.176 402.749C575.592 402.314 580.018 401.574 584.452 400.516C588.111 399.643 590.37 395.969 589.499 392.311C588.627 388.652 584.955 386.394 581.296 387.268C577.906 388.077 574.521 388.671 571.138 389.057C571.137 387.618 571.136 386.178 571.137 384.739C575.544 384.301 579.953 383.58 584.362 382.591C588.033 381.767 590.342 378.124 589.52 374.454C588.864 371.529 586.417 369.469 583.592 369.171C583.715 369.148 583.838 369.124 583.962 369.1L584.171 369.06C584.932 368.912 585.638 368.643 586.274 368.276C587.065 368.55 587.887 368.838 588.736 369.14C596.959 372.067 607.567 376.29 617.391 381.53C627.383 386.857 635.819 392.852 640.428 399.043C642.671 402.057 643.77 404.801 643.98 407.291C644.181 409.671 643.626 412.413 641.492 415.679C639.414 418.858 640.265 423.076 643.391 425.1C646.518 427.124 650.737 426.188 652.814 423.008C656.443 417.455 658.015 411.667 657.526 405.874C657.232 402.399 656.217 399.152 654.727 396.152C656.971 391.682 657.923 387.104 657.522 382.526C657.22 379.077 656.174 375.89 654.645 372.978C656.925 368.539 657.939 364.007 657.519 359.479C657.168 355.7 655.855 352.316 653.972 349.328C656.671 343.608 657.818 338.055 657.217 332.753C656.993 330.769 656.532 328.903 655.877 327.153C657.414 322.612 658.027 318.254 657.631 314.104C657.045 307.955 654.308 302.934 650.366 299.005C648.565 297.21 646.505 295.634 644.259 294.247C640.985 290.123 637.283 286.659 633.346 283.75C640.305 283.764 648.338 285.227 656.824 289.592C660.142 291.298 664.257 289.958 666.015 286.599C667.774 283.239 666.51 279.133 663.192 277.426C647.186 269.193 632.232 269.182 621.313 271.261C620.894 271.341 620.481 271.424 620.074 271.51C613.287 264.392 605.555 259.95 598.361 257.232C594.553 255.792 590.912 254.839 587.66 254.211C587.877 253.544 587.993 252.833 587.992 252.094C587.989 249.236 586.224 246.792 583.727 245.785C584.404 244.725 584.795 243.465 584.792 242.114C584.789 240.155 583.958 238.39 582.632 237.15C583.965 235.905 584.796 234.13 584.793 232.162C584.788 229.489 583.244 227.178 581.001 226.067C583.252 224.953 584.798 222.631 584.793 219.949C584.79 218.265 584.176 216.726 583.162 215.539C594.261 207.827 601.596 194.543 601.596 179.462C601.596 174.922 603.846 166.656 606.307 157.619C610.557 142.01 615.434 124.099 610.421 119.115C607.848 132.716 588.677 159.889 573.653 172.605C573.735 159.195 573.758 145.772 573.699 132.338H548.713C548.381 146.062 548.209 159.788 548.155 173.517ZM575.131 370.498C573.809 370.661 572.489 370.802 571.168 370.921L571.168 371.039C572.486 370.887 573.807 370.707 575.131 370.498ZM550.889 371L550.888 370.936C550.231 370.875 549.574 370.808 548.918 370.734C549.574 370.831 550.231 370.92 550.889 371ZM543.159 351.516C543.16 351.516 543.162 351.515 544.582 356.344L543.162 351.515C546.068 350.706 549.095 351.942 550.715 354.361C550.696 352.845 550.676 351.329 550.655 349.813L540.313 349.829C538.969 349.831 537.715 349.444 536.659 348.774C535.495 349.106 534.254 349.468 532.949 349.861C524.728 352.336 514.132 355.96 504.324 360.6C494.328 365.328 485.974 370.737 481.445 376.44C479.671 378.675 478.652 380.744 478.223 382.661C484.032 377.581 491.064 373.171 498.046 369.448C508.666 363.785 519.944 359.311 528.495 356.266C532.787 354.738 536.429 353.558 539.007 352.756C540.296 352.355 541.322 352.049 542.031 351.841C542.185 351.796 542.324 351.755 542.448 351.719C542.609 351.673 542.744 351.634 542.852 351.603L542.993 351.563L543.074 351.54L543.135 351.523L543.159 351.516ZM578.837 351.516C578.836 351.516 578.834 351.515 577.389 356.429L578.834 351.515C575.918 350.704 572.882 351.95 571.266 354.384C571.277 352.85 571.29 351.315 571.303 349.781L582.881 349.762C584.025 349.761 585.103 349.477 586.048 348.977C587.003 349.253 588.005 349.547 589.048 349.861C597.269 352.336 607.865 355.96 617.673 360.599C627.668 365.328 636.022 370.737 640.552 376.44C642.326 378.675 643.345 380.744 643.774 382.661C637.965 377.581 630.932 373.172 623.95 369.448C613.33 363.785 602.052 359.311 593.501 356.266C589.209 354.738 585.567 353.558 582.989 352.756C581.7 352.355 580.674 352.049 579.965 351.841C579.849 351.807 579.741 351.775 579.642 351.747C579.439 351.688 579.272 351.64 579.144 351.603L578.994 351.56L578.922 351.54L578.861 351.523L578.837 351.516ZM585.778 268.797C586.203 268.596 586.604 268.353 586.975 268.073C588.19 268.359 589.455 268.703 590.755 269.114C588.996 268.964 587.329 268.862 585.778 268.797ZM531.239 269.115C532.846 268.606 534.402 268.2 535.875 267.878C536.274 268.221 536.714 268.517 537.186 268.761C535.366 268.821 533.371 268.932 531.239 269.115ZM597.22 283.717C591.845 282.799 586.894 282.456 582.965 282.37C580.315 282.312 578.159 282.371 576.687 282.442C575.952 282.478 575.389 282.516 575.024 282.544C574.842 282.559 574.709 282.57 574.628 282.578L574.556 282.584L574.547 282.585L574.542 282.586L574.539 282.586L574.537 282.586C573.725 282.669 572.934 282.606 572.191 282.417L572.163 284.144C572.915 284.089 573.943 284.02 575.207 283.949C577.986 283.793 581.913 283.627 586.545 283.583C589.784 283.552 593.395 283.58 597.22 283.717ZM634.967 304.775C636.102 306.376 637.152 308.089 638.105 309.922C632.65 307.281 626.595 305.361 620.718 303.926C609.642 301.222 597.963 299.961 589.157 299.367C584.731 299.068 580.979 298.935 578.324 298.876C576.996 298.847 575.94 298.836 575.208 298.832C574.843 298.831 574.558 298.831 574.361 298.831C574.262 298.832 574.185 298.832 574.131 298.833L574.067 298.833L574.042 298.833C574.04 298.833 574.039 298.833 574.012 301.694L574.038 298.833C573.302 298.841 572.593 298.966 571.928 299.189L571.944 298.132L582.882 298.115C584.098 298.113 585.24 297.792 586.228 297.232L586.412 297.23C595.236 297.145 606.554 297.533 617.002 299.337C618.509 299.598 619.972 299.883 621.385 300.194C621.444 300.368 621.503 300.543 621.561 300.718C622.736 304.274 626.578 306.144 630.144 304.895C630.999 304.595 631.761 304.143 632.409 303.579C633.306 303.961 634.16 304.359 634.967 304.775ZM547.984 301.735L547.958 298.833C548.582 298.84 549.186 298.931 549.762 299.094L549.743 298.167L540.313 298.182C539.05 298.184 537.868 297.843 536.853 297.245C536.437 297.239 536.014 297.234 535.584 297.23C526.76 297.145 515.442 297.533 504.994 299.337C503.486 299.598 502.022 299.884 500.609 300.195C500.55 300.368 500.491 300.543 500.433 300.718C499.258 304.274 495.416 306.144 491.85 304.894C490.995 304.595 490.234 304.143 489.586 303.58C488.688 303.961 487.834 304.36 487.027 304.776C485.892 306.377 484.842 308.09 483.889 309.922C489.345 307.282 495.4 305.361 501.277 303.926C512.353 301.222 524.033 299.961 532.838 299.367C537.265 299.068 541.016 298.935 543.671 298.876C544.999 298.847 546.055 298.836 546.787 298.832C547.153 298.831 547.438 298.831 547.635 298.831L547.766 298.832L547.864 298.833L547.928 298.833L547.954 298.833C547.955 298.833 547.957 298.833 547.984 301.735ZM539.03 282.37C535.1 282.456 530.15 282.799 524.774 283.717C528.6 283.58 532.211 283.552 535.451 283.583C540.082 283.627 544.01 283.793 546.789 283.949C547.855 284.009 548.753 284.068 549.459 284.117L549.427 282.501C548.795 282.623 548.134 282.655 547.458 282.586L547.456 282.586L547.453 282.586L547.448 282.585C547.434 282.584 547.407 282.581 547.367 282.578C547.286 282.57 547.153 282.559 546.97 282.544C546.605 282.516 546.043 282.478 545.308 282.442C543.836 282.371 541.679 282.312 539.03 282.37ZM640.745 328.346C640.598 328.183 640.446 328.02 640.288 327.857C635.843 323.277 627.558 319.705 617.265 317.192C607.239 314.744 596.414 313.554 587.988 312.985C586.742 314.402 584.916 315.297 582.882 315.3L571.695 315.318C571.677 316.576 571.66 317.833 571.644 319.091L572.244 319.09C573.726 317.664 575.815 316.906 577.978 317.213L577.68 319.081C577.979 317.213 577.981 317.213 577.982 317.213L578.006 317.217L578.067 317.226C578.119 317.233 578.193 317.244 578.289 317.258C578.48 317.287 578.756 317.328 579.11 317.384C579.82 317.494 580.846 317.659 582.136 317.881C584.715 318.324 588.359 318.995 592.654 319.913C601.206 321.74 612.507 324.577 623.164 328.599C630.224 331.262 637.447 334.605 643.433 338.798C643.618 337.951 643.721 337.17 643.76 336.451C640.913 334.858 639.671 331.432 640.745 328.346ZM550.08 315.352C550.104 316.609 550.128 317.867 550.152 319.124L549.79 319.125C548.305 317.676 546.2 316.904 544.019 317.213L544.326 319.133C544.018 317.213 544.017 317.213 544.015 317.213L543.991 317.217L543.93 317.226C543.878 317.233 543.804 317.244 543.708 317.258C543.518 317.287 543.242 317.328 542.887 317.384C542.177 317.494 541.151 317.659 539.861 317.881C537.282 318.324 533.639 318.995 529.343 319.913C520.791 321.74 509.49 324.577 498.833 328.599C491.773 331.262 484.549 334.605 478.563 338.799C478.378 337.952 478.274 337.171 478.235 336.451C481.083 334.859 482.325 331.432 481.251 328.346C481.398 328.183 481.55 328.02 481.708 327.857C486.153 323.277 494.438 319.705 504.731 317.192C514.758 314.743 525.586 313.553 534.012 312.985C534.37 312.96 534.722 312.937 535.07 312.916C536.321 314.417 538.206 315.371 540.313 315.367L550.08 315.352ZM582.881 332.693C583.638 332.692 584.367 332.567 585.047 332.338C586.443 332.611 587.961 332.919 589.578 333.265C597.797 335.02 608.38 337.694 618.166 341.386C628.18 345.164 636.396 349.663 640.785 354.601C642.701 356.757 643.639 358.719 643.921 360.514C637.996 355.676 630.783 351.601 623.663 348.232C613.026 343.201 601.738 339.356 593.185 336.782C588.891 335.489 585.248 334.505 582.669 333.842C581.379 333.51 580.354 333.258 579.644 333.087C579.289 333.002 579.013 332.937 578.822 332.893L578.691 332.862L578.601 332.842L578.539 332.828L578.516 332.822C578.514 332.822 578.513 332.821 577.706 336.15L578.512 332.821C578.278 332.769 578.045 332.729 577.812 332.701L582.881 332.693ZM544.304 336.202L543.485 332.821C543.596 332.796 543.707 332.774 543.818 332.755L540.313 332.76C539.354 332.762 538.442 332.565 537.614 332.21C536.041 332.513 534.296 332.864 532.42 333.265C524.2 335.02 513.617 337.694 503.831 341.386C493.818 345.164 485.601 349.663 481.212 354.601C479.296 356.757 478.358 358.718 478.076 360.514C484.001 355.676 491.214 351.601 498.334 348.232C508.97 343.201 520.259 339.357 528.812 336.782C533.106 335.489 536.749 334.505 539.327 333.842C540.617 333.51 541.643 333.258 542.353 333.087C542.475 333.058 542.587 333.031 542.691 333.007L542.84 332.971L542.962 332.943L543.174 332.893L543.296 332.864L543.396 332.842L543.457 332.828L543.481 332.822C543.483 332.822 543.484 332.822 544.304 336.202ZM571.475 332.711L576.216 332.704C574.315 332.934 572.578 333.963 571.443 335.515C571.453 334.58 571.464 333.646 571.475 332.711ZM550.437 335.36C549.369 333.981 547.815 333.043 546.105 332.751L550.394 332.745C550.408 333.616 550.423 334.488 550.437 335.36Z"
                fill="#EEEEEE"
              />
            </g>
            <g id="Body Back" filter="url(#filter1_f_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M504.277 137.106C502.384 130.558 501.36 123.563 501.36 116.3C501.36 79.3923 527.807 55.0029 560.384 55.0029C592.961 55.0029 619.409 79.3923 619.409 116.3C619.409 123.316 618.454 130.081 616.682 136.433C616.801 136.46 616.92 136.489 617.038 136.519C624.901 138.547 630.781 140.817 622.091 160.43C617.297 171.25 615.809 180.151 608.503 181.108C607.873 182.933 607.256 184.726 607.11 185.171C604.033 194.536 589.754 244.67 631.592 258.21C683.989 275.167 689.661 254.131 731.065 315.155C731.065 315.155 726.824 348.308 751.4 409.213C791.921 448.541 691.035 482.94 691.035 482.94L691.035 381.399C691.035 381.399 658.075 524.898 681.404 601.633C704.732 678.367 683.534 735.956 684.382 740.681C685.009 744.175 600.764 746.616 561.725 743.951C522.687 746.616 438.442 744.921 439.069 741.427C439.917 736.703 417.223 678.367 440.551 601.633C463.88 524.898 432.415 381.399 432.415 381.399L439.069 482.94C439.069 482.94 320.339 460.294 360.86 420.966C370.477 372.349 392.385 315.155 392.385 315.155C433.789 254.131 439.461 275.167 491.859 258.21C532.672 245.002 520.083 196.971 516.586 185.932C516.366 185.237 515.656 183.129 514.973 181.111C507.645 180.171 506.159 171.262 501.36 160.43C493.478 142.643 497.58 139.12 504.277 137.106Z"
                fill="url(#paint0_radial_BONEDMI)"
                fillOpacity={0.3}
              />
            </g>
            <g id="Skeleton Back">
              <g id="R12-Left-Back" filter="url(#filter2_d_BONEDMI)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M544.724 427.043C544.705 427.054 544.707 427.052 544.688 427.064C544.082 427.43 503.996 451.698 490.569 475.282C489.131 477.798 490.016 481.022 492.537 482.445C495.062 483.887 498.274 482.997 499.711 480.481C512.22 458.503 549.957 436.169 550.087 436.092C550.091 436.09 550.089 436.091 550.093 436.088C552.582 434.608 553.395 431.376 551.908 428.877C550.427 426.404 547.214 425.587 544.724 427.043Z"
                  fill="url(#paint1_radial_BONEDMI)"
                />
              </g>
              <g id="R12-Right-Back" filter="url(#filter3_d_BONEDMI)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M577.27 427.043C577.289 427.054 577.287 427.052 577.306 427.064C577.912 427.43 617.998 451.698 631.426 475.282C632.863 477.798 631.979 481.022 629.457 482.445C626.933 483.887 623.721 482.997 622.283 480.481C609.774 458.503 572.038 436.169 571.907 436.092C571.903 436.09 571.905 436.091 571.901 436.088C569.412 434.608 568.6 431.376 570.087 428.877C571.567 426.404 574.781 425.587 577.27 427.043Z"
                  fill="url(#paint2_radial_BONEDMI)"
                />
              </g>
              <g id="Humerus-Left-Back" filter="url(#filter4_d_BONEDMI)">
                <path
                  d="M431.376 283.582C436.108 281.018 440.542 285.685 441.629 290.956C442.546 295.399 444.283 300.639 447.337 306.63C448.177 308.277 448.206 310.234 447.326 311.86C445.11 315.956 442.867 320.101 441.425 324.106C437.864 334.004 433.778 392.944 431.235 429.639C430.869 434.909 430.536 439.72 430.24 443.861C429.736 450.923 422.551 453.952 417.025 449.527L415.405 448.23C412.918 446.239 411.578 443.151 411.822 439.975C413.578 417.15 420.563 324.312 419.464 306.565C418.788 295.656 424.308 287.413 431.376 283.582Z"
                  fill="url(#paint3_radial_BONEDMI)"
                />
              </g>
              <g id="Humerus-Right-Back" filter="url(#filter5_d_BONEDMI)">
                <path
                  d="M690.619 283.583C685.887 281.018 681.453 285.686 680.366 290.956C679.449 295.4 677.712 300.64 674.657 306.631C673.818 308.277 673.789 310.234 674.668 311.86C676.885 315.956 679.127 320.101 680.57 324.106C684.131 334.004 688.216 392.944 690.76 429.639C691.125 434.909 691.459 439.72 691.755 443.861C692.259 450.923 699.443 453.952 704.97 449.527L706.59 448.23C709.077 446.239 710.417 443.151 710.172 439.975C708.417 417.15 701.431 324.312 702.531 306.565C703.207 295.656 697.687 287.413 690.619 283.583Z"
                  fill="url(#paint4_radial_BONEDMI)"
                />
              </g>
              <g id="Skull-Back">
                <g id="Vector" filter="url(#filter6_d_BONEDMI)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M560.182 58.2078C590.847 58.2078 615.744 83.2338 615.744 114.08C615.744 130.104 609.009 158.079 598.225 168.264C593.556 144.79 578.281 114.08 560.182 114.08V58.2078Z"
                    fill="url(#paint5_radial_BONEDMI)"
                  />
                </g>
                <g id="Vector_2" filter="url(#filter7_d_BONEDMI)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M560.17 58.2078C529.504 58.2078 504.608 83.2338 504.608 114.08C504.608 130.104 511.343 158.079 522.126 168.264C526.796 144.79 542.071 114.08 560.17 114.08V58.2078Z"
                    fill="url(#paint6_radial_BONEDMI)"
                  />
                </g>
                <g id="Vector_3" filter="url(#filter8_d_BONEDMI)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M522.129 168.265C526.849 144.506 541.479 112.864 559.772 112.864C578.062 112.864 593.506 144.492 598.226 168.251C588.18 177.774 574.644 169.415 559.772 169.415C544.899 169.415 532.175 177.788 522.129 168.265Z"
                    fill="url(#paint7_radial_BONEDMI)"
                  />
                </g>
              </g>
              <g id="R8-Left-Back" filter="url(#filter9_d_BONEDMI)">
                <path
                  d="M516.997 361.448C515.646 365.983 514.162 370.685 512.546 375.556C528.354 366.842 542.957 361.245 543.148 361.172L543.164 361.166C545.856 360.12 547.206 357.08 546.178 354.373C545.151 351.664 542.126 350.288 539.428 351.325L539.421 351.328C539.354 351.354 529.501 355.176 516.997 361.448Z"
                  fill="url(#paint8_radial_BONEDMI)"
                />
                <path
                  d="M472.891 392.235C476.089 388.446 480.099 384.771 484.557 381.281C486.605 384.663 488.651 387.56 490.687 389.771C490.298 390.08 489.914 390.39 489.534 390.702C484.406 394.907 480.046 399.367 477.343 403.985C475.711 406.779 474.774 409.641 474.819 412.515C471.661 416.61 469.373 420.889 468.245 425.288C465.615 421.269 464.402 417.205 464.261 413.18C464.013 406.107 467.228 398.955 472.891 392.235Z"
                  fill="url(#paint9_radial_BONEDMI)"
                />
              </g>
              <g id="R8-Right-Back" filter="url(#filter10_d_BONEDMI)">
                <path
                  d="M604.998 361.448C606.349 365.983 607.833 370.685 609.449 375.556C593.641 366.842 579.037 361.245 578.846 361.172L578.831 361.166C576.139 360.12 574.789 357.08 575.817 354.373C576.843 351.664 579.869 350.288 582.567 351.325L582.574 351.328C582.641 351.354 592.493 355.176 604.998 361.448Z"
                  fill="url(#paint10_radial_BONEDMI)"
                />
                <path
                  d="M649.104 392.235C645.906 388.446 641.896 384.771 637.438 381.281C635.39 384.663 633.344 387.56 631.308 389.771C631.696 390.08 632.081 390.39 632.461 390.702C637.589 394.907 641.949 399.367 644.652 403.985C646.284 406.779 647.221 409.641 647.176 412.515C650.334 416.61 652.622 420.889 653.75 425.288C656.379 421.269 657.592 417.205 657.734 413.18C657.982 406.107 654.767 398.955 649.104 392.235Z"
                  fill="url(#paint11_radial_BONEDMI)"
                />
              </g>
              <g id="R9-Left-Back" filter="url(#filter11_d_BONEDMI)">
                <path
                  d="M507.65 387.24C503.956 393.708 500.141 395.461 496.262 393.962C492.865 396.155 489.584 398.471 486.546 400.894C470.427 413.746 461.443 429.594 472.037 445.789C472.799 441.203 474.932 436.67 478.105 432.264C477.525 423.82 484.42 415.955 493.17 408.974C513.694 392.592 546.007 381.447 546.201 381.38L546.211 381.377C548.948 380.424 550.391 377.463 549.43 374.753C548.47 372.041 545.464 370.627 542.721 371.574L542.717 371.575C542.66 371.595 525.437 377.576 507.65 387.24Z"
                  fill="url(#paint12_radial_BONEDMI)"
                />
              </g>
              <g id="R9-Right-Back" filter="url(#filter12_d_BONEDMI)">
                <path
                  d="M614.345 387.24C618.039 393.708 621.854 395.461 625.733 393.962C629.13 396.155 632.411 398.471 635.448 400.894C651.567 413.746 660.551 429.594 649.957 445.788C649.196 441.203 647.062 436.67 643.889 432.264C644.469 423.82 637.575 415.955 628.824 408.974C608.301 392.592 575.988 381.447 575.793 381.38L575.783 381.377C573.047 380.424 571.603 377.463 572.565 374.753C573.525 372.041 576.53 370.627 579.273 371.574L579.277 371.575C579.335 371.595 596.558 377.576 614.345 387.24Z"
                  fill="url(#paint13_radial_BONEDMI)"
                />
              </g>
              <g id="R10-Left-Back" filter="url(#filter13_d_BONEDMI)">
                <path
                  d="M545.747 388.725L545.756 388.721C548.478 387.691 551.529 389.054 552.579 391.772C553.629 394.498 552.269 397.58 549.542 398.627L549.541 398.628C549.518 398.637 517.029 411.119 496.799 428.004C488.57 434.865 482.02 442.352 482.483 450.025C479.286 454.304 477.121 458.737 476.332 463.185C468.421 451.864 471.355 440.293 480.173 429.585C498.61 407.186 545.222 388.93 545.728 388.732C545.74 388.727 545.741 388.727 545.747 388.725Z"
                  fill="url(#paint14_radial_BONEDMI)"
                />
              </g>
              <g id="R10-Right-Back" filter="url(#filter14_d_BONEDMI)">
                <path
                  d="M576.248 388.725L576.238 388.721C573.517 387.691 570.466 389.054 569.416 391.772C568.365 394.498 569.726 397.58 572.453 398.627L572.454 398.628C572.477 398.637 604.966 411.119 625.195 428.004C633.425 434.865 639.975 442.352 639.511 450.025C642.708 454.304 644.874 458.737 645.663 463.185C653.573 451.864 650.64 440.293 641.821 429.585C623.384 407.186 576.773 388.93 576.266 388.732C576.255 388.727 576.254 388.727 576.248 388.725Z"
                  fill="url(#paint15_radial_BONEDMI)"
                />
              </g>
              <g id="R11-Left-Back" filter="url(#filter15_d_BONEDMI)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M545.757 410.085C545.745 410.09 545.747 410.089 545.734 410.094C545.328 410.25 511.517 423.234 491.602 440.428C481.876 448.82 475.585 458.387 476.022 467.807C476.156 470.69 478.633 472.912 481.55 472.783C484.468 472.655 486.727 470.212 486.593 467.329C486.283 460.609 491.628 454.274 498.568 448.287C517.38 432.048 549.423 419.889 549.544 419.844C549.548 419.842 549.546 419.843 549.55 419.841C552.27 418.811 553.627 415.783 552.579 413.086C551.531 410.411 548.477 409.071 545.757 410.085Z"
                  fill="url(#paint16_radial_BONEDMI)"
                />
              </g>
              <g id="R11-Right-Back" filter="url(#filter16_d_BONEDMI)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M576.237 410.085C576.25 410.09 576.247 410.089 576.26 410.094C576.666 410.25 610.477 423.234 630.392 440.428C640.119 448.82 646.409 458.387 645.972 467.807C645.838 470.69 643.362 472.912 640.444 472.783C637.527 472.655 635.268 470.212 635.401 467.329C635.712 460.609 630.366 454.274 623.427 448.287C604.615 432.048 572.571 419.889 572.45 419.844C572.447 419.842 572.448 419.843 572.444 419.841C569.724 418.811 568.367 415.783 569.415 413.086C570.464 410.411 573.518 409.071 576.237 410.085Z"
                  fill="url(#paint17_radial_BONEDMI)"
                />
              </g>
              <g id="Scapula-Left-Back" filter="url(#filter17_d_BONEDMI)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M442.575 273.816C442.454 273.996 442.355 274.179 442.269 274.379C441.325 276.593 436.021 291.599 452.931 316.951C471.294 344.46 493.741 431.907 512.279 376.357C530.817 320.788 532.23 286.903 516.262 274.801C509.474 269.665 501.301 271.968 494.149 276.317C483.009 283.086 468.751 282.928 457.789 275.883C451.488 271.838 445.365 269.679 442.575 273.816Z"
                  fill="url(#paint18_radial_BONEDMI)"
                />
              </g>
              <g id="Scapula-Right-Back" filter="url(#filter18_d_BONEDMI)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M679.419 273.816C679.54 273.996 679.64 274.179 679.725 274.379C680.67 276.593 685.974 291.599 669.064 316.951C650.7 344.46 628.253 431.907 609.715 376.357C591.177 320.788 589.764 286.903 605.733 274.801C612.521 269.665 620.694 271.968 627.845 276.317C638.986 283.086 653.243 282.928 664.205 275.883C670.507 271.838 676.63 269.679 679.419 273.816Z"
                  fill="url(#paint19_radial_BONEDMI)"
                />
              </g>
            </g>
          </g>
          <g id="Front">
            <g id="Skeleton Shape front" filter="url(#filter19_f_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M210.851 139.773H237.021C237.139 165.346 236.94 190.88 236.604 216.362L241.496 216.355C245.253 216.349 248.304 219.39 248.31 223.147C248.317 226.904 245.277 229.954 241.521 229.959L236.413 229.967L236.384 231.858L241.496 231.851C245.253 231.845 248.304 234.886 248.31 238.643C248.314 240.589 247.5 242.345 246.192 243.587C247.494 244.824 248.307 246.57 248.31 248.507C248.312 249.808 247.95 251.023 247.318 252.057C249.857 253.041 251.658 255.505 251.661 258.392C251.662 259.039 251.573 259.666 251.404 260.259C254.775 260.9 258.551 261.863 262.505 263.308C272.295 266.886 283.14 273.428 291.502 285.102C298.351 288.73 304.904 293.594 310.365 300.103L310.372 300.108C316.382 299.829 322.326 298.046 327.537 294.768C334.083 290.651 340.44 288.483 343.187 292.979C343.187 292.979 351.15 308.255 332.477 335.676C328.949 340.857 325.272 348.17 321.503 356.25C323.034 358.904 324.099 361.855 324.432 365.102C324.9 369.673 323.854 374.207 321.512 378.607C323.048 381.456 324.109 384.571 324.436 387.942C324.884 392.56 323.902 397.14 321.595 401.573C323.092 404.505 324.122 407.675 324.44 411.068C324.989 416.924 323.348 422.719 319.598 428.216C317.481 431.319 313.249 432.118 310.146 430.001C307.042 427.884 306.243 423.652 308.36 420.549C310.575 417.301 311.109 414.619 310.895 412.338C310.67 409.936 309.541 407.238 307.187 404.228C305.607 402.208 303.601 400.206 301.252 398.238C291.226 415.127 281.214 421.555 272.127 394.868C270.303 389.513 268.643 384.36 267.145 379.409C262.092 377.351 257.249 375.575 253.013 374.115C252.131 373.811 251.277 373.521 250.455 373.246C249.695 373.763 248.819 374.134 247.857 374.311L247.696 374.34C250.397 374.768 252.684 376.813 253.284 379.648C254.063 383.323 251.715 386.934 248.039 387.714C243.47 388.685 238.902 389.392 234.337 389.824C234.337 391.213 234.337 392.603 234.338 393.992C237.934 393.607 241.532 393.012 245.135 392.198C248.8 391.371 252.44 393.671 253.266 397.335C254.091 401 251.79 404.641 248.125 405.468C243.534 406.505 238.951 407.231 234.378 407.659C234.391 410.033 234.406 412.406 234.424 414.779L234.425 414.997C238.005 414.617 241.597 414.039 245.202 413.263C248.875 412.473 252.492 414.81 253.28 418.482C254.069 422.155 251.731 425.773 248.058 426.563C243.559 427.531 239.067 428.228 234.585 428.653C234.608 430.144 234.633 431.634 234.659 433.124L246.623 433.106C250.38 433.101 253.428 436.142 253.432 439.898C253.436 443.655 250.393 446.705 246.637 446.711L234.939 446.728C234.987 448.768 235.037 450.808 235.088 452.848L246.623 452.831C250.38 452.825 253.428 455.866 253.432 459.623C253.436 463.379 250.393 466.429 246.637 466.435L235.46 466.451C235.506 468.021 235.552 469.59 235.599 471.159L246.623 471.143C250.38 471.137 253.428 474.178 253.432 477.935C253.436 481.692 250.394 484.741 246.637 484.747L236.019 484.763L236.11 487.636L246.623 487.62C250.38 487.615 253.428 490.656 253.432 494.412C253.436 498.169 250.393 501.219 246.637 501.225L236.543 501.24C236.6 503.043 236.657 504.847 236.713 506.649L249.042 506.631C252.799 506.625 255.846 509.666 255.849 513.423C255.851 517.18 252.808 520.23 249.052 520.235L237.123 520.253C237.178 522.131 237.231 524.009 237.283 525.886L249.042 525.868C252.799 525.862 255.846 528.903 255.849 532.66C255.852 536.417 252.808 539.467 249.052 539.472L237.631 539.489C237.658 540.655 237.684 541.821 237.71 542.986C240.809 542.428 243.914 541.668 247.027 540.698C250.614 539.579 254.426 541.58 255.542 545.167C256.657 548.753 254.654 552.567 251.066 553.685C246.686 555.051 242.319 556.06 237.969 556.734C237.988 557.949 238.006 559.163 238.023 560.378C241.018 559.825 244.018 559.084 247.027 558.146C250.614 557.028 254.426 559.029 255.542 562.615C256.657 566.201 254.654 570.015 251.066 571.134C246.748 572.48 242.444 573.48 238.155 574.153C238.16 575.063 238.164 575.972 238.168 576.882C241.114 576.332 244.067 575.6 247.027 574.677C250.614 573.559 254.426 575.56 255.542 579.146C256.657 582.732 254.654 586.546 251.066 587.665C246.745 589.012 242.438 590.012 238.147 590.686C238.144 591.161 238.14 591.637 238.136 592.112C241.094 591.562 244.057 590.828 247.027 589.902C250.614 588.784 254.426 590.785 255.542 594.371C256.657 597.957 254.654 601.771 251.066 602.89C246.678 604.258 242.303 605.268 237.946 605.942C237.931 606.679 237.915 607.415 237.899 608.152C238.063 608.104 238.226 608.056 238.39 608.006C238.492 607.975 238.595 607.944 238.697 607.912C242.287 606.802 246.095 608.811 247.203 612.399C248.31 615.988 246.298 619.798 242.709 620.908C240.965 621.448 239.225 621.906 237.488 622.285C237.423 624.089 237.352 625.892 237.275 627.694C237.819 628.363 238.245 629.146 238.515 630.02C239.646 633.684 237.592 637.574 233.927 638.708C227.421 640.721 221.006 640.55 214.859 638.766C211.176 637.697 209.059 633.844 210.131 630.161C210.244 629.771 210.389 629.399 210.56 629.047C210.408 626.713 210.268 624.379 210.139 622.044C208.78 621.735 207.425 621.383 206.075 620.991C202.468 619.945 200.394 616.172 201.444 612.564C202.457 609.082 206.007 607.026 209.496 607.828C209.471 607.117 209.446 606.406 209.423 605.695C205.501 605.038 201.598 604.134 197.713 602.998C194.108 601.944 192.042 598.167 193.099 594.561C194.156 590.955 197.935 588.886 201.54 589.94C204.054 590.675 206.567 591.296 209.079 591.8C209.071 591.336 209.064 590.872 209.057 590.408C205.259 589.757 201.477 588.874 197.713 587.773C194.108 586.719 192.042 582.942 193.099 579.336C194.156 575.73 197.935 573.661 201.54 574.715C204.009 575.437 206.477 576.049 208.945 576.548C208.944 575.651 208.943 574.754 208.944 573.857C205.184 573.208 201.44 572.332 197.713 571.242C194.108 570.188 192.042 566.411 193.099 562.805C194.156 559.199 197.935 557.13 201.54 558.184C204.041 558.916 206.541 559.534 209.041 560.036C209.056 558.836 209.073 557.635 209.091 556.434C205.281 555.782 201.488 554.898 197.713 553.794C194.108 552.74 192.042 548.962 193.099 545.357C194.156 541.751 197.935 539.682 201.54 540.736C204.148 541.498 206.754 542.138 209.361 542.651C209.386 541.611 209.412 540.571 209.438 539.531L199.632 539.546C195.875 539.551 192.827 536.51 192.825 532.754C192.822 528.997 195.865 525.947 199.622 525.942L209.828 525.926C209.888 524.049 209.949 522.171 210.012 520.293L199.631 520.309C195.875 520.314 192.827 517.273 192.825 513.517C192.822 509.76 195.865 506.71 199.622 506.704L210.492 506.688C210.558 504.885 210.625 503.082 210.693 501.278L202.05 501.291C198.294 501.297 195.245 498.256 195.241 494.499C195.238 490.742 198.28 487.692 202.037 487.687L211.208 487.673L211.317 484.8L202.051 484.813C198.294 484.819 195.245 481.778 195.242 478.021C195.238 474.265 198.28 471.215 202.037 471.209L211.821 471.195C211.877 469.625 211.933 468.056 211.987 466.486L202.05 466.501C198.294 466.507 195.245 463.466 195.241 459.709C195.238 455.952 198.28 452.902 202.037 452.897L212.431 452.881C212.493 450.842 212.552 448.801 212.608 446.761L202.05 446.777C198.294 446.782 195.245 443.742 195.241 439.985C195.238 436.228 198.28 433.178 202.037 433.173L212.934 433.156C212.965 431.636 212.993 430.115 213.02 428.595C208.871 428.176 204.732 427.52 200.604 426.628C196.933 425.835 194.601 422.215 195.396 418.543C196.191 414.871 199.812 412.538 203.483 413.331C206.711 414.028 209.945 414.561 213.188 414.93L213.198 413.404C213.209 411.454 213.218 409.504 213.225 407.554C209.009 407.123 204.804 406.452 200.61 405.55C196.938 404.76 194.603 401.142 195.394 397.469C196.186 393.797 199.805 391.46 203.477 392.25C206.729 392.949 209.979 393.49 213.229 393.869C213.226 392.513 213.222 391.158 213.216 389.802C208.989 389.383 204.769 388.707 200.556 387.765C196.891 386.945 194.585 383.309 195.406 379.643C196.033 376.846 198.299 374.839 200.966 374.409C200.874 374.391 200.782 374.372 200.689 374.354C199.582 374.129 198.593 373.647 197.771 372.983C196.709 373.335 195.59 373.712 194.423 374.115C189.848 375.691 184.567 377.637 179.077 379.907C177.619 384.705 176.009 389.692 174.247 394.868C165.267 421.237 155.386 415.276 145.48 398.838C143.432 400.612 141.668 402.413 140.249 404.228C137.895 407.238 136.766 409.936 136.541 412.338C136.327 414.619 136.861 417.301 139.076 420.549C141.193 423.652 140.394 427.884 137.29 430.001C134.187 432.119 129.955 431.319 127.838 428.216C124.088 422.719 122.447 416.925 122.996 411.068C123.314 407.676 124.344 404.505 125.84 401.574C123.533 397.14 122.551 392.56 122.999 387.942C123.326 384.571 124.387 381.456 125.923 378.607C123.581 374.207 122.535 369.673 123.003 365.102C123.293 362.278 124.136 359.677 125.359 357.301C121.418 348.805 117.577 341.081 113.896 335.676C95.2236 308.255 103.186 292.979 103.186 292.979C105.933 288.483 112.29 290.651 118.836 294.768C124.338 298.229 130.657 300.023 137.009 300.141L137.07 300.104C142.532 293.594 149.085 288.729 155.935 285.101C164.296 273.427 175.141 266.886 184.931 263.308C189.344 261.695 193.536 260.682 197.191 260.049C197.07 259.543 197.006 259.016 197.005 258.473C197.001 255.575 198.81 253.098 201.362 252.114C200.732 251.084 200.367 249.874 200.365 248.578C200.361 246.633 201.175 244.876 202.483 243.635C201.182 242.398 200.369 240.651 200.365 238.714C200.359 234.957 203.399 231.908 207.155 231.902L210.552 231.897L210.526 230.005L207.18 230.01C203.423 230.016 200.372 226.975 200.365 223.218C200.359 219.462 203.399 216.412 207.155 216.406L210.373 216.401C210.135 190.855 210.197 165.307 210.851 139.773ZM234.37 376.148C234.499 376.134 234.627 376.12 234.756 376.106L234.551 376.124L234.37 376.139L234.37 376.148ZM242.154 356.449C242.153 356.449 242.151 356.448 240.727 361.706L242.151 356.448C239.101 355.622 235.974 357.008 234.473 359.626C234.485 358.152 234.497 356.678 234.511 355.204L246.637 355.186C247.966 355.184 249.205 354.801 250.252 354.141C251.23 354.415 252.254 354.708 253.319 355.019C255.791 355.742 258.469 356.561 261.274 357.471C261.692 359.306 262.139 361.178 262.616 363.086C260.812 362.428 259.081 361.816 257.446 361.253C252.967 359.709 249.167 358.515 246.479 357.704C245.134 357.298 244.065 356.988 243.326 356.777C242.957 356.672 242.67 356.591 242.472 356.536L242.327 356.496L242.242 356.473L242.179 356.456L242.154 356.449ZM205.285 356.448L206.688 361.629C205.285 356.448 205.283 356.449 205.281 356.449L205.257 356.456L205.194 356.473C205.14 356.488 205.063 356.509 204.964 356.537C204.766 356.592 204.479 356.672 204.109 356.777C203.371 356.988 202.302 357.298 200.957 357.704C198.268 358.515 194.469 359.709 189.99 361.253C188.004 361.937 185.878 362.693 183.649 363.516C184.134 361.589 184.589 359.7 185.013 357.847C188.236 356.784 191.309 355.84 194.116 355.019C195.478 354.621 196.774 354.253 197.99 353.915C199.124 354.757 200.529 355.255 202.05 355.252L212.886 355.236C212.907 356.69 212.927 358.143 212.946 359.597C211.439 356.997 208.324 355.626 205.285 356.448ZM197.387 273.862C197.675 274.132 197.987 274.378 198.319 274.595C196.713 274.663 194.985 274.768 193.156 274.921C194.619 274.496 196.036 274.147 197.387 273.862ZM250.167 274.644C250.451 274.471 250.722 274.277 250.976 274.065C252.044 274.309 253.149 274.592 254.281 274.921C252.844 274.801 251.469 274.71 250.167 274.644ZM260.836 289.406C255.556 288.569 250.707 288.231 246.814 288.128C244.03 288.054 241.764 288.1 240.215 288.163C239.441 288.195 238.848 288.23 238.461 288.257C238.268 288.27 238.127 288.281 238.04 288.288C237.996 288.292 237.967 288.294 237.951 288.296L237.948 288.296L237.943 288.296L237.94 288.297L237.939 288.297C237.075 288.376 236.234 288.291 235.447 288.066L235.42 289.705C236.195 289.656 237.243 289.595 238.523 289.534C241.418 289.395 245.512 289.252 250.341 289.235C253.539 289.223 257.084 289.267 260.836 289.406ZM197.096 289.235C193.897 289.223 190.351 289.267 186.599 289.406C191.88 288.569 196.729 288.231 200.622 288.128C203.405 288.054 205.672 288.1 207.221 288.163C207.995 288.195 208.587 288.23 208.974 288.257C209.167 288.27 209.309 288.281 209.396 288.288C209.439 288.292 209.469 288.294 209.484 288.296L209.488 288.296L209.492 288.296L209.495 288.297L209.496 288.297C210.216 288.363 210.921 288.315 211.591 288.167L211.623 289.681C210.899 289.637 209.988 289.585 208.914 289.534C206.019 289.395 201.925 289.252 197.096 289.235ZM260.684 303.014C257.072 302.875 253.623 302.828 250.477 302.838C249.385 303.59 248.062 304.03 246.637 304.032L235.182 304.049L235.173 304.614C235.837 304.394 236.546 304.274 237.283 304.27L237.297 307.459C237.283 304.27 237.285 304.27 237.287 304.27L237.312 304.27L237.378 304.27L237.516 304.27L237.616 304.27C237.82 304.271 238.116 304.272 238.497 304.276C239.258 304.284 240.358 304.301 241.742 304.338C244.508 304.412 248.419 304.566 253.035 304.89C255.11 305.035 257.339 305.215 259.678 305.438C259.988 304.599 260.324 303.791 260.684 303.014ZM234.92 321.067L246.637 321.05C248.802 321.047 250.73 320.032 251.975 318.453L252.085 318.461C253.661 318.571 255.319 318.702 257.038 318.856C256.897 320.903 256.841 323.054 256.87 325.308L256.621 325.256C252.139 324.319 248.338 323.63 245.649 323.174C244.304 322.946 243.235 322.776 242.496 322.662C242.126 322.605 241.839 322.562 241.641 322.533C241.542 322.519 241.465 322.507 241.411 322.5L241.348 322.491L241.324 322.487C241.322 322.487 241.321 322.487 241.011 324.683L241.32 322.487C238.984 322.158 236.759 323.057 235.296 324.692L234.869 324.692C234.886 323.484 234.903 322.276 234.92 321.067ZM206.431 324.735L206.115 322.487C208.467 322.155 210.707 323.069 212.169 324.726L212.356 324.726C212.332 323.518 212.308 322.309 212.284 321.101L202.05 321.116C199.813 321.119 197.827 320.042 196.586 318.377C196.181 318.404 195.769 318.431 195.352 318.461C193.454 318.593 191.44 318.756 189.342 318.953C189.482 321.039 189.535 323.233 189.5 325.534C189.945 325.439 190.383 325.346 190.815 325.256C195.296 324.319 199.097 323.63 201.786 323.174C203.131 322.946 204.2 322.776 204.939 322.662C205.309 322.605 205.596 322.562 205.794 322.533L205.874 322.521L206.024 322.5L206.087 322.491L206.111 322.487C206.113 322.487 206.114 322.487 206.431 324.735ZM202.05 338.345C200.878 338.347 199.775 338.052 198.812 337.532C197.224 337.833 195.475 338.18 193.6 338.572C191.942 338.919 190.192 339.3 188.373 339.717C188.244 340.684 188.103 341.664 187.951 342.658C188.753 342.417 189.536 342.185 190.298 341.962C194.779 340.652 198.579 339.652 201.268 338.978C202.307 338.718 203.181 338.506 203.865 338.343L202.05 338.345ZM206.415 341.642C205.986 339.702 205.782 338.779 205.684 338.34H205.686L206.415 341.642ZM241.032 341.59C241.471 339.603 241.671 338.698 241.763 338.286H241.761L241.032 341.59ZM212.612 338.33L209.75 338.334C210.911 338.834 211.923 339.653 212.654 340.705C212.64 339.913 212.626 339.122 212.612 338.33ZM237.784 338.292L234.69 338.297C234.68 339.16 234.67 340.024 234.659 340.887C235.417 339.716 236.515 338.815 237.784 338.292ZM246.637 338.279L243.323 338.284C244.039 338.454 244.999 338.685 246.167 338.978C248.856 339.652 252.657 340.652 257.137 341.962C257.543 342.08 257.955 342.202 258.372 342.326C258.226 341.36 258.091 340.408 257.967 339.469C256.539 339.148 255.157 338.849 253.835 338.572C252.267 338.244 250.786 337.948 249.415 337.683C248.567 338.065 247.627 338.278 246.637 338.279ZM210.14 307.5C210.153 304.27 210.152 304.27 210.15 304.27L210.124 304.27L210.058 304.27C210.003 304.27 209.923 304.27 209.821 304.27C209.741 304.271 209.647 304.271 209.54 304.272L209.301 304.273C209.191 304.274 209.07 304.275 208.94 304.276C208.179 304.284 207.079 304.301 205.695 304.338C202.928 304.412 199.017 304.566 194.402 304.89C192.025 305.056 189.447 305.268 186.732 305.538C186.417 304.678 186.076 303.851 185.709 303.057C189.735 302.883 193.577 302.826 197.047 302.839C197.404 302.84 197.757 302.842 198.105 302.845C199.218 303.636 200.58 304.101 202.05 304.099L211.931 304.084L211.94 304.516C211.371 304.358 210.772 304.273 210.154 304.27L210.14 307.5ZM310.789 388.494C310.527 387.059 309.902 385.513 308.814 383.849C308.463 384.578 308.112 385.301 307.76 386.018C308.802 386.825 309.813 387.651 310.789 388.494ZM138.909 386.62C138.136 387.235 137.381 387.86 136.646 388.495C136.856 387.344 137.3 386.12 138.03 384.822C138.323 385.426 138.616 386.025 138.909 386.62Z"
                fill="#EEEEEE"
              />
            </g>
            <g id="Body Front" filter="url(#filter20_f_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M165.847 132.833C163.953 126.284 162.929 119.29 162.929 112.026C162.929 75.1191 189.377 50.7297 221.953 50.7297C254.53 50.7297 280.978 75.1191 280.978 112.026C280.978 119.042 280.023 125.808 278.252 132.16C278.37 132.187 278.489 132.216 278.608 132.246C286.47 134.274 292.35 136.543 283.66 156.156C278.866 166.977 277.378 175.877 270.072 176.834C269.442 178.66 268.825 180.453 268.679 180.898C265.603 190.263 251.323 240.397 293.161 253.937C345.558 270.894 351.23 249.858 392.635 310.882C392.635 310.882 388.393 344.035 412.969 404.94C453.49 444.268 352.605 478.667 352.605 478.667L352.605 377.125C352.605 377.125 319.645 520.625 342.973 597.36C366.301 674.094 345.103 731.683 345.951 736.408C346.578 739.901 262.333 742.343 223.295 739.678C184.256 742.343 100.011 740.648 100.638 737.154C101.486 732.43 78.7922 674.094 102.12 597.36C125.449 520.625 93.9845 377.125 93.9845 377.125L100.638 478.667C100.638 478.667 -18.0914 456.021 22.4296 416.693C32.0462 368.076 53.954 310.882 53.954 310.882C95.3582 249.858 101.031 270.894 153.428 253.937C194.241 240.729 181.653 192.698 178.155 181.659C177.935 180.964 177.225 178.856 176.542 176.838C169.214 175.898 167.728 166.989 162.929 156.156C155.048 138.37 159.15 134.847 165.847 132.833Z"
                fill="url(#paint20_radial_BONEDMI)"
                fillOpacity={0.3}
              />
            </g>
            <g id="Humerus-Right-Front">
              <g id="Vector_4" filter="url(#filter21_d_BONEDMI)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M73.7229 440.998C73.7229 440.998 82.9993 322.963 81.7456 302.726C80.4918 282.488 100.592 271.44 112.288 280.765C123.983 290.07 108.789 306.037 103.673 320.24C98.5564 334.463 92.3538 450.107 91.2175 455.005"
                  fill="url(#paint21_radial_BONEDMI)"
                />
              </g>
            </g>
            <g id="Humerus-Left-Front">
              <g id="Vector_5" filter="url(#filter22_d_BONEDMI)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M372.65 440.997C372.65 440.997 363.374 322.963 364.628 302.726C365.882 282.488 345.782 271.44 334.086 280.765C322.39 290.07 337.585 306.037 342.7 320.24C347.817 334.463 354.019 450.107 355.156 455.004"
                  fill="url(#paint22_radial_BONEDMI)"
                />
              </g>
            </g>
            <g id="Skull-Front">
              <g id="Vector_6" filter="url(#filter23_d_BONEDMI)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M221.811 200.653C223.12 200.992 224.478 200.996 225.787 200.658C234.638 198.376 255.992 190.326 257.956 165.648C258.217 162.38 261.52 159.986 264.557 161.222C266.878 162.168 267.986 164.859 267.161 167.226C265.364 172.386 262.65 181.718 262.022 192.453C261.063 208.839 258.448 209.231 247.597 216.248C237.094 223.024 237.116 223.308 223.802 223.221C210.489 223.308 210.51 223.024 200.008 216.248C189.156 209.231 186.541 208.839 185.583 192.453C184.955 181.718 182.241 172.386 180.444 167.226C179.619 164.859 180.727 162.168 183.049 161.222C186.085 159.986 189.389 162.365 189.649 165.633C190.331 174.224 193.36 180.81 197.393 185.829C204.956 195.221 216.038 199.156 221.811 200.653Z"
                  fill="url(#paint23_radial_BONEDMI)"
                />
              </g>
              <g id="Vector_7" filter="url(#filter24_d_BONEDMI)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M218.241 181.177C219.321 184.971 225.083 184.97 226.16 181.176C226.699 179.28 227.805 179.799 229.765 179.603L233.856 179.193C239.279 178.65 244.069 182.717 244.412 188.156L244.733 193.24C244.797 194.255 244.741 195.293 244.311 196.214C241.395 202.461 231.074 204.521 222.914 204.076C222.445 204.05 221.977 204.05 221.508 204.076C213.304 204.524 202.981 202.436 200.146 196.101C199.764 195.248 199.697 194.296 199.736 193.362C199.815 191.442 199.904 189.622 199.994 187.954C200.285 182.587 205.022 178.638 210.369 179.175L214.634 179.602C216.596 179.799 217.702 179.28 218.241 181.177Z"
                  fill="url(#paint24_radial_BONEDMI)"
                />
              </g>
              <g id="Group">
                <g id="Vector_8" filter="url(#filter25_d_BONEDMI)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M166.169 110.7C165.515 88.343 183.056 58.7955 221.973 57.1395C257.839 57.1177 278.518 85.75 277.799 110.7C277.581 117.563 274.726 123.076 274.77 129.308C274.966 159.008 269.344 177.072 258.253 173.303C244.776 168.736 244.546 178.877 244.583 180.377C244.586 180.502 244.6 180.627 244.607 180.753C245.227 191.031 203.055 190.702 199.582 181.413C199.377 180.866 199.403 180.269 199.374 179.685C199.24 176.984 197.83 169.196 185.692 173.303C174.601 177.072 169.001 159.008 169.197 129.308C169.219 123.076 166.365 117.563 166.169 110.7Z"
                    fill="url(#paint25_radial_BONEDMI)"
                  />
                </g>
              </g>
              <g id="Group_2">
                <path
                  id="Vector_9"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M202.953 115.837C199.996 115.335 196.98 117.537 194.015 117.991C187.337 119.013 176.225 122.222 178.806 132.207C182.445 146.261 182.837 155.74 202.361 148.964C221.906 142.187 213.626 126.106 207.983 119.33C206.04 117.014 204.344 116.073 202.953 115.837Z"
                  fill="#C4C4C4"
                />
              </g>
              <g id="Group_3">
                <path
                  id="Vector_10"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M242.069 115.837C245.027 115.335 248.043 117.537 251.008 117.991C257.686 119.013 268.798 122.222 266.217 132.207C262.578 146.261 262.186 155.74 242.662 148.964C223.116 142.187 231.396 126.106 237.04 119.33C238.982 117.014 240.678 116.073 242.069 115.837Z"
                  fill="#C4C4C4"
                />
              </g>
              <g id="Group_4">
                <path
                  id="Vector_11"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M218.337 140.76C219.173 138.31 221.207 140.805 221.168 143.394C221.06 150.507 220.854 164.536 220.903 164.779C220.947 165.106 209.747 169.116 212.318 158.548C214.889 147.958 216.937 150.202 217.765 143.468C217.911 142.309 218.109 141.426 218.337 140.76Z"
                  fill="#C4C4C4"
                />
              </g>
              <g id="Group_5">
                <path
                  id="Vector_12"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M226.112 140.76C225.275 138.31 223.241 140.805 223.28 143.394C223.388 150.507 223.594 164.536 223.545 164.779C223.502 165.106 234.702 169.116 232.13 158.548C229.559 147.958 227.511 150.202 226.683 143.468C226.537 142.309 226.339 141.426 226.112 140.76Z"
                  fill="#C4C4C4"
                />
              </g>
              <g id="Group_6">
                <g id="Vector_13" filter="url(#filter26_d_BONEDMI)">
                  <path
                    d="M198.789 180.951C197.277 170.088 205.588 167.669 202.287 160.297"
                    stroke="url(#paint26_linear_BONEDMI)"
                    strokeWidth={1.14909}
                    shapeRendering="crispEdges"
                  />
                </g>
              </g>
              <g id="Group_7">
                <g id="Vector_14" filter="url(#filter27_d_BONEDMI)">
                  <path
                    d="M194.36 200.614C197.35 192.637 192.798 182.496 191.467 172.666"
                    stroke="url(#paint27_linear_BONEDMI)"
                    strokeWidth={1.14909}
                    shapeRendering="crispEdges"
                  />
                </g>
              </g>
              <g id="Group_8">
                <g id="Vector_15" filter="url(#filter28_d_BONEDMI)">
                  <path
                    d="M253.111 200.902C250.12 192.925 254.673 182.784 256.004 172.955"
                    stroke="url(#paint28_linear_BONEDMI)"
                    strokeWidth={1.14909}
                    shapeRendering="crispEdges"
                  />
                </g>
              </g>
              <g id="Group_9">
                <g id="Vector_16" filter="url(#filter29_d_BONEDMI)">
                  <path
                    d="M245.208 180.926C246.719 170.063 238.409 167.644 241.71 160.272"
                    stroke="url(#paint29_linear_BONEDMI)"
                    strokeWidth={1.14909}
                    shapeRendering="crispEdges"
                  />
                </g>
              </g>
            </g>
            <g id="Group 70">
              <path
                id="Vector_17"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M202.109 404.786C186.566 414.838 169.883 421.678 157.229 429.862C147.983 435.827 140.814 442.58 137.195 451.324C134.814 457.074 135.114 464.156 137.383 470.481C138.176 472.71 140.646 473.871 142.862 473.08C145.108 472.284 146.256 469.806 145.463 467.576C143.933 463.311 143.525 458.511 145.145 454.606C148.927 445.436 157.7 439.211 168.32 433.203C179.927 426.602 192.361 420.771 205.392 412.358C207.385 411.069 209.338 408.069 208.076 406.082C206.779 404.075 204.102 403.497 202.109 404.786Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_18"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M207.536 380.392C189.819 391.832 169.821 400.817 155.072 410.692C144.356 417.878 136.355 425.654 133.165 434.783C132.387 437.012 133.601 439.475 135.806 440.251C138.045 441.023 140.528 439.841 141.306 437.612C143.945 429.993 150.909 423.825 159.822 417.839C174.535 407.969 194.537 399.012 212.188 387.61C214.159 386.329 214.738 383.669 213.443 381.675C212.183 379.677 209.507 379.11 207.536 380.392Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_19"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M208.228 363.102C190.628 374.464 168.934 380.203 153.178 388.173C141.309 394.159 132.69 401.494 130.06 412.261C129.467 414.556 130.914 416.878 133.204 417.444C135.494 418.011 137.849 416.616 138.404 414.297C140.479 405.849 147.72 400.546 157.041 395.839C173.066 387.744 195.023 381.826 212.889 370.312C214.865 369.028 215.445 366.361 214.147 364.362C212.888 362.386 210.204 361.818 208.228 363.102Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_20"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M207.001 347.226C192.545 347.92 169.631 352.537 152.322 361.474C139.904 367.911 130.43 376.631 127.824 387.309C127.231 389.604 128.678 391.925 130.968 392.492C133.258 393.058 135.613 391.663 136.168 389.345C138.229 380.783 146.312 374.271 156.255 369.132C172.457 360.753 193.877 356.462 207.409 355.812C209.786 355.677 211.597 353.668 211.501 351.298C211.37 348.933 209.346 347.124 207.001 347.226Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_21"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M209.38 327.537C194.924 328.231 168.025 333.924 150.716 342.862C138.298 349.298 128.824 358.019 126.218 368.696C125.625 370.992 127.072 373.313 129.362 373.88C131.652 374.446 134.007 373.051 134.562 370.733C136.623 362.171 144.706 355.658 154.648 350.519C170.851 342.14 196.256 336.773 209.788 336.123C212.165 335.988 213.976 333.979 213.88 331.609C213.749 329.244 211.725 327.435 209.38 327.537Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_22"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M212.107 305.095C196.973 305.356 166.839 312.323 150.782 321.638C139.45 328.2 130.808 336.123 127.996 343.703C127.158 345.897 128.378 348.353 130.676 349.158C133.009 349.931 135.543 348.778 136.377 346.556C138.676 340.395 146.11 334.309 155.357 328.966C170.094 320.417 198.392 313.875 212.274 313.635C214.702 313.574 216.673 311.628 216.608 309.275C216.58 306.918 214.539 305.061 212.107 305.095Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_23"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M214.294 293.253C199.887 290.876 178.33 293.675 161.35 299.781C149.37 304.08 139.686 310.142 135.597 316.89C134.392 318.839 135.088 321.395 137.118 322.562C139.186 323.705 141.806 323.043 143.014 321.067C146.35 315.585 154.544 311.065 164.318 307.569C179.901 301.966 199.636 299.255 212.852 301.434C215.167 301.796 217.401 300.281 217.781 298.023C218.196 295.769 216.607 293.642 214.294 293.253Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_24"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M211.25 283.555C198.702 280.045 181.512 280.348 167.036 284.711C156.983 287.768 148.286 292.78 143.031 299.58C141.586 301.469 141.945 304.164 143.829 305.613C145.713 307.061 148.403 306.708 149.848 304.819C154.118 299.278 161.355 295.412 169.531 292.939C182.433 289.055 197.767 288.69 208.925 291.832C211.23 292.454 213.597 291.117 214.225 288.848C214.852 286.555 213.522 284.202 211.25 283.555Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_25"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M211.991 264.261C192.826 257.719 165.946 260.792 154.017 277.52C152.611 279.478 153.15 282.154 155.213 283.492C157.276 284.83 160.056 284.31 161.462 282.352C171.209 268.697 193.304 267.012 208.971 272.365C211.303 273.158 213.904 271.993 214.711 269.763C215.549 267.532 214.353 265.054 211.991 264.261Z"
                fill="#EAEAEA"
              />
            </g>
            <g id="Group 71">
              <path
                id="Vector_26"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M243.738 404.786C259.28 414.838 275.964 421.678 288.618 429.862C297.864 435.827 305.033 442.58 308.652 451.324C311.033 457.074 310.733 464.156 308.464 470.481C307.671 472.71 305.2 473.871 302.985 473.08C300.739 472.284 299.591 469.806 300.384 467.576C301.913 463.311 302.322 458.511 300.702 454.606C296.92 445.436 288.146 439.211 277.527 433.203C265.919 426.602 253.486 420.771 240.455 412.358C238.461 411.069 236.509 408.069 237.771 406.082C239.068 404.075 241.744 403.497 243.738 404.786Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_27"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M238.311 380.392C256.027 391.832 276.026 400.817 290.775 410.692C301.491 417.878 309.492 425.654 312.682 434.783C313.459 437.012 312.246 439.475 310.041 440.251C307.801 441.023 305.318 439.841 304.541 437.612C301.902 429.993 294.938 423.825 286.025 417.839C271.311 407.969 251.309 399.012 233.659 387.61C231.688 386.329 231.109 383.669 232.404 381.675C233.663 379.677 236.34 379.11 238.311 380.392Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_28"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M237.619 363.102C255.218 374.464 276.913 380.203 292.669 388.173C304.538 394.159 313.157 401.494 315.787 412.261C316.38 414.556 314.933 416.878 312.643 417.444C310.353 418.011 307.997 416.616 307.443 414.297C305.367 405.849 298.127 400.546 288.806 395.839C272.781 387.744 250.824 381.826 232.958 370.312C230.982 369.028 230.401 366.361 231.699 364.362C232.959 362.386 235.642 361.818 237.619 363.102Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_29"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M238.846 347.226C253.302 347.92 276.216 352.537 293.525 361.474C305.943 367.911 315.417 376.631 318.023 387.309C318.616 389.604 317.169 391.925 314.879 392.492C312.589 393.058 310.233 391.663 309.679 389.345C307.618 380.783 299.535 374.271 289.592 369.132C273.39 360.753 251.97 356.462 238.437 355.812C236.06 355.677 234.25 353.668 234.346 351.298C234.476 348.933 236.501 347.124 238.846 347.226Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_30"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M236.467 327.537C250.923 328.231 277.822 333.924 295.131 342.862C307.549 349.298 317.023 358.019 319.629 368.696C320.222 370.992 318.775 373.313 316.485 373.88C314.194 374.446 311.839 373.051 311.285 370.733C309.224 362.171 301.141 355.658 291.198 350.519C274.996 342.14 249.591 336.773 236.058 336.123C233.681 335.988 231.871 333.979 231.967 331.609C232.097 329.244 234.121 327.435 236.467 327.537Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_31"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M233.739 305.095C248.874 305.356 279.008 312.323 295.065 321.638C306.396 328.2 315.038 336.123 317.851 343.703C318.688 345.897 317.469 348.353 315.17 349.158C312.838 349.931 310.304 348.778 309.47 346.556C307.171 340.395 299.736 334.309 290.489 328.966C275.753 320.417 247.455 313.875 233.573 313.635C231.144 313.574 229.174 311.628 229.239 309.275C229.267 306.918 231.308 305.061 233.739 305.095Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_32"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M231.552 293.253C245.96 290.876 267.517 293.675 284.497 299.781C296.477 304.08 306.161 310.142 310.249 316.89C311.455 318.839 310.759 321.395 308.729 322.562C306.661 323.705 304.041 323.043 302.832 321.067C299.497 315.585 291.303 311.065 281.529 307.569C265.946 301.966 246.21 299.255 232.995 301.434C230.68 301.796 228.445 300.281 228.066 298.023C227.651 295.769 229.24 293.642 231.552 293.253Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_33"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M234.597 283.555C247.144 280.045 264.334 280.348 278.811 284.711C288.863 287.768 297.561 292.78 302.816 299.58C304.261 301.469 303.902 304.164 302.018 305.613C300.134 307.061 297.443 306.708 295.998 304.819C291.729 299.278 284.492 295.412 276.315 292.939C263.414 289.055 248.08 288.69 236.922 291.832C234.617 292.454 232.25 291.117 231.622 288.848C230.995 286.555 232.324 284.202 234.597 283.555Z"
                fill="#F0F0F0"
              />
              <path
                id="Vector_34"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M233.856 264.261C253.021 257.719 279.9 260.792 291.83 277.52C293.235 279.478 292.697 282.154 290.634 283.492C288.571 284.83 285.79 284.31 284.385 282.352C274.638 268.697 252.543 267.012 236.876 272.365C234.544 273.158 231.943 271.993 231.135 269.763C230.298 267.532 231.494 265.054 233.856 264.261Z"
                fill="#EAEAEA"
              />
            </g>
            <g id="R10-Right-Front" filter="url(#filter30_d_BONEDMI)">
              <path
                d="M169.445 470.699C173.635 469.066 178.095 466.293 182.754 462.056C183.285 461.569 183.855 460.918 184.452 460.125C182.617 464.113 180.874 467.737 179.343 470.666C177.199 474.754 174.804 477.863 172.331 480.143C158.871 492.585 142.058 483.409 137.336 470.148C136.553 467.933 137.685 465.522 139.893 464.74C140.566 464.499 141.264 464.442 141.93 464.543C143.01 465.671 144.171 466.713 145.408 467.647C148.485 475.617 158.474 481.465 166.594 473.953C167.583 473.039 168.534 471.961 169.445 470.699Z"
                fill="url(#paint30_radial_BONEDMI)"
              />
            </g>
            <g id="R10-Left-Front" filter="url(#filter31_d_BONEDMI)">
              <path
                d="M276.402 470.699C272.212 469.066 267.752 466.293 263.093 462.056C262.561 461.569 261.992 460.918 261.394 460.125C263.229 464.113 264.973 467.737 266.503 470.666C268.647 474.754 271.043 477.863 273.516 480.143C286.976 492.585 303.789 483.409 308.511 470.148C309.293 467.933 308.161 465.522 305.954 464.74C305.28 464.499 304.582 464.442 303.917 464.543C302.837 465.671 301.676 466.713 300.439 467.647C297.362 475.617 287.373 481.465 279.252 473.953C278.263 473.039 277.312 471.961 276.402 470.699Z"
                fill="url(#paint31_radial_BONEDMI)"
              />
            </g>
            <g id="R9-Right-Front" filter="url(#filter32_d_BONEDMI)">
              <path
                d="M180.749 449.541C181.785 448.988 182.834 448.384 183.896 447.726C187.233 445.646 190.813 441.321 193.963 436.166C195.634 433.43 197.566 430.036 199.52 426.489C197.18 432.966 193.945 441.483 190.744 448.511C187.866 454.846 184.868 459.995 182.577 462.095C172.733 471.048 163.781 473.459 156.372 472.416C147.513 471.177 140.516 464.834 136.412 457.166C132.311 449.526 131.187 440.664 133.227 434.733C133.329 434.439 133.461 434.162 133.618 433.906C133.881 434.462 134.157 435.015 134.446 435.564C136.196 438.847 138.401 441.971 141.028 444.698C141.492 447.462 142.522 450.391 143.974 453.119C146.841 458.413 151.441 463.06 157.577 463.911C163.06 464.683 169.495 462.37 176.788 455.725C177.983 454.635 179.316 452.394 180.749 449.541Z"
                fill="url(#paint32_radial_BONEDMI)"
              />
            </g>
            <g id="R9-Left-Front" filter="url(#filter33_d_BONEDMI)">
              <path
                d="M265.098 449.541C264.062 448.988 263.013 448.384 261.951 447.726C258.613 445.646 255.033 441.321 251.883 436.166C250.213 433.43 248.281 430.036 246.326 426.489C248.667 432.966 251.902 441.483 255.102 448.511C257.981 454.846 260.978 459.995 263.27 462.095C273.113 471.048 282.066 473.459 289.474 472.416C298.334 471.177 305.331 464.834 309.435 457.166C313.536 449.526 314.66 440.664 312.62 434.733C312.517 434.439 312.386 434.162 312.229 433.906C311.966 434.462 311.69 435.015 311.401 435.564C309.651 438.847 307.446 441.971 304.819 444.698C304.355 447.462 303.325 450.391 301.873 453.119C299.006 458.413 294.406 463.06 288.27 463.911C282.787 464.683 276.352 462.37 269.058 455.725C267.863 454.635 266.531 452.394 265.098 449.541Z"
                fill="url(#paint33_radial_BONEDMI)"
              />
            </g>
            <g id="R8-Right-Front" filter="url(#filter34_d_BONEDMI)">
              <path
                d="M190.462 425.099C197.427 420.337 205.274 411.708 210.856 405.002C208.76 409.116 199.776 426.638 193.957 436.164C190.807 441.319 187.227 445.645 183.889 447.725C172.781 454.608 163.114 455.573 155.176 453.364C145.831 450.78 138.751 443.654 134.44 435.563C130.16 427.438 128.727 418.394 130.248 412.264C130.474 411.334 130.991 410.547 131.678 409.979C133.417 413.583 135.654 417.117 138.363 420.305C138.789 423.867 140.064 427.834 142.03 431.561C145.253 437.624 150.444 443.15 157.453 445.088C163.536 446.783 170.863 445.69 179.393 440.406C181.874 438.878 184.294 435.521 186.616 431.689C187.785 429.782 189.099 427.518 190.462 425.099Z"
                fill="url(#paint34_radial_BONEDMI)"
              />
            </g>
            <g id="R8-Left-Front" filter="url(#filter35_d_BONEDMI)">
              <path
                d="M255.384 425.099C248.42 420.337 240.573 411.708 234.991 405.002C237.087 409.116 246.071 426.638 251.89 436.164C255.04 441.319 258.62 445.645 261.958 447.725C273.066 454.608 282.733 455.573 290.671 453.364C300.016 450.78 307.096 443.654 311.407 435.563C315.687 427.438 317.12 418.394 315.599 412.264C315.372 411.334 314.856 410.547 314.169 409.979C312.43 413.583 310.192 417.117 307.483 420.305C307.058 423.867 305.783 427.834 303.817 431.561C300.594 437.624 295.403 443.15 288.394 445.088C282.31 446.783 274.984 445.69 266.454 440.406C263.973 438.878 261.553 435.521 259.231 431.689C258.062 429.782 256.748 427.518 255.384 425.099Z"
                fill="url(#paint35_radial_BONEDMI)"
              />
            </g>
            <g id="R7-Right-Front" filter="url(#filter36_d_BONEDMI)">
              <path
                d="M128.94 385.299C129.378 386.254 129.865 387.208 130.402 388.155C131.942 390.842 133.838 393.485 136.088 395.93C136.527 398.765 137.471 401.896 138.849 405.016C142.569 413.507 149.616 422.016 159.82 424.335C166.668 425.866 174.858 424.535 184.302 418.864C195.917 411.89 211.118 390.847 211.332 390.55L211.345 390.533C212.74 388.625 215.427 388.192 217.32 389.586C219.247 390.973 219.675 393.656 218.296 395.546L218.277 395.572C217.972 395.989 201.34 418.663 188.696 426.226C176.865 433.326 166.53 434.643 157.947 432.698C144.982 429.764 135.746 419.267 130.975 408.484C127.512 400.588 126.534 392.572 127.811 387.309C128.004 386.521 128.404 385.836 128.94 385.299Z"
                fill="url(#paint36_radial_BONEDMI)"
              />
            </g>
            <g id="R7-Left-Front" filter="url(#filter37_d_BONEDMI)">
              <path
                d="M316.907 385.299C316.469 386.254 315.981 387.208 315.445 388.155C313.904 390.842 312.009 393.485 309.759 395.93C309.32 398.765 308.375 401.896 306.998 405.016C303.277 413.507 296.231 422.016 286.027 424.335C279.179 425.866 270.989 424.535 261.545 418.864C249.93 411.89 234.729 390.847 234.515 390.55L234.502 390.533C233.106 388.625 230.42 388.192 228.526 389.586C226.6 390.973 226.172 393.656 227.551 395.546L227.569 395.572C227.875 395.989 244.506 418.663 257.151 426.226C268.981 433.326 279.317 434.643 287.899 432.698C300.864 429.764 310.101 419.267 314.872 408.484C318.335 400.588 319.312 392.572 318.035 387.309C317.843 386.521 317.443 385.836 316.907 385.299Z"
                fill="url(#paint37_radial_BONEDMI)"
              />
            </g>
            <g id="R6-Right-Front" filter="url(#filter38_d_BONEDMI)">
              <path
                d="M127.939 365.921C129.253 368.958 131.255 371.833 134.115 374.358C134.286 374.509 134.461 374.659 134.639 374.809C134.995 377.656 136.122 380.813 137.883 383.879C144.986 396.372 160.52 406.561 186.516 393.811C194.851 389.728 210.902 372.107 212.909 369.884C212.978 369.808 213.044 369.731 213.11 369.653C213.179 369.573 213.247 369.492 213.319 369.414C214.825 367.752 217.376 367.49 219.164 368.885C220.962 370.287 221.327 372.846 220.077 374.702C219.976 374.852 219.868 374.981 219.749 375.118C217.859 377.295 200.562 397.043 191.202 401.621C159.362 417.236 139.154 403.427 130.401 388.153C126.405 381.108 125.143 373.649 126.472 368.235C126.703 367.289 127.234 366.491 127.939 365.921Z"
                fill="url(#paint38_radial_BONEDMI)"
              />
            </g>
            <g id="R6-Left-Front" filter="url(#filter39_d_BONEDMI)">
              <path
                d="M317.908 365.921C316.594 368.958 314.592 371.833 311.732 374.358C311.561 374.509 311.386 374.659 311.208 374.809C310.851 377.656 309.725 380.813 307.964 383.879C300.86 396.372 285.327 406.561 259.331 393.811C250.996 389.728 234.944 372.107 232.938 369.884C232.869 369.808 232.803 369.731 232.737 369.653C232.668 369.573 232.599 369.492 232.528 369.414C231.022 367.752 228.471 367.49 226.683 368.885C224.885 370.287 224.52 372.846 225.77 374.702C225.871 374.852 225.979 374.981 226.097 375.118C227.988 377.295 245.285 397.043 254.645 401.621C286.485 417.236 306.692 403.427 315.446 388.153C319.442 381.108 320.703 373.649 319.375 368.235C319.144 367.289 318.613 366.491 317.908 365.921Z"
                fill="url(#paint39_radial_BONEDMI)"
              />
            </g>
            <g id="R5-Right-Front" filter="url(#filter40_d_BONEDMI)">
              <path
                d="M132.133 340.861C132.86 342.901 133.909 344.909 135.339 346.846C135.547 347.127 135.764 347.409 135.99 347.692C133.85 354.166 133.461 362.101 139.963 367.924C144.695 372.193 153.493 376.05 165.34 374.01C174.867 372.361 200.927 362.629 212.228 356.127C214.312 354.908 217.037 355.553 218.321 357.576C219.568 359.603 218.888 362.235 216.801 363.425C204.703 370.411 177.11 380.65 166.895 382.429C151.245 385.133 140.15 379.788 133.872 374.15C124.288 365.513 124.561 352.972 128.007 343.703C128.654 341.978 130.327 340.897 132.133 340.861Z"
                fill="url(#paint40_radial_BONEDMI)"
              />
            </g>
            <g id="R5-Left-Front" filter="url(#filter41_d_BONEDMI)">
              <path
                d="M313.713 340.861C312.987 342.901 311.938 344.909 310.508 346.846C310.299 347.127 310.083 347.409 309.857 347.692C311.996 354.166 312.386 362.101 305.883 367.924C301.152 372.193 292.354 376.05 280.507 374.01C270.98 372.361 244.92 362.629 233.619 356.127C231.534 354.908 228.81 355.553 227.526 357.576C226.279 359.603 226.959 362.235 229.046 363.425C241.144 370.411 268.737 380.65 278.951 382.429C294.602 385.133 305.697 379.788 311.975 374.15C321.559 365.513 321.285 352.972 317.84 343.703C317.192 341.978 315.52 340.897 313.713 340.861Z"
                fill="url(#paint41_radial_BONEDMI)"
              />
            </g>
            <g id="R4-Right-Front" filter="url(#filter42_d_BONEDMI)">
              <path
                d="M140.557 315.008C141.228 316.652 142.204 318.288 143.502 319.895C143.406 320.297 143.246 320.693 143.016 321.068C139.427 326.999 137.025 335.002 142.404 342.086C146.093 346.981 153.717 352.189 165.339 352.297C174.687 352.376 201.235 347.606 213.175 343.36C215.381 342.558 217.845 343.646 218.684 345.8C219.487 347.951 218.349 350.345 216.145 351.12C203.358 355.689 175.261 360.676 165.237 360.603C149.882 360.47 140.358 353.443 135.458 346.972C127.984 337.065 130.594 325.141 135.599 316.891C136.63 315.205 138.69 314.476 140.557 315.008Z"
                fill="url(#paint42_radial_BONEDMI)"
              />
            </g>
            <g id="R4-Left-Front" filter="url(#filter43_d_BONEDMI)">
              <path
                d="M305.29 315.008C304.619 316.652 303.643 318.288 302.345 319.895C302.44 320.297 302.601 320.693 302.831 321.068C306.42 326.999 308.821 335.002 303.443 342.086C299.754 346.981 292.13 352.189 280.508 352.297C271.16 352.376 244.612 347.606 232.672 343.36C230.466 342.558 228.002 343.646 227.163 345.8C226.359 347.951 227.498 350.345 229.702 351.12C242.489 355.689 270.585 360.676 280.61 360.603C295.965 360.47 305.489 353.443 310.389 346.972C317.863 337.065 315.253 325.141 310.247 316.891C309.216 315.205 307.157 314.476 305.29 315.008Z"
                fill="url(#paint43_radial_BONEDMI)"
              />
            </g>
            <g id="R3-Right-Front" filter="url(#filter44_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M143.114 299.579C137.991 306.228 138.055 314.283 145.049 321.551C153.283 330.107 173.2 337.804 208.47 337.873C210.83 337.874 212.747 335.95 212.766 333.595C212.751 331.216 210.857 329.296 208.462 329.271C176.8 329.227 158.639 323.28 151.232 315.599C147.787 312.026 147.403 308.092 149.932 304.817C151.377 302.953 151.018 300.26 149.134 298.811C147.284 297.362 144.56 297.715 143.114 299.579Z"
                fill="url(#paint44_radial_BONEDMI)"
              />
            </g>
            <g id="R3-Left-Front" filter="url(#filter45_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M302.733 299.579C307.856 306.228 307.792 314.283 300.798 321.551C292.563 330.107 272.647 337.804 237.377 337.873C235.016 337.874 233.1 335.95 233.081 333.595C233.096 331.216 234.99 329.296 237.385 329.271C269.047 329.227 287.207 323.28 294.615 315.599C298.06 312.026 298.444 308.092 295.915 304.817C294.47 302.953 294.828 300.26 296.713 298.811C298.563 297.362 301.287 297.715 302.733 299.579Z"
                fill="url(#paint45_radial_BONEDMI)"
              />
            </g>
            <g id="R2-Right-Front" filter="url(#filter46_d_BONEDMI)">
              <path
                d="M157.107 275.696C158.277 276.069 159.494 276.423 160.748 276.759C162.405 278.158 162.751 280.558 161.462 282.354C159.07 285.699 159.908 289.788 163.466 293.605C170.761 301.461 187.803 307.904 215.669 308.598C218.15 308.648 220.094 310.631 220.034 313.01C219.974 315.364 217.911 317.248 215.43 317.174C183.946 316.405 164.99 308.177 156.738 299.305C149.892 291.944 149.443 283.94 154.017 277.521C154.761 276.484 155.899 275.858 157.107 275.696Z"
                fill="url(#paint46_radial_BONEDMI)"
              />
            </g>
            <g id="R2-Left-Front" filter="url(#filter47_d_BONEDMI)">
              <path
                d="M288.17 275.654C287.861 275.752 287.55 275.853 287.237 275.957C286.627 276.16 286.002 276.358 285.366 276.551C283.481 277.909 283.029 280.465 284.384 282.354C286.776 285.699 285.939 289.788 282.381 293.605C275.085 301.461 258.043 307.905 230.178 308.598C227.696 308.648 225.752 310.631 225.812 313.01C225.872 315.364 227.935 317.248 230.417 317.174C261.9 316.405 280.856 308.177 289.108 299.305C295.955 291.944 296.403 283.94 291.829 277.521C290.969 276.323 289.583 275.672 288.17 275.654Z"
                fill="url(#paint47_radial_BONEDMI)"
              />
            </g>
            <g id="R1-Right-Front" filter="url(#filter48_d_BONEDMI)">
              <path
                d="M189.686 251.948C198.336 249.746 207.589 249.867 213.148 252.999C215.209 254.171 215.947 256.777 214.781 258.858C213.615 260.919 210.991 261.647 208.93 260.495C204.867 258.192 198.103 258.677 191.785 260.273C185.541 261.84 179.585 264.547 177.34 267.995C177.136 268.396 176.973 268.81 176.851 269.235C173.973 268.74 171.128 268.172 168.419 267.519C168.704 266.361 169.12 265.24 169.659 264.172C169.751 263.954 169.881 263.713 170.053 263.445C173.124 258.616 180.997 254.13 189.686 251.948Z"
                fill="url(#paint48_radial_BONEDMI)"
              />
              <path
                d="M171.489 281.914C170.79 280.899 170.199 279.871 169.713 278.838C173.815 279.676 178.085 280.36 182.25 280.915C187.743 285.313 197.082 288.517 210.678 288.945C213.05 289.005 214.916 291.006 214.838 293.37C214.761 295.735 212.778 297.593 210.406 297.532C189.179 296.866 176.816 289.612 171.489 281.914Z"
                fill="url(#paint49_radial_BONEDMI)"
              />
            </g>
            <g id="R1-Left-Front" filter="url(#filter49_d_BONEDMI)">
              <path
                d="M256.16 251.948C247.51 249.746 238.258 249.867 232.698 252.999C230.638 254.171 229.899 256.777 231.065 258.858C232.231 260.919 234.856 261.647 236.916 260.495C240.979 258.192 247.744 258.677 254.061 260.273C260.305 261.84 266.261 264.547 268.506 267.995C268.689 268.354 268.838 268.724 268.956 269.103C269.28 269.047 269.604 268.991 269.927 268.933C270.186 268.939 270.458 268.885 270.739 268.787C273.008 268.37 275.244 267.906 277.394 267.389C277.103 266.248 276.685 265.144 276.146 264.092C276.063 263.899 275.947 263.685 275.794 263.445C272.722 258.616 264.85 254.13 256.16 251.948Z"
                fill="url(#paint50_radial_BONEDMI)"
              />
              <path
                d="M274.357 281.914C275.091 280.849 275.705 279.77 276.204 278.685C272.148 279.516 267.925 280.195 263.8 280.749C258.337 285.233 248.934 288.512 235.168 288.945C232.796 289.005 230.93 291.006 231.008 293.37C231.086 295.735 233.068 297.593 235.44 297.532C256.667 296.866 269.03 289.612 274.357 281.914Z"
                fill="url(#paint51_radial_BONEDMI)"
              />
            </g>
            <g id="Clavicula-Right-Front" filter="url(#filter50_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M210.912 272.545C210.901 272.545 210.903 272.545 210.892 272.544C210.539 272.536 179.222 271.749 161.266 265.479C141.268 258.524 125.704 263.997 124.636 264.39C124.594 264.405 124.556 264.419 124.514 264.435C121.77 265.486 120.377 268.582 121.416 271.353C122.46 274.117 125.565 275.534 128.344 274.525C128.362 274.519 128.372 274.515 128.389 274.509C128.935 274.317 141.499 270.022 157.71 275.686C176.971 282.401 210.614 283.326 210.619 283.327C210.619 283.327 210.619 283.327 210.619 283.327C213.602 283.409 216.072 281.047 216.151 278.069C216.23 275.096 213.887 272.615 210.912 272.545Z"
                fill="url(#paint52_radial_BONEDMI)"
              />
            </g>
            <g id="Clavicula-Left-Front" filter="url(#filter51_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M234.935 272.545C234.946 272.545 234.943 272.545 234.954 272.544C235.308 272.536 266.625 271.749 284.581 265.479C304.579 258.524 320.143 263.997 321.211 264.39C321.253 264.405 321.291 264.419 321.333 264.435C324.077 265.486 325.47 268.582 324.431 271.353C323.387 274.117 320.282 275.534 317.503 274.525C317.485 274.519 317.475 274.515 317.458 274.509C316.911 274.317 304.348 270.022 288.137 275.686C268.876 282.401 235.233 283.326 235.228 283.327C235.228 283.327 235.228 283.327 235.228 283.327C232.244 283.409 229.775 281.047 229.696 278.069C229.617 275.096 231.959 272.615 234.935 272.545Z"
                fill="url(#paint53_radial_BONEDMI)"
              />
            </g>
            <g id="Sternum" filter="url(#filter52_d_BONEDMI)">
              <rect
                x={206.19}
                y={278.234}
                width={33.4663}
                height={133.206}
                rx={9.19269}
                fill="url(#paint54_radial_BONEDMI)"
              />
            </g>
            <g id="Group_10" filter="url(#filter53_i_BONEDMI)">
              <path
                id="Vector_35"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M221.756 184.927C221.765 184.936 221.852 184.937 221.86 184.928C221.884 184.902 225.648 182.463 225.683 182.462L243.751 181.701C243.77 181.7 243.786 181.714 243.788 181.733L244.618 189.335C244.73 190.361 244.733 191.481 243.987 192.195C238.499 197.444 207.879 197.664 200.93 192.489C199.819 191.661 199.715 190.172 199.865 188.795L200.635 181.747C200.637 181.72 200.66 181.701 200.687 181.702L217.734 182.457C217.785 182.46 221.721 184.89 221.756 184.927Z"
                fill="url(#paint55_radial_BONEDMI)"
              />
            </g>
          </g>
          <g id="Vector_36" filter="url(#filter54_f_BONEDMI)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M877.795 561.035C877.795 561.035 860.78 578.674 873.906 588.346C873.906 588.346 876.356 608.329 881.618 635.677C884.037 648.229 871.361 647.911 863.816 700.384L861.163 724.883L838.746 726.294C838.746 726.294 851.533 687.256 847.54 665.965C843.55 644.674 855.34 639.088 840.365 636.784C840.365 636.784 861.156 573.786 877.795 561.035Z"
              fill="url(#paint56_linear_BONEDMI)"
            />
          </g>
          <g id="Group 74">
            <g id="Skeleton Shape side" filter="url(#filter55_f_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M870.095 225.904L870.087 225.9C865.05 223.549 856.603 224.058 848.769 225.712C844.583 226.588 840.495 227.792 837.176 229.276C841.575 228.579 846.093 228.237 850.596 228.231H850.884C859.254 228.231 867.587 229.401 874.983 231.587C878.014 232.498 879.637 235.308 878.519 237.858C877.436 240.383 874.081 241.71 871.015 240.799L870.798 240.747C858.51 237.144 842.974 236.667 830.462 240.767C830.849 241.496 831.342 242.225 831.94 242.944C834.022 245.459 837.213 247.787 841.574 249.738C853.214 249.254 864.696 250.233 874.057 252.591C877.168 253.372 878.915 256.103 877.977 258.68C877.905 258.877 877.82 259.068 877.721 259.253C877.774 259.531 877.797 259.817 877.785 260.108C877.687 262.59 875.181 264.542 872.183 264.478C859.497 264.147 849.315 262.269 841.394 259.527C834.508 259.863 827.571 260.774 821.097 262.271C819.768 262.579 818.458 262.912 817.173 263.271C818.841 264.693 820.866 266.067 823.251 267.37C839.694 263.753 857.228 263.392 870.752 266.893C873.857 267.683 875.568 270.436 874.635 273.02C873.656 275.574 870.372 277.028 867.267 276.238C860.159 274.392 851.783 273.855 843.12 274.417C853.079 276.693 865.429 278.187 880.25 278.507C883.244 278.559 885.589 280.641 885.517 283.139C885.445 285.611 882.955 287.589 879.961 287.511C875.801 287.422 871.817 287.24 868.008 286.974C867.121 287.498 866.051 287.821 864.889 287.86C853.587 288.317 839.27 291.752 825.761 296.812C836.908 299.052 851.051 300.526 868.491 300.872C868.588 300.868 868.684 300.864 868.78 300.86C872.016 300.751 874.779 302.809 874.933 305.504C875.086 308.2 872.56 310.517 869.324 310.626C854.42 311.243 831.934 314.755 812.859 321.478C817.331 322.615 822.394 323.595 828.081 324.389C841.316 321.321 854.473 319.502 864.837 318.875C865.395 318.649 865.947 318.416 866.492 318.178C869.11 317.004 872.395 317.851 873.782 320.072C874.609 321.337 874.618 322.785 873.963 324.008C873.721 326.421 871.345 328.39 868.369 328.49C867.297 328.534 866.187 328.594 865.041 328.668C852.992 332.746 839.557 334.479 830.964 333.85C821.596 336.034 812.203 338.892 803.892 342.455C799.286 344.429 794.993 346.604 791.281 349.015C797.253 353.035 806.66 354.639 820.5 352.23C825.548 351.347 833.493 349.458 841.97 347.01C851.318 343.704 860.618 339.992 869.153 335.407C870.869 334.491 872.926 334.403 874.657 335.017C876.642 334.82 878.689 335.555 879.863 337.056C881.459 339.16 880.725 341.96 878.223 343.279C873.188 345.964 866.452 348.667 859.285 351.143C849.939 354.926 840.257 358.114 830.967 361.174L830.967 361.174L830.967 361.174C821.663 364.238 812.753 367.172 804.969 370.444C803.112 371.22 801.319 372.01 799.607 372.827C805.271 375.242 812.024 376.7 819.782 376.612C824.092 374.611 828.547 372.606 833.071 370.569L833.076 370.567C844.403 365.467 856.169 360.169 867.212 354.252C867.975 353.844 868.81 353.6 869.656 353.51C874.645 348.709 878.235 344.822 878.235 344.822C880.094 342.855 883.514 342.483 885.878 344.015C888.242 345.546 888.646 348.393 886.832 350.355C886.832 350.355 864.735 373.544 852.21 378.633C842.182 382.719 832.962 384.871 824.6 385.551C818.497 388.402 812.709 391.249 807.451 394.17C805.222 395.415 803.089 396.666 801.076 397.935C803.303 398.868 805.686 399.599 808.224 400.078C810.491 400.499 812.875 400.713 815.373 400.694C820.171 398.48 825.242 396.297 830.458 394.052L830.459 394.052L830.459 394.052L830.459 394.052L830.461 394.051L830.461 394.051C838.488 390.596 846.858 386.993 855.104 382.902C865.005 374.206 873.333 364.6 873.333 364.6C875.093 362.584 878.499 362.124 880.898 363.591C883.342 365.053 883.878 367.884 882.113 369.87C882.113 369.87 878.332 374.169 872.75 379.742C864.063 395.812 842.775 434.945 833.907 449.042C831.149 453.41 828.069 456.732 824.888 459.167C807.597 472.445 786.006 462.681 779.902 448.54C779.894 448.522 779.886 448.504 779.878 448.486C778.057 444.269 777.24 439.732 777.656 435.436C777.608 435.362 777.56 435.288 777.512 435.214C772.884 428.051 771.256 419.864 772.796 413.76C772.681 413.032 772.76 412.271 773.061 411.53C773.422 410.672 773.832 409.825 774.288 408.99C770.66 402.164 769.259 395.016 770.151 389.49C769.955 388.776 769.948 388.015 770.168 387.257C770.57 385.89 771.083 384.574 771.699 383.306C767.916 376.087 766.514 368.783 767.299 363.387C767.09 362.658 767.077 361.88 767.302 361.105C767.822 359.337 768.556 357.619 769.483 355.953C768.216 352.231 767.815 348.644 768.255 345.524C768.045 344.795 768.033 344.017 768.258 343.242C769.061 340.511 770.373 337.9 772.124 335.414C771.647 331.134 772.072 326.917 773.176 323.257C773.079 322.58 773.152 321.876 773.421 321.186C774.482 318.486 776.326 315.721 778.818 312.964C773.587 305.735 774.185 297.968 778.659 291.625C778.81 290.942 779.14 290.275 779.655 289.669C780.983 288.109 782.483 286.606 784.133 285.164C781.389 279.928 782.168 274.658 785.831 269.992C786.027 269.312 786.403 268.656 786.969 268.074C790.715 264.208 795.757 260.925 801.665 258.249C800.805 254.588 801.477 251.003 803.518 247.731C803.643 247.013 803.963 246.306 804.49 245.665C808.191 241.147 813.079 237.566 818.696 234.855C818.899 233.506 819.3 232.193 819.887 230.937C819.921 230.088 820.222 229.236 820.81 228.47C824.716 223.358 834.79 218.563 845.87 216.229C856.926 213.917 868.768 214.065 875.868 217.396C878.694 218.712 879.701 221.703 878.104 224.037C876.507 226.392 872.92 227.219 870.095 225.904ZM820.816 229.237C820.92 229.048 821.04 228.862 821.178 228.683C825.06 223.612 835.011 218.903 845.993 216.611C856.926 214.299 868.621 214.426 875.647 217.714C877.598 218.636 878.612 220.404 878.377 222.151C878.61 220.405 877.597 218.638 875.647 217.717C868.62 214.428 856.926 214.301 845.993 216.614C835.01 218.905 825.06 223.615 821.178 228.686C821.046 228.858 820.929 229.036 820.828 229.218C820.824 229.224 820.82 229.23 820.816 229.237ZM818.635 235.305C813.195 237.973 808.457 241.473 804.85 245.873C804.811 245.921 804.773 245.969 804.737 246.017L804.756 245.992C804.787 245.953 804.819 245.913 804.851 245.874C808.457 241.474 813.195 237.973 818.635 235.306C818.635 235.306 818.635 235.306 818.635 235.305ZM820.963 245.213C818.381 246.887 816.092 248.869 814.194 251.181C813.847 251.608 813.429 251.974 812.962 252.277C812.622 252.944 812.41 253.631 812.322 254.332C814.153 253.793 816.03 253.299 817.944 252.851C820.618 252.229 823.364 251.698 826.152 251.257C824.94 250.216 823.89 249.151 822.997 248.079C822.212 247.133 821.535 246.176 820.963 245.213ZM877.539 258.61C877.543 258.598 877.547 258.587 877.551 258.576C878.403 256.182 876.784 253.683 873.929 252.955C868.649 251.63 862.699 250.743 856.428 250.31C862.698 250.743 868.648 251.63 873.928 252.955C876.783 253.684 878.402 256.182 877.55 258.576C877.546 258.587 877.542 258.597 877.538 258.608C877.538 258.609 877.539 258.609 877.539 258.61ZM835.955 229.852L835.953 229.853C848.916 227.579 863.06 228.464 874.803 231.953C875.775 232.236 876.582 232.725 877.185 233.34C876.582 232.725 875.774 232.236 874.803 231.952C863.06 228.464 848.917 227.579 835.955 229.852ZM795.787 273.954C798.535 271.114 802.195 268.722 806.455 266.738L806.456 266.738C802.196 268.723 798.536 271.114 795.788 273.954C795.751 273.992 795.713 274.031 795.675 274.068L795.687 274.055C795.721 274.022 795.754 273.988 795.787 273.954ZM820.969 261.907C819.565 262.234 818.181 262.588 816.825 262.969L816.825 262.969C818.181 262.588 819.564 262.234 820.967 261.907L820.969 261.907ZM796.129 274.214C798.862 271.393 802.502 269.016 806.739 267.045C807.292 267.633 807.889 268.219 808.53 268.801C809.256 269.462 810.048 270.119 810.906 270.769C804.649 272.867 798.779 275.452 793.611 278.459C793.673 277.354 794.048 276.275 794.732 275.248C795.248 274.974 795.722 274.629 796.129 274.214ZM798.958 286.767C805.606 282.699 813.813 279.515 822.483 277.32L822.484 277.32C813.814 279.516 805.607 282.7 798.959 286.768L798.958 286.767ZM867.394 275.878C859.927 273.947 851.054 273.438 841.901 274.131L841.899 274.131C851.053 273.437 859.926 273.946 867.395 275.877C869.484 276.418 871.698 275.838 873.075 274.544C871.698 275.838 869.484 276.419 867.394 275.878ZM799.317 287.029C806.022 282.943 814.314 279.757 823.063 277.568C827.359 279.386 832.345 281.047 838.04 282.472C828.592 284.977 818.867 288.415 809.93 292.442C805.539 290.791 802.018 288.966 799.317 287.029ZM864.876 287.5C865.736 287.46 866.543 287.254 867.251 286.92L867.253 286.92C866.545 287.254 865.738 287.46 864.878 287.5C853.369 287.95 838.773 291.48 825.056 296.669L825.055 296.669C838.771 291.48 853.367 287.95 864.876 287.5ZM790.94 292.872C790.25 293.542 789.599 294.227 788.991 294.928L788.983 294.938C789.594 294.233 790.248 293.545 790.941 292.873L790.94 292.872ZM791.281 293.132C790.546 293.845 789.856 294.576 789.213 295.325C788.817 295.802 788.333 296.199 787.792 296.514C785.895 299.418 785.408 302.655 786.68 305.85C790.321 303.064 794.53 300.356 799.155 297.807C796.038 296.309 793.422 294.738 791.281 293.132ZM811.502 302.491C809.856 303.291 808.247 304.111 806.685 304.948C801.653 307.633 797.083 310.469 793.351 313.38L793.352 313.38C797.084 310.469 801.655 307.633 806.686 304.948C808.248 304.111 809.857 303.291 811.503 302.491L811.502 302.491ZM812.055 302.656C810.311 303.498 808.609 304.364 806.96 305.248C801.954 307.921 797.41 310.734 793.701 313.622C795.09 314.571 796.661 315.485 798.42 316.358C798.764 316.207 799.111 316.057 799.459 315.907C808.541 312.01 818.833 308.889 829.078 306.516C822.673 305.426 817.013 304.119 812.055 302.656ZM874.415 305.015C874.449 305.181 874.472 305.351 874.483 305.524C874.604 308.012 872.316 310.121 869.312 310.263C854.233 310.864 831.406 314.438 812.181 321.304L812.186 321.305C831.411 314.44 854.235 310.867 869.313 310.266C872.317 310.124 874.605 308.015 874.484 305.526C874.473 305.351 874.449 305.179 874.414 305.011L874.415 305.015ZM784.176 324.084C784.686 322.785 785.44 321.483 786.408 320.184L786.409 320.185C785.441 321.483 784.687 322.785 784.177 324.084L784.173 324.094L784.172 324.095L784.176 324.084ZM784.846 323.642C785.328 322.57 785.973 321.498 786.764 320.43C787.273 320.778 787.8 321.122 788.346 321.463C787.139 322.171 785.971 322.897 784.846 323.642ZM783.447 338.036C787.14 333.717 792.699 329.997 799.224 326.754L799.228 326.755C792.702 329.999 787.142 333.72 783.448 338.039L783.447 338.036ZM783.589 338.535C787.3 334.07 793.013 330.249 799.724 326.942C802.492 327.979 805.522 328.945 808.826 329.828C805.265 331.041 801.804 332.355 798.504 333.771C793.4 335.956 788.689 338.398 784.536 341.084C784.159 340.249 783.845 339.397 783.589 338.535ZM803.702 342.112C811.7 338.676 820.705 335.894 829.728 333.739L829.739 333.741C820.712 335.896 811.704 338.678 803.703 342.115C799.029 344.122 794.68 346.328 790.927 348.771L790.924 348.769C794.678 346.326 799.027 344.119 803.702 342.112ZM868.357 328.13C867.69 328.156 867.009 328.189 866.313 328.227L866.325 328.222C867.017 328.184 867.694 328.152 868.356 328.126C870.699 328.015 872.606 326.709 873.275 324.959L873.279 324.955C872.612 326.709 870.703 328.019 868.357 328.13ZM783.178 355.127C782.579 355.777 782.023 356.44 781.512 357.118L781.514 357.12C782.025 356.442 782.581 355.778 783.18 355.128L783.178 355.127ZM783.523 355.381C782.879 356.082 782.285 356.799 781.744 357.532C782.168 358.276 782.637 359.02 783.148 359.759C784.791 362.159 786.886 364.49 789.413 366.615C792.537 364.876 795.953 363.252 799.609 361.713C792.859 360.631 787.585 358.33 783.523 355.381ZM830.779 360.83L830.776 360.831L830.776 360.831L830.775 360.831C821.465 363.896 812.544 366.833 804.736 370.109C802.79 370.926 800.916 371.759 799.131 372.621L799.132 372.622C800.917 371.759 802.79 370.926 804.736 370.11C812.543 366.834 821.465 363.897 830.776 360.832C837.792 358.522 845.029 356.14 852.177 353.485L852.165 353.488C845.024 356.141 837.792 358.522 830.781 360.83L830.779 360.83ZM779.132 373.759C778.674 372.348 778.337 370.974 778.128 369.666C778.985 370.559 779.895 371.436 780.858 372.292C780.263 372.772 779.687 373.261 779.132 373.759ZM784.324 384.085C785.763 382.083 787.609 380.278 789.786 378.616C794.047 380.997 798.91 382.936 804.348 384.195C803.177 384.816 802.028 385.44 800.903 386.068C797.487 387.969 794.289 389.911 791.351 391.906C788.592 389.543 786.248 386.866 784.324 384.085ZM807.178 393.869C812.187 391.077 817.681 388.355 823.471 385.634L823.476 385.634C817.685 388.356 812.189 391.078 807.178 393.871C804.885 395.15 802.693 396.438 800.629 397.745L800.627 397.744C802.691 396.436 804.884 395.148 807.178 393.869ZM780.869 395.628C781.04 396.892 781.335 398.207 781.747 399.545C782.29 399.024 782.851 398.508 783.43 397.995C782.542 397.23 781.688 396.439 780.869 395.628ZM792.076 403.971C790.032 405.739 788.256 407.566 786.801 409.475L786.802 409.477C788.258 407.568 790.034 405.741 792.078 403.972L792.076 403.971ZM792.461 404.177C790.355 405.99 788.535 407.864 787.059 409.824C788.317 411.497 789.755 413.101 791.369 414.573C794.367 412.181 797.743 409.941 801.428 407.805C798.233 406.881 795.241 405.649 792.461 404.177ZM818.42 409.609C811.424 412.917 805.082 416.299 799.968 420.166C801.558 420.851 803.243 421.411 805.02 421.819C812.709 423.6 821.969 422.452 832.75 416.904C835.885 415.299 838.944 411.774 841.879 407.751C843.406 405.681 844.874 403.476 846.249 401.264C845.735 401.545 845.225 401.812 844.72 402.063C835.151 406.834 826.356 409.118 818.42 409.609ZM770.589 387.512L770.591 387.505C770.605 387.454 770.619 387.403 770.635 387.352C770.747 386.97 770.868 386.593 770.997 386.22C770.868 386.593 770.747 386.971 770.635 387.353C770.618 387.406 770.603 387.459 770.589 387.512ZM783.415 422.444C783.26 421.738 783.146 421.04 783.077 420.358C783.462 420.714 783.854 421.065 784.255 421.41C783.968 421.752 783.688 422.097 783.415 422.444ZM789.689 431.818C790.514 430.155 791.528 428.584 792.71 427.091C795.609 428.563 798.758 429.731 802.142 430.509C811.057 432.57 821.698 431.999 833.81 426.775C831.9 429.976 830.127 432.502 828.545 433.701C819.326 440.678 811.193 443.106 804.263 442.296C797.752 441.546 792.609 437.986 788.982 433.573C789.17 432.973 789.405 432.386 789.689 431.818ZM791.364 447.792C796.24 455.232 807.893 459.944 817.51 452.554C818.948 451.449 820.324 450.121 821.633 448.538C814.746 451.228 808.388 451.887 802.741 451.226C798.606 450.746 794.792 449.535 791.364 447.792ZM879.172 601.981C879.172 601.981 888.287 583.555 904.187 569.81C920.085 556.065 903.628 499.525 850.57 520.38C805.184 538.237 822.277 564.172 832.896 580.285C834.691 583.007 836.3 585.449 837.392 587.524C842.385 597.013 841.743 598.376 839.964 602.149C839.051 604.084 837.84 606.654 836.937 611.282C836.212 614.996 837.096 618.843 838.105 622.68C832.208 624.873 825.186 626.158 818.506 624.069C808.3 620.88 807.837 644.117 821.902 652.735C833.274 659.703 838.639 657.772 845.216 655.406L845.217 655.406L845.218 655.405L845.219 655.405L845.219 655.405C846.775 654.845 848.399 654.261 850.186 653.765C863.697 650.009 860.088 633.952 856.193 623.687C861.407 613.116 866.937 609.711 873.258 605.82L873.259 605.82C875.154 604.652 877.121 603.442 879.172 601.981Z"
                fill="#EEEEEE"
              />
            </g>
            <g id="Body Side" filter="url(#filter56_f_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M856.248 -42.5948C856.248 -42.5948 785.237 -55.3648 769.596 3.35504C753.954 62.0749 770.409 35.9037 765.088 47.1984C759.767 58.4933 742.375 73.9714 749.292 79.2617C756.209 84.552 763.751 79.5493 760.18 89.171C756.609 98.7927 758.817 96.3211 765.567 100.906C765.567 100.906 756.085 110.51 763.416 114.006C770.747 117.503 770.274 116.723 769.363 125.885C768.453 135.048 771.745 139.054 788.946 139.539C806.148 140.024 809.158 135.764 813.82 157.5C818.482 179.236 819.928 199.004 811.729 210.797C803.531 222.591 755.426 272.349 762.352 350.318C758.448 395.071 755.556 410.718 760.433 462.683C763.183 491.976 758.036 525.464 763.909 557.522C775.778 622.321 760.226 679.202 767.548 739.278C774.87 799.354 915.178 747.083 915.178 747.083C915.178 747.083 912.755 733.243 919.526 714.288C930.853 682.577 958.687 655.355 944.747 602.148C931.07 549.947 907.355 529.834 922.253 446.69C937.151 363.545 949.739 270.134 932.368 231.265C898.016 154.401 872.745 133.831 900.051 82.1066C944.449 -1.99113 900.354 -30.3169 856.248 -42.5948Z"
                fill="url(#paint57_radial_BONEDMI)"
                fillOpacity={0.3}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M856.248 -42.5948C856.248 -42.5948 785.237 -55.3648 769.596 3.35504C753.954 62.0749 770.409 35.9037 765.088 47.1984C759.767 58.4933 742.375 73.9714 749.292 79.2617C756.209 84.552 763.751 79.5493 760.18 89.171C756.609 98.7927 758.817 96.3211 765.567 100.906C765.567 100.906 756.085 110.51 763.416 114.006C770.747 117.503 770.274 116.723 769.363 125.885C768.453 135.048 771.745 139.054 788.946 139.539C806.148 140.024 809.158 135.764 813.82 157.5C818.482 179.236 819.928 199.004 811.729 210.797C803.531 222.591 755.426 272.349 762.352 350.318C758.448 395.071 755.556 410.718 760.433 462.683C763.183 491.976 758.036 525.464 763.909 557.522C775.778 622.321 760.226 679.202 767.548 739.278C774.87 799.354 915.178 747.083 915.178 747.083C915.178 747.083 912.755 733.243 919.526 714.288C930.853 682.577 958.687 655.355 944.747 602.148C931.07 549.947 907.355 529.834 922.253 446.69C937.151 363.545 949.739 270.134 932.368 231.265C898.016 154.401 872.745 133.831 900.051 82.1066C944.449 -1.99113 900.354 -30.3169 856.248 -42.5948Z"
                fill="url(#paint58_linear_BONEDMI)"
              />
            </g>
            <g id="C5" filter="url(#filter57_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M849.999 153.722C848.884 153.77 847.813 154.337 847.026 155.297C846.239 156.257 845.801 157.53 845.811 158.831C845.829 161.146 845.849 163.881 845.866 166.117C845.885 168.588 847.492 170.569 849.598 170.72C857.79 171.307 878.017 172.757 894.203 173.917C895.759 174.028 897.195 172.774 897.565 170.982C897.935 169.189 897.125 167.409 895.668 166.814C886.247 162.966 875.834 158.712 869.197 156.001C864.664 154.149 859.842 153.306 854.973 153.512C853.27 153.584 851.514 153.658 849.999 153.722Z"
                fill="url(#paint59_radial_BONEDMI)"
              />
            </g>
            <g id="C6" filter="url(#filter58_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M851.706 175.63C850.427 175.734 849.236 176.517 848.476 177.753C847.716 178.989 847.473 180.541 847.817 181.958C848.103 183.138 848.398 184.352 848.665 185.453C849.229 187.779 851.212 189.175 853.288 188.708C856.467 187.991 861.135 186.94 864.793 186.116C868.502 185.28 872.282 185.23 875.948 185.968C882.606 187.308 892.884 189.376 892.884 189.376C892.884 189.376 892.884 189.376 892.885 189.376C894.337 189.689 895.79 188.596 896.175 186.902C896.559 185.209 895.738 183.52 894.315 183.08C885.298 180.287 877.454 177.857 872.397 176.291C868.429 175.062 864.287 174.607 860.135 174.945C857.429 175.165 854.297 175.42 851.706 175.63Z"
                fill="url(#paint60_radial_BONEDMI)"
              />
            </g>
            <g id="C7" filter="url(#filter59_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M855.396 190.825C854.138 191.125 853.044 192.077 852.428 193.405C851.811 194.733 851.741 196.292 852.236 197.634C853.103 199.982 854.087 202.647 854.851 204.718C855.611 206.776 857.523 207.878 859.444 207.364C863.004 206.413 868.72 204.885 872.81 203.792C876.057 202.924 879.381 202.674 882.652 203.05C887.086 203.561 893.999 204.356 901.266 205.193C902.855 205.376 904.355 204.12 904.736 202.288C905.118 200.456 904.258 198.643 902.745 198.095C893.951 194.906 885.069 191.685 879.099 189.521C874.341 187.796 869.234 187.516 864.252 188.707C861.324 189.407 858.049 190.19 855.396 190.825Z"
                fill="url(#paint61_radial_BONEDMI)"
              />
            </g>
            <g id="T1" filter="url(#filter60_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M861.618 208.645C860.387 208.976 859.326 209.931 858.732 211.244C858.137 212.557 858.073 214.088 858.555 215.409C859.363 217.62 860.273 220.114 860.992 222.08C861.739 224.126 863.639 225.219 865.544 224.699C868.931 223.776 874.281 222.317 878.289 221.223C881.838 220.255 885.479 220.006 889.049 220.485C894.199 221.177 902.433 222.284 911.078 223.445C912.678 223.66 914.205 222.407 914.596 220.559C914.986 218.71 914.11 216.881 912.578 216.346C900.995 212.296 889.359 208.228 882.966 205.993C879.689 204.847 876.176 204.727 872.772 205.643C869.381 206.555 864.978 207.741 861.618 208.645Z"
                fill="url(#paint62_radial_BONEDMI)"
              />
            </g>
            <g id="T2" filter="url(#filter61_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M867.488 225.84C866.273 226.168 865.226 227.112 864.639 228.409C864.053 229.707 863.989 231.219 864.465 232.525C865.254 234.688 866.145 237.132 866.861 239.095C867.64 241.231 869.663 242.318 871.627 241.656C874.231 240.778 877.928 239.531 881.274 238.402C886.58 236.613 892.135 236.441 897.396 237.906C902.682 239.378 910.119 241.448 918.284 243.722C919.881 244.166 921.551 243.061 922.087 241.205C922.624 239.348 921.839 237.387 920.301 236.739C906.874 231.082 894.476 225.859 888.205 223.217C885.407 222.038 882.343 221.836 879.377 222.635C875.889 223.575 871.078 224.872 867.488 225.84Z"
                fill="url(#paint63_radial_BONEDMI)"
              />
            </g>
            <g id="T3" filter="url(#filter62_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M874.617 243.039C873.458 243.439 872.485 244.403 871.95 245.679C871.415 246.956 871.372 248.418 871.833 249.684C872.739 252.177 873.803 255.105 874.587 257.26C875.259 259.108 876.873 260.208 878.614 260.005C882.128 259.595 888.056 258.904 891.956 258.449C894.516 258.15 897.08 258.419 899.513 259.242C904.928 261.073 915.531 264.658 925.977 268.19C927.498 268.705 929.156 267.774 929.817 266.034C930.478 264.294 929.929 262.306 928.546 261.428C916.13 253.549 902.44 244.861 895.451 240.425C892.457 238.525 888.895 238.111 885.533 239.271C882.171 240.432 877.849 241.924 874.617 243.039Z"
                fill="url(#paint64_radial_BONEDMI)"
              />
            </g>
            <g id="T4" filter="url(#filter63_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M880.637 261.236C879.453 261.365 878.372 262.105 877.676 263.262C876.979 264.419 876.737 265.879 877.011 267.262C877.483 269.646 878.027 272.393 878.469 274.619C878.951 277.052 880.89 278.645 882.962 278.312C889.275 277.296 901.574 275.316 901.574 275.316C901.574 275.316 914.697 282.819 931.055 292.17C932.554 293.027 934.357 292.314 935.147 290.553C935.937 288.792 935.434 286.606 934.005 285.592C920.636 276.109 908.517 267.512 902.053 262.927C898.86 260.661 895.147 259.659 891.44 260.062C888.06 260.429 883.828 260.89 880.637 261.236Z"
                fill="url(#paint65_radial_BONEDMI)"
              />
            </g>
            <g id="T5" filter="url(#filter64_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M883.046 280.374C881.011 280.681 879.472 282.748 879.448 285.206C879.431 287.056 879.41 289.239 879.391 291.203C879.378 292.597 879.861 293.928 880.718 294.864C881.576 295.799 882.727 296.25 883.884 296.103C888.529 295.512 895.689 294.602 900.232 294.024C902.939 293.68 905.629 294.785 907.582 297.044C911.482 301.554 918.598 309.782 926.068 318.42C927.231 319.766 929.065 319.81 930.285 318.523C931.505 317.235 931.703 315.046 930.74 313.489C924.189 302.9 917.882 292.704 914.48 287.205C912.778 284.454 910.51 282.282 907.895 280.899C907.347 280.609 906.781 280.309 906.222 280.014C903.206 278.419 899.881 277.837 896.601 278.331C892.471 278.953 886.716 279.821 883.046 280.374Z"
                fill="url(#paint66_radial_BONEDMI)"
              />
            </g>
            <g id="T6" filter="url(#filter65_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M883.037 299.543C880.957 299.814 879.374 301.923 879.368 304.431C879.364 306.481 879.359 308.935 879.354 311.084C879.351 312.448 879.822 313.748 880.654 314.673C881.485 315.598 882.603 316.063 883.737 315.956C887.085 315.641 891.802 315.198 895.898 314.813C901.306 314.304 906.56 317.034 909.932 322.106C913.512 327.488 918.538 335.045 923.961 343.2C924.985 344.74 926.837 345.051 928.186 343.909C929.535 342.767 929.916 340.567 929.055 338.889C921.621 324.398 914.996 311.483 912.861 307.322C912.384 306.392 911.821 305.531 911.181 304.754C910.375 303.776 909.174 302.317 908.016 300.912C905.845 298.275 902.785 296.973 899.703 297.374C894.825 298.009 887.433 298.971 883.037 299.543Z"
                fill="url(#paint67_radial_BONEDMI)"
              />
            </g>
            <g id="T7" filter="url(#filter66_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M883.136 319.294C881.009 319.502 879.365 321.636 879.359 324.195C879.351 327.939 879.339 333.243 879.331 337.088C879.328 338.391 879.757 339.638 880.523 340.555C881.29 341.472 882.33 341.984 883.416 341.977C888.084 341.949 895.783 341.901 901.328 341.866C905.531 341.84 909.474 344.257 911.908 348.352C914.676 353.009 918.709 359.795 923.288 367.499C924.251 369.118 926.108 369.539 927.508 368.454C928.908 367.37 929.357 365.162 928.53 363.438C920.346 346.393 913.598 332.339 912.768 330.609C912.711 330.49 912.648 330.375 912.58 330.264C912.223 329.68 910.969 327.634 909.557 325.328C906.458 320.269 901.392 317.505 896.161 318.017C891.749 318.45 886.565 318.958 883.136 319.294Z"
                fill="url(#paint68_radial_BONEDMI)"
              />
            </g>
            <g id="T8" filter="url(#filter67_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M881.268 344.152C879.158 344.16 877.834 345.211 877.668 347.713C877.425 351.381 877.078 356.601 876.825 360.426C876.737 361.741 877.102 363.049 877.835 364.052C878.567 365.055 879.606 365.667 880.713 365.749C885.293 366.088 892.726 366.638 898.528 367.067C903.882 367.463 908.801 370.847 911.794 376.192C914.442 380.922 917.897 387.092 921.365 393.285C922.248 394.863 923.974 395.422 925.381 394.586C926.789 393.75 927.435 391.783 926.884 390.008C922.493 375.855 918.935 364.072 911.141 351.368C908.144 346.485 903.572 344.13 898.528 344.152C892.908 344.176 885.584 344.133 881.268 344.152Z"
                fill="url(#paint69_radial_BONEDMI)"
              />
            </g>
            <g id="T9" filter="url(#filter68_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M877.843 367.778C875.844 367.596 874.072 369.129 873.647 371.41C873.033 374.699 872.155 379.408 871.49 382.979C871.246 384.286 871.482 385.673 872.142 386.802C872.801 387.932 873.823 388.701 874.961 388.924C879.224 389.761 885.896 391.07 891.886 392.245C900.255 393.888 907.62 400.01 911.795 408.794C912.344 409.951 912.909 411.139 913.48 412.341C914.253 413.967 915.909 414.714 917.362 414.092C918.814 413.47 919.618 411.669 919.245 409.871C916.891 398.502 916.843 388.56 910.262 378.513C906.818 373.254 901.646 369.941 896.093 369.437C890.018 368.884 882.249 368.178 877.843 367.778Z"
                fill="url(#paint70_radial_BONEDMI)"
              />
            </g>
            <g id="T10" filter="url(#filter69_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M874.065 391.383C871.92 390.926 869.909 392.483 869.474 394.938C869.083 397.142 868.611 399.807 868.222 402.005C867.79 404.441 869.057 406.933 871.125 407.716C876.854 409.885 887.968 414.091 894.755 416.66C898.51 418.081 901.945 420.549 904.755 423.845C906.942 426.409 909.723 429.672 912.504 432.934C913.588 434.205 915.262 434.431 916.488 433.472C917.714 432.513 918.144 430.64 917.511 429.015C913.634 419.059 909.595 408.686 909.595 408.686C909.595 408.686 909.592 408.678 909.585 408.663C906.607 401.927 901.098 397.139 894.776 395.793C887.841 394.316 879.016 392.437 874.065 391.383Z"
                fill="url(#paint71_radial_BONEDMI)"
              />
            </g>
            <g id="T11" filter="url(#filter70_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M869.959 410.367C867.839 409.549 865.633 410.799 864.969 413.194C864.002 416.683 862.639 421.6 861.641 425.198C861.302 426.423 861.419 427.785 861.967 428.962C862.514 430.138 863.443 431.027 864.533 431.417C868.883 432.975 875.899 435.487 882.089 437.702C890.575 440.741 898.743 445.038 906.384 450.487C907.892 451.562 909.433 452.661 910.929 453.727C912.175 454.616 913.737 454.436 914.716 453.291C915.696 452.146 915.844 450.328 915.074 448.881C911.366 441.907 906.931 433.568 904.034 428.12C902.051 424.39 898.992 421.57 895.444 420.201C888.327 417.455 876.123 412.746 869.959 410.367Z"
                fill="url(#paint72_radial_BONEDMI)"
              />
            </g>
            <g id="T12" filter="url(#filter71_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M864.031 434.473C861.914 433.658 859.712 434.902 859.049 437.287C858.083 440.762 856.722 445.657 855.726 449.24C855.387 450.46 855.504 451.815 856.051 452.987C856.597 454.159 857.525 455.044 858.614 455.432C866.434 458.225 882.882 464.097 887.61 465.785C888.475 466.093 889.343 466.386 890.213 466.664C893.352 467.664 901.563 470.28 908.347 472.442C909.692 472.871 911.072 472.236 911.739 470.882C912.405 469.528 912.201 467.778 911.236 466.579C906.432 460.61 900.472 453.207 897.27 449.229C895.769 447.364 893.892 445.963 891.828 445.169C885.429 442.707 870.936 437.13 864.031 434.473Z"
                fill="url(#paint73_radial_BONEDMI)"
              />
            </g>
            <g id="L1" filter="url(#filter72_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M857.888 459.139C855.801 458.383 853.645 459.608 852.968 461.935C852.075 465.002 850.857 469.187 849.923 472.396C849.565 473.626 849.676 474.998 850.231 476.18C850.785 477.362 851.732 478.246 852.841 478.617C862.323 481.796 884.16 489.115 884.16 489.115C884.16 489.115 897.077 492.327 907.446 494.906C908.865 495.258 910.26 494.452 910.821 492.957C911.383 491.461 910.963 489.665 909.807 488.612C901.189 480.765 890.343 470.891 890.343 470.891C890.343 470.891 867.116 462.48 857.888 459.139Z"
                fill="url(#paint74_radial_BONEDMI)"
              />
            </g>
            <g id="L2" filter="url(#filter73_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M850.921 481.655C848.799 480.957 846.657 482.284 846.059 484.669C845.238 487.936 844.104 492.454 843.241 495.892C842.922 497.162 843.094 498.556 843.715 499.724C844.335 500.893 845.345 501.724 846.491 502.011C852.519 503.517 863.349 506.224 871.1 508.161C877.134 509.669 883.078 511.723 888.876 514.304C893.071 516.171 898.254 518.478 903.196 520.678C904.632 521.317 906.208 520.69 906.927 519.192C907.646 517.695 907.3 515.763 906.108 514.618C895.429 504.363 893.266 498.671 882.664 492.104C871.281 485.053 860.082 484.671 850.921 481.655Z"
                fill="url(#paint75_radial_BONEDMI)"
              />
            </g>
            <g id="L3" filter="url(#filter74_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M844.692 505.127C842.47 504.579 840.353 506.209 839.961 508.768C839.32 512.957 838.376 519.128 837.698 523.555C837.49 524.917 837.811 526.338 838.577 527.443C839.343 528.547 840.477 529.224 841.677 529.292C844.052 529.428 847.116 529.602 850.426 529.791C866.947 530.734 883.3 535.102 898.708 542.689C899.043 542.854 899.377 543.019 899.711 543.183C901.132 543.882 902.742 543.306 903.518 541.819C904.294 540.333 904.008 538.372 902.842 537.184C896.23 530.445 888.851 522.925 884.292 518.279C881.428 515.359 877.873 513.306 874.047 512.363C865.979 510.374 851.655 506.843 844.692 505.127Z"
                fill="url(#paint76_radial_BONEDMI)"
              />
            </g>
            <g id="L4" filter="url(#filter75_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M839.563 533.155C838.462 533.108 837.401 533.583 836.621 534.473C835.841 535.363 835.408 536.592 835.42 537.882C835.459 542.122 835.516 548.203 835.554 552.354C835.578 554.928 837.335 557.066 839.532 557.194C846.852 557.621 862.533 558.534 870.438 558.994C873.609 559.179 876.772 559.592 879.91 560.231C884.531 561.171 891.796 562.65 898.19 563.951C899.623 564.243 901.016 563.343 901.551 561.779C902.086 560.216 901.621 558.402 900.429 557.403C895.354 553.148 889.346 548.112 884.27 543.856C877.073 537.822 868.552 534.399 859.797 534.023C852.678 533.718 844.422 533.363 839.563 533.155Z"
                fill="url(#paint77_radial_BONEDMI)"
              />
            </g>
            <g id="L5" filter="url(#filter76_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M840.869 560.746C839.605 560.701 838.385 561.349 837.564 562.502C836.744 563.655 836.416 565.182 836.676 566.638C837.553 571.538 838.769 578.329 839.573 582.825C839.797 584.075 840.435 585.16 841.346 585.84C842.257 586.52 843.366 586.74 844.429 586.45C848.023 585.469 853.54 583.965 858.906 582.501C869.56 579.595 880.561 579.205 891.271 581.354C895.397 582.182 899.952 583.096 904.483 584.005C906.046 584.319 907.578 583.19 908.038 581.386C908.498 579.582 907.739 577.681 906.276 576.976C895.981 572.015 885.267 566.852 879.485 564.065C876.625 562.687 873.501 561.919 870.287 561.804C862.816 561.535 848.581 561.023 840.869 560.746Z"
                fill="url(#paint78_radial_BONEDMI)"
              />
            </g>
            <g id="Sacrum" filter="url(#filter77_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M847.609 590.012C833.424 593.852 865.737 620.03 868.427 622.923C882.013 637.538 890.878 657.341 893.539 679.013C894.238 684.706 894.934 690.382 895.546 695.364C895.753 697.055 896.925 698.329 898.364 698.426C899.802 698.524 901.122 697.42 901.538 695.771C903.712 687.146 906.453 676.276 908.912 666.521C913.016 650.242 912.237 632.868 906.707 617.392C905.983 615.364 905.255 613.327 904.544 611.336C900.029 598.698 891.245 588.963 880.311 584.476C877.128 583.17 873.686 582.953 870.372 583.85C864.435 585.457 854.531 588.138 847.609 590.012Z"
                fill="url(#paint79_radial_BONEDMI)"
              />
            </g>
            <g id="C4" filter="url(#filter78_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M849.96 133.474C848.855 133.441 847.772 133.93 846.951 134.831C846.131 135.732 845.642 136.97 845.595 138.267C845.515 140.487 845.42 143.093 845.341 145.272C845.248 147.845 846.886 149.99 849.071 150.154C856.215 150.69 871.827 151.863 884.337 152.803C885.844 152.916 887.235 151.736 887.632 150.009C888.028 148.282 887.313 146.512 885.94 145.819C879.483 142.561 872.515 139.045 867.807 136.67C864.093 134.796 860.088 133.772 856.002 133.652C853.985 133.592 851.794 133.528 849.96 133.474Z"
                fill="url(#paint80_radial_BONEDMI)"
              />
            </g>
            <g id="C1" filter="url(#filter79_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M856.928 81.8191C854.793 81.1989 852.604 82.5759 851.871 85.0011C851.741 85.4306 851.608 85.8708 851.474 86.3106C851.06 87.6816 851.176 89.1958 851.794 90.4581C852.412 91.7203 853.469 92.6054 854.69 92.8818C860.05 94.095 868.773 96.0695 875.32 97.5516C876.648 97.8521 877.995 97.1476 878.688 95.7892C879.381 94.4308 879.271 92.7102 878.414 91.4864C877.479 90.1507 876.634 88.9435 876.079 88.151C875.64 87.525 875.04 87.0819 874.369 86.8867C871.303 85.9958 862.151 83.3367 856.928 81.8191Z"
                fill="url(#paint81_radial_BONEDMI)"
              />
            </g>
            <g id="C2" filter="url(#filter80_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M854.126 94.7163C853.041 94.4699 851.918 94.7468 851.008 95.4848C850.098 96.2229 849.477 97.3604 849.284 98.6427C848.974 100.705 848.614 103.105 848.303 105.174C848.109 106.468 848.367 107.799 849.019 108.864C849.671 109.93 850.661 110.64 851.764 110.831C858.674 112.029 872.84 114.486 884.561 116.519C886.063 116.78 887.504 115.72 887.966 114.016C888.427 112.312 887.774 110.464 886.422 109.65C879.46 105.461 872.167 101.073 868.516 98.8755C866.936 97.925 865.251 97.242 863.509 96.8466C860.968 96.2695 857.078 95.3865 854.126 94.7163Z"
                fill="url(#paint82_radial_BONEDMI)"
              />
            </g>
            <g id="C3" filter="url(#filter81_d_BONEDMI)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M851.876 113.301C850.773 113.162 849.661 113.554 848.789 114.39C847.918 115.225 847.36 116.435 847.24 117.746C847.039 119.947 846.803 122.524 846.604 124.701C846.362 127.356 847.945 129.719 850.174 130.03C856.968 130.98 871.119 132.959 882.467 134.545C883.956 134.753 885.378 133.671 885.848 131.969C886.318 130.268 885.703 128.432 884.384 127.603C878.921 124.167 873.088 120.499 869.084 117.981C865.785 115.907 862.173 114.6 858.439 114.129C856.285 113.857 853.87 113.553 851.876 113.301Z"
                fill="url(#paint83_radial_BONEDMI)"
              />
            </g>
            <g id="Group 75">
              <g id="C1_2" filter="url(#filter82_d_BONEDMI)">
                <path
                  d="M820.264 85.9299C820.264 84.9779 820.478 84.1239 820.908 83.3679C821.337 82.6026 821.92 82.0053 822.658 81.5759C823.404 81.1466 824.23 80.9319 825.136 80.9319C826.2 80.9319 827.128 81.1886 827.922 81.7019C828.715 82.2153 829.294 82.9433 829.658 83.8859H828.132C827.861 83.2979 827.469 82.8453 826.956 82.5279C826.452 82.2106 825.845 82.0519 825.136 82.0519C824.454 82.0519 823.843 82.2106 823.302 82.5279C822.76 82.8453 822.336 83.2979 822.028 83.8859C821.72 84.4646 821.566 85.1459 821.566 85.9299C821.566 86.7046 821.72 87.3859 822.028 87.9739C822.336 88.5526 822.76 89.0006 823.302 89.3179C823.843 89.6353 824.454 89.7939 825.136 89.7939C825.845 89.7939 826.452 89.6399 826.956 89.3319C827.469 89.0146 827.861 88.5619 828.132 87.9739H829.658C829.294 88.9073 828.715 89.6306 827.922 90.1439C827.128 90.6479 826.2 90.8999 825.136 90.8999C824.23 90.8999 823.404 90.6899 822.658 90.2699C821.92 89.8406 821.337 89.2479 820.908 88.4919C820.478 87.7359 820.264 86.8819 820.264 85.9299ZM831.008 81.8559V80.6939H833.64V90.8159H832.352V81.8559H831.008Z"
                  fill="#686868"
                />
              </g>
              <g id="C2_2" filter="url(#filter83_d_BONEDMI)">
                <path
                  d="M813.496 103.747C813.496 102.795 813.71 101.941 814.14 101.185C814.569 100.42 815.152 99.8224 815.89 99.3931C816.636 98.9637 817.462 98.7491 818.368 98.7491C819.432 98.7491 820.36 99.0057 821.154 99.5191C821.947 100.032 822.526 100.76 822.89 101.703H821.364C821.093 101.115 820.701 100.662 820.188 100.345C819.684 100.028 819.077 99.8691 818.368 99.8691C817.686 99.8691 817.075 100.028 816.534 100.345C815.992 100.662 815.568 101.115 815.26 101.703C814.952 102.282 814.798 102.963 814.798 103.747C814.798 104.522 814.952 105.203 815.26 105.791C815.568 106.37 815.992 106.818 816.534 107.135C817.075 107.452 817.686 107.611 818.368 107.611C819.077 107.611 819.684 107.457 820.188 107.149C820.701 106.832 821.093 106.379 821.364 105.791H822.89C822.526 106.724 821.947 107.448 821.154 107.961C820.36 108.465 819.432 108.717 818.368 108.717C817.462 108.717 816.636 108.507 815.89 108.087C815.152 107.658 814.569 107.065 814.14 106.309C813.71 105.553 813.496 104.699 813.496 103.747ZM824.422 107.611C825.608 106.659 826.536 105.88 827.208 105.273C827.88 104.657 828.445 104.018 828.902 103.355C829.369 102.683 829.602 102.025 829.602 101.381C829.602 100.774 829.453 100.298 829.154 99.9531C828.865 99.5984 828.394 99.4211 827.74 99.4211C827.106 99.4211 826.611 99.6217 826.256 100.023C825.911 100.415 825.724 100.942 825.696 101.605H824.464C824.502 100.56 824.819 99.7524 825.416 99.1831C826.014 98.6137 826.784 98.3291 827.726 98.3291C828.688 98.3291 829.448 98.5951 830.008 99.1271C830.578 99.6591 830.862 100.392 830.862 101.325C830.862 102.1 830.629 102.856 830.162 103.593C829.705 104.321 829.182 104.965 828.594 105.525C828.006 106.076 827.255 106.72 826.34 107.457H831.156V108.521H824.422V107.611Z"
                  fill="#686868"
                />
              </g>
              <g id="C3_2" filter="url(#filter84_d_BONEDMI)">
                <path
                  d="M810.909 121.689C810.909 120.737 811.124 119.883 811.553 119.127C811.983 118.362 812.566 117.764 813.303 117.335C814.05 116.906 814.876 116.691 815.781 116.691C816.845 116.691 817.774 116.948 818.567 117.461C819.361 117.974 819.939 118.702 820.303 119.645H818.777C818.507 119.057 818.115 118.604 817.601 118.287C817.097 117.97 816.491 117.811 815.781 117.811C815.1 117.811 814.489 117.97 813.947 118.287C813.406 118.604 812.981 119.057 812.673 119.645C812.365 120.224 812.211 120.905 812.211 121.689C812.211 122.464 812.365 123.145 812.673 123.733C812.981 124.312 813.406 124.76 813.947 125.077C814.489 125.394 815.1 125.553 815.781 125.553C816.491 125.553 817.097 125.399 817.601 125.091C818.115 124.774 818.507 124.321 818.777 123.733H820.303C819.939 124.666 819.361 125.39 818.567 125.903C817.774 126.407 816.845 126.659 815.781 126.659C814.876 126.659 814.05 126.449 813.303 126.029C812.566 125.6 811.983 125.007 811.553 124.251C811.124 123.495 810.909 122.641 810.909 121.689ZM821.962 119.001C822.027 118.142 822.359 117.47 822.956 116.985C823.553 116.5 824.328 116.257 825.28 116.257C825.915 116.257 826.461 116.374 826.918 116.607C827.385 116.831 827.735 117.139 827.968 117.531C828.211 117.923 828.332 118.366 828.332 118.861C828.332 119.44 828.164 119.939 827.828 120.359C827.501 120.779 827.072 121.05 826.54 121.171V121.241C827.147 121.39 827.627 121.684 827.982 122.123C828.337 122.562 828.514 123.136 828.514 123.845C828.514 124.377 828.393 124.858 828.15 125.287C827.907 125.707 827.543 126.038 827.058 126.281C826.573 126.524 825.989 126.645 825.308 126.645C824.319 126.645 823.507 126.388 822.872 125.875C822.237 125.352 821.883 124.615 821.808 123.663H823.04C823.105 124.223 823.334 124.68 823.726 125.035C824.118 125.39 824.641 125.567 825.294 125.567C825.947 125.567 826.442 125.399 826.778 125.063C827.123 124.718 827.296 124.274 827.296 123.733C827.296 123.033 827.063 122.529 826.596 122.221C826.129 121.913 825.425 121.759 824.482 121.759H824.16V120.695H824.496C825.355 120.686 826.003 120.546 826.442 120.275C826.881 119.995 827.1 119.566 827.1 118.987C827.1 118.492 826.937 118.096 826.61 117.797C826.293 117.498 825.835 117.349 825.238 117.349C824.659 117.349 824.193 117.498 823.838 117.797C823.483 118.096 823.273 118.497 823.208 119.001H821.962Z"
                  fill="#686868"
                />
              </g>
              <g id="C4_2" filter="url(#filter85_d_BONEDMI)">
                <path
                  d="M809.632 141.627C809.632 140.675 809.847 139.821 810.276 139.065C810.706 138.299 811.289 137.702 812.026 137.273C812.773 136.843 813.599 136.629 814.504 136.629C815.568 136.629 816.497 136.885 817.29 137.399C818.084 137.912 818.662 138.64 819.026 139.583H817.5C817.23 138.995 816.838 138.542 816.324 138.225C815.82 137.907 815.214 137.749 814.504 137.749C813.823 137.749 813.212 137.907 812.67 138.225C812.129 138.542 811.704 138.995 811.396 139.583C811.088 140.161 810.934 140.843 810.934 141.627C810.934 142.401 811.088 143.083 811.396 143.671C811.704 144.249 812.129 144.697 812.67 145.015C813.212 145.332 813.823 145.491 814.504 145.491C815.214 145.491 815.82 145.337 816.324 145.029C816.838 144.711 817.23 144.259 817.5 143.671H819.026C818.662 144.604 818.084 145.327 817.29 145.841C816.497 146.345 815.568 146.597 814.504 146.597C813.599 146.597 812.773 146.387 812.026 145.967C811.289 145.537 810.706 144.945 810.276 144.189C809.847 143.433 809.632 142.579 809.632 141.627ZM820.405 144.259V143.293L825.319 136.489H826.845V143.153H828.245V144.259H826.845V146.513H825.585V144.259H820.405ZM825.641 137.819L821.875 143.153H825.641V137.819Z"
                  fill="#686868"
                />
              </g>
              <g id="C5_2" filter="url(#filter86_d_BONEDMI)">
                <path
                  d="M810.636 161.56C810.636 160.608 810.851 159.754 811.28 158.998C811.709 158.233 812.293 157.636 813.03 157.206C813.777 156.777 814.603 156.562 815.508 156.562C816.572 156.562 817.501 156.819 818.294 157.332C819.087 157.846 819.666 158.574 820.03 159.516H818.504C818.233 158.928 817.841 158.476 817.328 158.158C816.824 157.841 816.217 157.682 815.508 157.682C814.827 157.682 814.215 157.841 813.674 158.158C813.133 158.476 812.708 158.928 812.4 159.516C812.092 160.095 811.938 160.776 811.938 161.56C811.938 162.335 812.092 163.016 812.4 163.604C812.708 164.183 813.133 164.631 813.674 164.948C814.215 165.266 814.827 165.424 815.508 165.424C816.217 165.424 816.824 165.27 817.328 164.962C817.841 164.645 818.233 164.192 818.504 163.604H820.03C819.666 164.538 819.087 165.261 818.294 165.774C817.501 166.278 816.572 166.53 815.508 166.53C814.603 166.53 813.777 166.32 813.03 165.9C812.293 165.471 811.709 164.878 811.28 164.122C810.851 163.366 810.636 162.512 810.636 161.56ZM828.171 157.43H823.257V160.622C823.471 160.324 823.789 160.081 824.209 159.894C824.629 159.698 825.081 159.6 825.567 159.6C826.341 159.6 826.971 159.764 827.457 160.09C827.942 160.408 828.287 160.823 828.493 161.336C828.707 161.84 828.815 162.377 828.815 162.946C828.815 163.618 828.689 164.22 828.437 164.752C828.185 165.284 827.797 165.704 827.275 166.012C826.761 166.32 826.122 166.474 825.357 166.474C824.377 166.474 823.583 166.222 822.977 165.718C822.37 165.214 822.001 164.542 821.871 163.702H823.117C823.238 164.234 823.495 164.65 823.887 164.948C824.279 165.247 824.773 165.396 825.371 165.396C826.108 165.396 826.663 165.177 827.037 164.738C827.41 164.29 827.597 163.702 827.597 162.974C827.597 162.246 827.41 161.686 827.037 161.294C826.663 160.893 826.113 160.692 825.385 160.692C824.89 160.692 824.456 160.814 824.083 161.056C823.719 161.29 823.453 161.612 823.285 162.022H822.081V156.31H828.171V157.43Z"
                  fill="#686868"
                />
              </g>
              <g id="C6_2" filter="url(#filter87_d_BONEDMI)">
                <path
                  d="M813.579 181.5C813.579 180.548 813.793 179.694 814.223 178.938C814.652 178.173 815.235 177.575 815.973 177.146C816.719 176.717 817.545 176.502 818.451 176.502C819.515 176.502 820.443 176.759 821.237 177.272C822.03 177.785 822.609 178.513 822.973 179.456H821.447C821.176 178.868 820.784 178.415 820.271 178.098C819.767 177.781 819.16 177.622 818.451 177.622C817.769 177.622 817.158 177.781 816.617 178.098C816.075 178.415 815.651 178.868 815.343 179.456C815.035 180.035 814.881 180.716 814.881 181.5C814.881 182.275 815.035 182.956 815.343 183.544C815.651 184.123 816.075 184.571 816.617 184.888C817.158 185.205 817.769 185.364 818.451 185.364C819.16 185.364 819.767 185.21 820.271 184.902C820.784 184.585 821.176 184.132 821.447 183.544H822.973C822.609 184.477 822.03 185.201 821.237 185.714C820.443 186.218 819.515 186.47 818.451 186.47C817.545 186.47 816.719 186.26 815.973 185.84C815.235 185.411 814.652 184.818 814.223 184.062C813.793 183.306 813.579 182.452 813.579 181.5ZM830.301 178.672C830.096 177.636 829.457 177.118 828.383 177.118C827.553 177.118 826.932 177.44 826.521 178.084C826.111 178.719 825.91 179.769 825.919 181.234C826.134 180.749 826.489 180.371 826.983 180.1C827.487 179.82 828.047 179.68 828.663 179.68C829.625 179.68 830.39 179.979 830.959 180.576C831.538 181.173 831.827 181.999 831.827 183.054C831.827 183.689 831.701 184.258 831.449 184.762C831.207 185.266 830.833 185.667 830.329 185.966C829.835 186.265 829.233 186.414 828.523 186.414C827.562 186.414 826.811 186.199 826.269 185.77C825.728 185.341 825.35 184.748 825.135 183.992C824.921 183.236 824.813 182.303 824.813 181.192C824.813 177.767 826.008 176.054 828.397 176.054C829.312 176.054 830.031 176.301 830.553 176.796C831.076 177.291 831.384 177.916 831.477 178.672H830.301ZM828.397 180.758C827.996 180.758 827.618 180.842 827.263 181.01C826.909 181.169 826.619 181.416 826.395 181.752C826.181 182.079 826.073 182.48 826.073 182.956C826.073 183.665 826.279 184.244 826.689 184.692C827.1 185.131 827.688 185.35 828.453 185.35C829.107 185.35 829.625 185.149 830.007 184.748C830.399 184.337 830.595 183.787 830.595 183.096C830.595 182.368 830.409 181.799 830.035 181.388C829.662 180.968 829.116 180.758 828.397 180.758Z"
                  fill="#686868"
                />
              </g>
              <g id="C7_2" filter="url(#filter88_d_BONEDMI)">
                <path
                  d="M818.685 199.444C818.685 198.492 818.899 197.638 819.329 196.882C819.758 196.117 820.341 195.52 821.079 195.09C821.825 194.661 822.651 194.446 823.557 194.446C824.621 194.446 825.549 194.703 826.343 195.216C827.136 195.73 827.715 196.458 828.079 197.4H826.553C826.282 196.812 825.89 196.36 825.377 196.042C824.873 195.725 824.266 195.566 823.557 195.566C822.875 195.566 822.264 195.725 821.723 196.042C821.181 196.36 820.757 196.812 820.449 197.4C820.141 197.979 819.987 198.66 819.987 199.444C819.987 200.219 820.141 200.9 820.449 201.488C820.757 202.067 821.181 202.515 821.723 202.832C822.264 203.15 822.875 203.308 823.557 203.308C824.266 203.308 824.873 203.154 825.377 202.846C825.89 202.529 826.282 202.076 826.553 201.488H828.079C827.715 202.422 827.136 203.145 826.343 203.658C825.549 204.162 824.621 204.414 823.557 204.414C822.651 204.414 821.825 204.204 821.079 203.784C820.341 203.355 819.758 202.762 819.329 202.006C818.899 201.25 818.685 200.396 818.685 199.444ZM835.995 195.202L832.103 204.33H830.815L834.763 195.328H829.359V194.236H835.995V195.202Z"
                  fill="#686868"
                />
              </g>
              <g id="T1_2" filter="url(#filter89_d_BONEDMI)">
                <path
                  d="M836.82 213.51V214.546H834.16V223.268H832.886V214.546H830.212V213.51H836.82ZM837.842 214.308V213.146H840.474V223.268H839.186V214.308H837.842Z"
                  fill="#686868"
                />
              </g>
              <g id="T2_2" filter="url(#filter90_d_BONEDMI)">
                <path
                  d="M838.015 231.453V232.489H835.355V241.211H834.081V232.489H831.407V231.453H838.015ZM839.219 240.189C840.405 239.237 841.333 238.458 842.005 237.851C842.677 237.235 843.242 236.596 843.699 235.933C844.166 235.261 844.399 234.603 844.399 233.959C844.399 233.353 844.25 232.877 843.951 232.531C843.662 232.177 843.191 231.999 842.537 231.999C841.903 231.999 841.408 232.2 841.053 232.601C840.708 232.993 840.521 233.521 840.493 234.183H839.261C839.299 233.138 839.616 232.331 840.213 231.761C840.811 231.192 841.581 230.907 842.523 230.907C843.485 230.907 844.245 231.173 844.805 231.705C845.375 232.237 845.659 232.97 845.659 233.903C845.659 234.678 845.426 235.434 844.959 236.171C844.502 236.899 843.979 237.543 843.391 238.103C842.803 238.654 842.052 239.298 841.137 240.035H845.953V241.099H839.219V240.189Z"
                  fill="#686868"
                />
              </g>
              <g id="T3_2" filter="url(#filter91_d_BONEDMI)">
                <path
                  d="M843.17 248.852V249.888H840.51V258.61H839.236V249.888H836.562V248.852H843.17ZM844.5 251.036C844.565 250.177 844.897 249.505 845.494 249.02C846.091 248.535 846.866 248.292 847.818 248.292C848.453 248.292 848.999 248.409 849.456 248.642C849.923 248.866 850.273 249.174 850.506 249.566C850.749 249.958 850.87 250.401 850.87 250.896C850.87 251.475 850.702 251.974 850.366 252.394C850.039 252.814 849.61 253.085 849.078 253.206V253.276C849.685 253.425 850.165 253.719 850.52 254.158C850.875 254.597 851.052 255.171 851.052 255.88C851.052 256.412 850.931 256.893 850.688 257.322C850.445 257.742 850.081 258.073 849.596 258.316C849.111 258.559 848.527 258.68 847.846 258.68C846.857 258.68 846.045 258.423 845.41 257.91C844.775 257.387 844.421 256.65 844.346 255.698H845.578C845.643 256.258 845.872 256.715 846.264 257.07C846.656 257.425 847.179 257.602 847.832 257.602C848.485 257.602 848.98 257.434 849.316 257.098C849.661 256.753 849.834 256.309 849.834 255.768C849.834 255.068 849.601 254.564 849.134 254.256C848.667 253.948 847.963 253.794 847.02 253.794H846.698V252.73H847.034C847.893 252.721 848.541 252.581 848.98 252.31C849.419 252.03 849.638 251.601 849.638 251.022C849.638 250.527 849.475 250.131 849.148 249.832C848.831 249.533 848.373 249.384 847.776 249.384C847.197 249.384 846.731 249.533 846.376 249.832C846.021 250.131 845.811 250.532 845.746 251.036H844.5Z"
                  fill="#686868"
                />
              </g>
              <g id="T4_2" filter="url(#filter92_d_BONEDMI)">
                <path
                  d="M849.118 267.339V268.375H846.458V277.097H845.184V268.375H842.51V267.339H849.118ZM850.168 274.843V273.877L855.082 267.073H856.608V273.737H858.008V274.843H856.608V277.097H855.348V274.843H850.168ZM855.404 268.403L851.638 273.737H855.404V268.403Z"
                  fill="#686868"
                />
              </g>
              <g id="T5_2" filter="url(#filter93_d_BONEDMI)">
                <path
                  d="M849.955 284.194V285.23H847.295V293.952H846.021V285.23H843.347V284.194H849.955ZM857.767 284.936H852.853V288.128C853.068 287.829 853.385 287.587 853.805 287.4C854.225 287.204 854.678 287.106 855.163 287.106C855.938 287.106 856.568 287.269 857.053 287.596C857.539 287.913 857.884 288.329 858.089 288.842C858.304 289.346 858.411 289.883 858.411 290.452C858.411 291.124 858.285 291.726 858.033 292.258C857.781 292.79 857.394 293.21 856.871 293.518C856.358 293.826 855.719 293.98 854.953 293.98C853.973 293.98 853.18 293.728 852.573 293.224C851.967 292.72 851.598 292.048 851.467 291.208H852.713C852.835 291.74 853.091 292.155 853.483 292.454C853.875 292.753 854.37 292.902 854.967 292.902C855.705 292.902 856.26 292.683 856.633 292.244C857.007 291.796 857.193 291.208 857.193 290.48C857.193 289.752 857.007 289.192 856.633 288.8C856.26 288.399 855.709 288.198 854.981 288.198C854.487 288.198 854.053 288.319 853.679 288.562C853.315 288.795 853.049 289.117 852.881 289.528H851.677V283.816H857.767V284.936Z"
                  fill="#686868"
                />
              </g>
              <g id="T6_2" filter="url(#filter94_d_BONEDMI)">
                <path
                  d="M849.532 302.503V303.539H846.872V312.261H845.598V303.539H842.924V302.503H849.532ZM856.532 304.547C856.327 303.511 855.688 302.993 854.614 302.993C853.784 302.993 853.163 303.315 852.752 303.959C852.342 304.594 852.141 305.644 852.15 307.109C852.365 306.624 852.72 306.246 853.214 305.975C853.718 305.695 854.278 305.555 854.894 305.555C855.856 305.555 856.621 305.854 857.19 306.451C857.769 307.048 858.058 307.874 858.058 308.929C858.058 309.564 857.932 310.133 857.68 310.637C857.438 311.141 857.064 311.542 856.56 311.841C856.066 312.14 855.464 312.289 854.754 312.289C853.793 312.289 853.042 312.074 852.5 311.645C851.959 311.216 851.581 310.623 851.366 309.867C851.152 309.111 851.044 308.178 851.044 307.067C851.044 303.642 852.239 301.929 854.628 301.929C855.543 301.929 856.262 302.176 856.784 302.671C857.307 303.166 857.615 303.791 857.708 304.547H856.532ZM854.628 306.633C854.227 306.633 853.849 306.717 853.494 306.885C853.14 307.044 852.85 307.291 852.626 307.627C852.412 307.954 852.304 308.355 852.304 308.831C852.304 309.54 852.51 310.119 852.92 310.567C853.331 311.006 853.919 311.225 854.684 311.225C855.338 311.225 855.856 311.024 856.238 310.623C856.63 310.212 856.826 309.662 856.826 308.971C856.826 308.243 856.64 307.674 856.266 307.263C855.893 306.843 855.347 306.633 854.628 306.633Z"
                  fill="#686868"
                />
              </g>
              <g id="T7_2" filter="url(#filter95_d_BONEDMI)">
                <path
                  d="M849.582 325.792V326.828H846.922V335.55H845.648V326.828H842.974V325.792H849.582ZM857.17 326.422L853.278 335.55H851.99L855.938 326.548H850.534V325.456H857.17V326.422Z"
                  fill="#686868"
                />
              </g>
              <g id="T8_2" filter="url(#filter96_d_BONEDMI)">
                <path
                  d="M847.126 348.152V349.188H844.466V357.91H843.192V349.188H840.518V348.152H847.126ZM850.332 352.646C849.809 352.44 849.408 352.142 849.128 351.75C848.848 351.358 848.708 350.882 848.708 350.322C848.708 349.818 848.834 349.365 849.086 348.964C849.338 348.553 849.711 348.231 850.206 347.998C850.71 347.755 851.316 347.634 852.026 347.634C852.735 347.634 853.337 347.755 853.832 347.998C854.336 348.231 854.714 348.553 854.966 348.964C855.227 349.365 855.358 349.818 855.358 350.322C855.358 350.863 855.213 351.339 854.924 351.75C854.634 352.151 854.238 352.45 853.734 352.646C854.312 352.823 854.77 353.136 855.106 353.584C855.451 354.022 855.624 354.554 855.624 355.18C855.624 355.786 855.474 356.318 855.176 356.776C854.877 357.224 854.452 357.574 853.902 357.826C853.36 358.068 852.735 358.19 852.026 358.19C851.316 358.19 850.691 358.068 850.15 357.826C849.618 357.574 849.202 357.224 848.904 356.776C848.605 356.318 848.456 355.786 848.456 355.18C848.456 354.554 848.624 354.018 848.96 353.57C849.296 353.122 849.753 352.814 850.332 352.646ZM854.126 350.476C854.126 349.906 853.939 349.468 853.566 349.16C853.192 348.852 852.679 348.698 852.026 348.698C851.382 348.698 850.873 348.852 850.5 349.16C850.126 349.468 849.94 349.911 849.94 350.49C849.94 351.012 850.131 351.432 850.514 351.75C850.906 352.067 851.41 352.226 852.026 352.226C852.651 352.226 853.155 352.067 853.538 351.75C853.93 351.423 854.126 350.998 854.126 350.476ZM852.026 353.206C851.335 353.206 850.77 353.369 850.332 353.696C849.893 354.013 849.674 354.494 849.674 355.138C849.674 355.735 849.884 356.216 850.304 356.58C850.733 356.944 851.307 357.126 852.026 357.126C852.744 357.126 853.314 356.944 853.734 356.58C854.154 356.216 854.364 355.735 854.364 355.138C854.364 354.512 854.149 354.036 853.72 353.71C853.29 353.374 852.726 353.206 852.026 353.206Z"
                  fill="#686868"
                />
              </g>
              <g id="T9_2" filter="url(#filter97_d_BONEDMI)">
                <path
                  d="M841.434 370.549V371.585H838.774V380.307H837.5V371.585H834.826V370.549H841.434ZM844.43 377.591C844.523 378.123 844.738 378.534 845.074 378.823C845.419 379.113 845.881 379.257 846.46 379.257C847.235 379.257 847.804 378.954 848.168 378.347C848.541 377.741 848.719 376.719 848.7 375.281C848.504 375.701 848.177 376.033 847.72 376.275C847.263 376.509 846.754 376.625 846.194 376.625C845.569 376.625 845.009 376.499 844.514 376.247C844.029 375.986 843.646 375.608 843.366 375.113C843.086 374.619 842.946 374.021 842.946 373.321C842.946 372.323 843.235 371.52 843.814 370.913C844.393 370.297 845.214 369.989 846.278 369.989C847.585 369.989 848.499 370.414 849.022 371.263C849.554 372.113 849.82 373.377 849.82 375.057C849.82 376.233 849.713 377.204 849.498 377.969C849.293 378.735 848.938 379.318 848.434 379.719C847.939 380.121 847.258 380.321 846.39 380.321C845.438 380.321 844.696 380.065 844.164 379.551C843.632 379.038 843.329 378.385 843.254 377.591H844.43ZM846.404 375.547C847.029 375.547 847.543 375.356 847.944 374.973C848.345 374.581 848.546 374.054 848.546 373.391C848.546 372.691 848.35 372.127 847.958 371.697C847.566 371.268 847.015 371.053 846.306 371.053C845.653 371.053 845.13 371.259 844.738 371.669C844.355 372.08 844.164 372.621 844.164 373.293C844.164 373.975 844.355 374.521 844.738 374.931C845.121 375.342 845.676 375.547 846.404 375.547Z"
                  fill="#686868"
                />
              </g>
              <g id="T10_2" filter="url(#filter98_d_BONEDMI)">
                <path
                  d="M831.422 392.6V393.636H828.762V402.358H827.488V393.636H824.814V392.6H831.422ZM832.444 393.398V392.236H835.076V402.358H833.788V393.398H832.444ZM837.264 397.192C837.264 395.586 837.526 394.336 838.048 393.44C838.571 392.534 839.486 392.082 840.792 392.082C842.09 392.082 843 392.534 843.522 393.44C844.045 394.336 844.306 395.586 844.306 397.192C844.306 398.825 844.045 400.094 843.522 401C843 401.905 842.09 402.358 840.792 402.358C839.486 402.358 838.571 401.905 838.048 401C837.526 400.094 837.264 398.825 837.264 397.192ZM843.046 397.192C843.046 396.38 842.99 395.694 842.878 395.134C842.776 394.564 842.556 394.107 842.22 393.762C841.894 393.416 841.418 393.244 840.792 393.244C840.158 393.244 839.672 393.416 839.336 393.762C839.01 394.107 838.79 394.564 838.678 395.134C838.576 395.694 838.524 396.38 838.524 397.192C838.524 398.032 838.576 398.736 838.678 399.306C838.79 399.875 839.01 400.332 839.336 400.678C839.672 401.023 840.158 401.196 840.792 401.196C841.418 401.196 841.894 401.023 842.22 400.678C842.556 400.332 842.776 399.875 842.878 399.306C842.99 398.736 843.046 398.032 843.046 397.192Z"
                  fill="#686868"
                />
              </g>
              <g id="T11_2" filter="url(#filter99_d_BONEDMI)">
                <path
                  d="M827.659 414.557V415.593H824.999V424.315H823.725V415.593H821.051V414.557H827.659ZM828.681 415.355V414.193H831.313V424.315H830.025V415.355H828.681ZM833.165 415.355V414.193H835.797V424.315H834.509V415.355H833.165Z"
                  fill="#686868"
                />
              </g>
              <g id="T12_2" filter="url(#filter100_d_BONEDMI)">
                <path
                  d="M819.55 437.64V438.676H816.89V447.398H815.616V438.676H812.942V437.64H819.55ZM820.572 438.438V437.276H823.204V447.398H821.916V438.438H820.572ZM825.239 446.376C826.424 445.424 827.353 444.645 828.025 444.038C828.697 443.422 829.261 442.783 829.719 442.12C830.185 441.448 830.419 440.79 830.419 440.146C830.419 439.539 830.269 439.063 829.971 438.718C829.681 438.363 829.21 438.186 828.557 438.186C827.922 438.186 827.427 438.387 827.073 438.788C826.727 439.18 826.541 439.707 826.513 440.37H825.281C825.318 439.325 825.635 438.517 826.233 437.948C826.83 437.379 827.6 437.094 828.543 437.094C829.504 437.094 830.265 437.36 830.825 437.892C831.394 438.424 831.679 439.157 831.679 440.09C831.679 440.865 831.445 441.621 830.979 442.358C830.521 443.086 829.999 443.73 829.411 444.29C828.823 444.841 828.071 445.485 827.157 446.222H831.973V447.286H825.239V446.376Z"
                  fill="#686868"
                />
              </g>
              <g id="L1_2" filter="url(#filter101_d_BONEDMI)">
                <path
                  d="M818.525 469.445H821.941V470.481H817.251V460.723H818.525V469.445ZM822.748 461.521V460.359H825.38V470.481H824.092V461.521H822.748Z"
                  fill="#686868"
                />
              </g>
              <g id="L2_2" filter="url(#filter102_d_BONEDMI)">
                <path
                  d="M809.479 493.308H812.895V494.344H808.205V484.586H809.479V493.308ZM813.884 493.322C815.07 492.37 815.998 491.591 816.67 490.984C817.342 490.368 817.907 489.729 818.364 489.066C818.831 488.394 819.064 487.736 819.064 487.092C819.064 486.486 818.915 486.01 818.616 485.664C818.327 485.31 817.856 485.132 817.202 485.132C816.568 485.132 816.073 485.333 815.718 485.734C815.373 486.126 815.186 486.654 815.158 487.316H813.926C813.964 486.271 814.281 485.464 814.878 484.894C815.476 484.325 816.246 484.04 817.188 484.04C818.15 484.04 818.91 484.306 819.47 484.838C820.04 485.37 820.324 486.103 820.324 487.036C820.324 487.811 820.091 488.567 819.624 489.304C819.167 490.032 818.644 490.676 818.056 491.236C817.468 491.787 816.717 492.431 815.802 493.168H820.618V494.232H813.884V493.322Z"
                  fill="#686868"
                />
              </g>
              <g id="L3_2" filter="url(#filter103_d_BONEDMI)">
                <path
                  d="M804.371 520.735H807.787V521.771H803.097V512.013H804.371V520.735ZM808.902 514.197C808.967 513.339 809.299 512.667 809.896 512.181C810.493 511.696 811.268 511.453 812.22 511.453C812.855 511.453 813.401 511.57 813.858 511.803C814.325 512.027 814.675 512.335 814.908 512.727C815.151 513.119 815.272 513.563 815.272 514.057C815.272 514.636 815.104 515.135 814.768 515.555C814.441 515.975 814.012 516.246 813.48 516.367V516.437C814.087 516.587 814.567 516.881 814.922 517.319C815.277 517.758 815.454 518.332 815.454 519.041C815.454 519.573 815.333 520.054 815.09 520.483C814.847 520.903 814.483 521.235 813.998 521.477C813.513 521.72 812.929 521.841 812.248 521.841C811.259 521.841 810.447 521.585 809.812 521.071C809.177 520.549 808.823 519.811 808.748 518.859H809.98C810.045 519.419 810.274 519.877 810.666 520.231C811.058 520.586 811.581 520.763 812.234 520.763C812.887 520.763 813.382 520.595 813.718 520.259C814.063 519.914 814.236 519.471 814.236 518.929C814.236 518.229 814.003 517.725 813.536 517.417C813.069 517.109 812.365 516.955 811.422 516.955H811.1V515.891H811.436C812.295 515.882 812.943 515.742 813.382 515.471C813.821 515.191 814.04 514.762 814.04 514.183C814.04 513.689 813.877 513.292 813.55 512.993C813.233 512.695 812.775 512.545 812.178 512.545C811.599 512.545 811.133 512.695 810.778 512.993C810.423 513.292 810.213 513.693 810.148 514.197H808.902Z"
                  fill="#686868"
                />
              </g>
              <g id="L4_2" filter="url(#filter104_d_BONEDMI)">
                <path
                  d="M800.916 549.193H804.332V550.229H799.642V540.471H800.916V549.193ZM805.167 547.975V547.009L810.081 540.205H811.607V546.869H813.007V547.975H811.607V550.229H810.347V547.975H805.167ZM810.403 541.535L806.637 546.869H810.403V541.535Z"
                  fill="#686868"
                />
              </g>
              <g id="L5_2" filter="url(#filter105_d_BONEDMI)">
                <path
                  d="M804.597 580.433H808.013V581.469H803.323V571.711H804.597V580.433ZM815.61 572.453H810.696V575.645C810.911 575.346 811.228 575.103 811.648 574.917C812.068 574.721 812.521 574.623 813.006 574.623C813.781 574.623 814.411 574.786 814.896 575.113C815.382 575.43 815.727 575.845 815.932 576.359C816.147 576.863 816.254 577.399 816.254 577.969C816.254 578.641 816.128 579.243 815.876 579.775C815.624 580.307 815.237 580.727 814.714 581.035C814.201 581.343 813.562 581.497 812.796 581.497C811.816 581.497 811.023 581.245 810.416 580.741C809.81 580.237 809.441 579.565 809.31 578.725H810.556C810.678 579.257 810.934 579.672 811.326 579.971C811.718 580.269 812.213 580.419 812.81 580.419C813.548 580.419 814.103 580.199 814.476 579.761C814.85 579.313 815.036 578.725 815.036 577.997C815.036 577.269 814.85 576.709 814.476 576.317C814.103 575.915 813.552 575.715 812.824 575.715C812.33 575.715 811.896 575.836 811.522 576.079C811.158 576.312 810.892 576.634 810.724 577.045H809.52V571.333H815.61V572.453Z"
                  fill="#686868"
                />
              </g>
            </g>
          </g>
          <g id="Group 84">
            <g id="Femur-Right-Front" filter="url(#filter106_d_BONEDMI)">
              <path
                d="M151.092 587.399C145.565 591.527 145.166 596.431 144.796 600.965C144.47 604.968 144.168 608.681 140.381 611.314C140.381 611.314 119.967 600.388 114.479 627.302C113.457 632.305 115.017 635.23 117.758 640.37C121.786 647.922 128.363 660.255 133.046 690.983L135.813 731.533L159.192 732.921C159.192 732.921 145.856 678.063 150.02 657.11C150.679 653.791 151.206 650.748 151.686 647.967L151.687 647.965C154.095 634.034 156.547 625.743 167.76 623.307C166.385 618.488 164.247 612.429 160.996 609.962L160.999 609.964C161.022 609.976 161.046 609.988 161.069 609.999C160.802 609.797 160.525 609.58 160.239 609.344C159.673 608.878 158.966 606.565 158.243 604.2L158.213 604.103L158.22 604.1C157.963 603.267 157.389 601.474 156.536 599.19C155.047 595.285 153.196 591.298 151.092 587.399Z"
                fill="url(#paint84_radial_BONEDMI)"
              />
            </g>
            <g id="Femur-Left-Front" filter="url(#filter107_d_BONEDMI)">
              <path
                d="M290.535 587.399C296.061 591.527 296.461 596.431 296.83 600.965C297.156 604.968 297.459 608.681 301.246 611.314C301.246 611.314 321.659 600.388 327.148 627.302C328.17 632.305 326.609 635.23 323.868 640.37C319.841 647.922 313.263 660.255 308.581 690.983L305.814 731.533L282.434 732.921C282.434 732.921 295.771 678.063 291.607 657.11C290.947 653.791 290.421 650.748 289.94 647.967L289.94 647.965C287.532 634.034 285.08 625.743 273.867 623.307C275.242 618.488 277.38 612.429 280.631 609.962L280.628 609.964C280.605 609.976 280.581 609.988 280.557 609.999C280.825 609.797 281.101 609.58 281.388 609.344C281.954 608.878 282.661 606.565 283.384 604.2L283.414 604.103L283.407 604.1C283.663 603.267 284.238 601.474 285.09 599.19C286.58 595.285 288.431 591.298 290.535 587.399Z"
                fill="url(#paint85_radial_BONEDMI)"
              />
            </g>
            <g id="Ilium-Right-Front" filter="url(#filter108_d_BONEDMI)">
              <path
                d="M179.07 517.903C215.038 535.538 201.492 561.151 193.076 577.063C192.997 577.212 192.919 577.361 192.84 577.51C190.301 582.304 187.619 587.368 188.055 592.747L158.243 604.098C154.299 591.194 145.646 576.486 136.579 566.718C123.98 553.144 137.021 497.308 179.07 517.903Z"
                fill="url(#paint86_radial_BONEDMI)"
              />
            </g>
            <g id="Ilium-Left-Front" filter="url(#filter109_d_BONEDMI)">
              <path
                d="M262.557 517.903C226.588 535.538 240.135 561.151 248.551 577.063C248.629 577.212 248.708 577.361 248.787 577.51C251.326 582.304 254.008 587.368 253.572 592.747L283.383 604.098C287.328 591.194 295.981 576.486 305.048 566.718C317.647 553.144 304.605 497.308 262.557 517.903Z"
                fill="url(#paint87_radial_BONEDMI)"
              />
            </g>
            <g id="Ischium-Left-Front" filter="url(#filter110_d_BONEDMI)">
              <path
                d="M161.108 610.011C161.078 609.997 161.048 609.982 161.018 609.966L161.015 609.964C165.155 613.106 167.49 622.073 168.743 626.886C168.767 626.976 168.79 627.065 168.813 627.153C169.304 629.039 169.858 631.162 170.577 633.636C175.093 652.483 187.004 650.887 208.092 648.062L209.175 647.918C211.649 647.587 214.088 646.708 215.699 644.801L205.278 631.243L205.281 631.239L205.279 631.237C188.666 642.065 186.099 630.984 188.025 618.882C181.543 616.141 175.515 613.927 174.288 613.573C171.588 612.953 169.621 612.535 168.111 612.214C164.366 611.418 163.439 611.221 161.125 610.024C161.12 610.02 161.114 610.015 161.108 610.011Z"
                fill="url(#paint88_radial_BONEDMI)"
              />
            </g>
            <g id="Ischium-Right-Front" filter="url(#filter111_d_BONEDMI)">
              <path
                d="M280.519 610.011C280.549 609.997 280.579 609.982 280.609 609.966L280.612 609.964C276.472 613.106 274.137 622.073 272.884 626.886C272.86 626.976 272.837 627.065 272.814 627.153C272.323 629.039 271.769 631.162 271.051 633.636C266.534 652.483 254.623 650.887 233.535 648.062L232.452 647.918C229.978 647.587 227.539 646.708 225.928 644.801L236.349 631.243L236.347 631.239L236.348 631.237C252.961 642.065 255.528 630.984 253.602 618.882C260.084 616.141 266.112 613.927 267.339 613.573C270.039 612.953 272.006 612.535 273.516 612.214C277.261 611.418 278.188 611.221 280.502 610.024C280.507 610.02 280.513 610.015 280.519 610.011Z"
                fill="url(#paint89_radial_BONEDMI)"
              />
            </g>
            <g id="Pubis-Right-Front" filter="url(#filter112_d_BONEDMI)">
              <path
                d="M158.229 604.103L188.048 592.752C188.152 594.237 188.454 595.766 189.063 597.204C190.629 599.304 204.023 605.04 215.653 608.791C217.857 609.501 219.535 617.06 219.668 619.371C220.399 632.09 219.775 639.913 215.695 644.803L205.268 631.24C205.539 630.795 205.785 630.317 205.997 629.804C207.608 625.901 177.213 614.417 174.278 613.571C164.878 611.412 164.362 611.702 161.115 610.022C160.838 609.813 160.552 609.588 160.255 609.344C159.689 608.878 158.982 606.565 158.259 604.2L158.229 604.103Z"
                fill="url(#paint90_radial_BONEDMI)"
              />
            </g>
            <g id="Pubis-Left-Front" filter="url(#filter113_d_BONEDMI)">
              <path
                d="M283.398 604.103L253.579 592.752C253.474 594.237 253.173 595.766 252.563 597.204C250.998 599.304 237.604 605.04 225.973 608.791C223.77 609.501 222.091 617.06 221.959 619.371C221.228 632.09 221.851 639.913 225.932 644.803L236.359 631.24C236.088 630.795 235.842 630.317 235.63 629.804C234.019 625.901 264.414 614.417 267.349 613.571C276.749 611.412 277.265 611.702 280.512 610.022C280.789 609.813 281.075 609.588 281.371 609.344C281.938 608.878 282.645 606.565 283.368 604.2L283.398 604.103Z"
                fill="url(#paint91_radial_BONEDMI)"
              />
            </g>
          </g>
          <g id="Pubic-Bone-Left-Back" filter="url(#filter114_d_BONEDMI)">
            <path
              d="M540.861 651.845C543.199 651.227 545.888 649.921 549.173 647.593C560.991 639.22 560.602 616.642 552.027 619.741C538.666 624.573 535.574 613.832 535.574 613.832C535.574 613.832 535.49 613.923 535.333 614.096C535.226 616.269 535.05 618.543 534.87 620.854C533.908 633.255 532.863 646.723 542.096 651.306C542.096 651.306 541.648 651.535 540.861 651.845Z"
              fill="url(#paint92_radial_BONEDMI)"
            />
          </g>
          <g id="Pubic-Bone-Right-Back" filter="url(#filter115_d_BONEDMI)">
            <path
              d="M581.134 651.845C578.795 651.227 576.106 649.921 572.821 647.593C561.003 639.22 561.392 616.642 569.968 619.741C583.328 624.573 586.42 613.832 586.42 613.832C586.42 613.832 586.505 613.923 586.662 614.096C586.768 616.269 586.945 618.543 587.124 620.854C588.086 633.255 589.132 646.723 579.899 651.306C579.899 651.306 580.347 651.535 581.134 651.845Z"
              fill="url(#paint93_radial_BONEDMI)"
            />
          </g>
          <g id="Ilium-Left-Back" filter="url(#filter116_d_BONEDMI)">
            <path
              d="M489.461 593.968C489.696 587.849 503.538 587.308 513.864 592.357C517.624 594.195 521.038 594.579 523.991 594.868C522.85 592.354 522.709 589.279 524.616 584.703C525.475 582.639 526.743 580.211 528.156 577.504C536.518 561.482 549.978 535.691 514.238 517.934C472.458 497.196 459.499 553.42 472.018 567.088C480.428 576.269 486.428 587.551 489.461 593.968Z"
              fill="url(#paint94_radial_BONEDMI)"
            />
          </g>
          <g id="Ilium-Right-Back" filter="url(#filter117_d_BONEDMI)">
            <path
              d="M632.534 593.968C632.298 587.849 618.456 587.308 608.131 592.357C604.371 594.195 600.957 594.579 598.003 594.868C599.145 592.354 599.286 589.279 597.379 584.703C596.519 582.639 595.252 580.211 593.839 577.504C585.477 561.482 572.016 535.691 607.756 517.934C649.537 497.196 662.496 553.42 649.977 567.088C641.566 576.269 635.567 587.551 632.534 593.968Z"
              fill="url(#paint95_radial_BONEDMI)"
            />
          </g>
          <g id="Femur-Left-Back" filter="url(#filter118_d_BONEDMI)">
            <path
              d="M492.502 599.6C492.728 604.948 491.306 610.332 486.19 613.889C486.19 613.889 465.777 602.963 460.288 629.878C459.266 634.88 460.827 637.806 463.568 642.945C467.595 650.497 474.173 662.83 478.855 693.559L481.622 734.939L505.002 736.327C505.002 736.327 491.666 680.639 495.83 659.685C496.489 656.366 497.015 653.322 497.496 650.541C499.878 636.764 501.145 629.432 511.963 626.958C506.91 610.369 501.378 606.256 495.43 601.832C494.465 601.115 493.489 600.389 492.502 599.6Z"
              fill="url(#paint96_radial_BONEDMI)"
            />
          </g>
          <g id="Femur-Right-Back" filter="url(#filter119_d_BONEDMI)">
            <path
              d="M629.492 599.6C629.266 604.948 630.688 610.332 635.804 613.889C635.804 613.889 656.218 602.963 661.706 629.878C662.728 634.88 661.168 637.806 658.427 642.945C654.399 650.497 647.822 662.83 643.139 693.559L640.373 735.022L616.993 736.41C616.993 736.41 630.329 680.639 626.165 659.685C625.506 656.366 624.979 653.322 624.498 650.541C622.117 636.764 620.849 629.432 610.031 626.958C615.085 610.369 620.616 606.256 626.564 601.832C627.529 601.115 628.505 600.389 629.492 599.6Z"
              fill="url(#paint97_radial_BONEDMI)"
            />
          </g>
          <g id="Iscium-Left-Back" filter="url(#filter120_d_BONEDMI)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M491.18 598.413C483.916 588.302 501.447 586.278 513.88 592.357C524.839 597.715 532.86 590.715 535.101 605.026C537.214 618.523 528.512 644.555 542.113 651.306C542.113 651.306 520.551 662.343 513.88 634.587C507.208 606.831 500.221 606.44 491.18 598.413Z"
              fill="url(#paint98_radial_BONEDMI)"
            />
          </g>
          <g id="Iscium-Right-Back" filter="url(#filter121_d_BONEDMI)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M630.815 598.413C638.079 588.302 620.547 586.278 608.114 592.357C597.155 597.715 589.135 590.715 586.894 605.026C584.78 618.523 593.482 644.555 579.882 651.306C579.882 651.306 601.444 662.343 608.114 634.587C614.786 606.831 621.773 606.44 630.815 598.413Z"
              fill="url(#paint99_radial_BONEDMI)"
            />
          </g>
          <g id="Hand blur 3" filter="url(#filter122_f_BONEDMI)">
            <ellipse
              cx={700.256}
              cy={452.118}
              rx={33.4477}
              ry={54.7341}
              fill="white"
            />
          </g>
          <g id="Hand blur 2" filter="url(#filter123_f_BONEDMI)">
            <path
              d="M451.449 460.374C451.449 495.162 425.037 523.363 392.455 523.363C359.873 523.363 333.46 495.162 333.46 460.374C333.46 425.586 321.77 396.199 392.455 397.384C458.457 397.58 451.449 425.586 451.449 460.374Z"
              fill="white"
            />
          </g>
          <g filter="url(#filter124_d_BONEDMI)">
            <path
              d="M446.196 408.082C445.673 407.876 445.272 407.578 444.992 407.186C444.712 406.794 444.572 406.318 444.572 405.758C444.572 405.254 444.698 404.801 444.95 404.4C445.202 403.989 445.575 403.667 446.07 403.434C446.574 403.191 447.181 403.07 447.89 403.07C448.599 403.07 449.201 403.191 449.696 403.434C450.2 403.667 450.578 403.989 450.83 404.4C451.091 404.801 451.222 405.254 451.222 405.758C451.222 406.299 451.077 406.775 450.788 407.186C450.499 407.587 450.102 407.886 449.598 408.082C450.177 408.259 450.634 408.572 450.97 409.02C451.315 409.458 451.488 409.99 451.488 410.616C451.488 411.222 451.339 411.754 451.04 412.212C450.741 412.66 450.317 413.01 449.766 413.262C449.225 413.504 448.599 413.626 447.89 413.626C447.181 413.626 446.555 413.504 446.014 413.262C445.482 413.01 445.067 412.66 444.768 412.212C444.469 411.754 444.32 411.222 444.32 410.616C444.32 409.99 444.488 409.454 444.824 409.006C445.16 408.558 445.617 408.25 446.196 408.082ZM449.99 405.912C449.99 405.342 449.803 404.904 449.43 404.596C449.057 404.288 448.543 404.134 447.89 404.134C447.246 404.134 446.737 404.288 446.364 404.596C445.991 404.904 445.804 405.347 445.804 405.926C445.804 406.448 445.995 406.868 446.378 407.186C446.77 407.503 447.274 407.662 447.89 407.662C448.515 407.662 449.019 407.503 449.402 407.186C449.794 406.859 449.99 406.434 449.99 405.912ZM447.89 408.642C447.199 408.642 446.635 408.805 446.196 409.132C445.757 409.449 445.538 409.93 445.538 410.574C445.538 411.171 445.748 411.652 446.168 412.016C446.597 412.38 447.171 412.562 447.89 412.562C448.609 412.562 449.178 412.38 449.598 412.016C450.018 411.652 450.228 411.171 450.228 410.574C450.228 409.948 450.013 409.472 449.584 409.146C449.155 408.81 448.59 408.642 447.89 408.642Z"
              fill="#686868"
            />
          </g>
          <g filter="url(#filter125_d_BONEDMI)">
            <path
              d="M445.993 434.404C446.086 434.936 446.301 435.347 446.637 435.636C446.982 435.925 447.444 436.07 448.023 436.07C448.798 436.07 449.367 435.767 449.731 435.16C450.104 434.553 450.282 433.531 450.263 432.094C450.067 432.514 449.74 432.845 449.283 433.088C448.826 433.321 448.317 433.438 447.757 433.438C447.132 433.438 446.572 433.312 446.077 433.06C445.592 432.799 445.209 432.421 444.929 431.926C444.649 431.431 444.509 430.834 444.509 430.134C444.509 429.135 444.798 428.333 445.377 427.726C445.956 427.11 446.777 426.802 447.841 426.802C449.148 426.802 450.062 427.227 450.585 428.076C451.117 428.925 451.383 430.19 451.383 431.87C451.383 433.046 451.276 434.017 451.061 434.782C450.856 435.547 450.501 436.131 449.997 436.532C449.502 436.933 448.821 437.134 447.953 437.134C447.001 437.134 446.259 436.877 445.727 436.364C445.195 435.851 444.892 435.197 444.817 434.404H445.993ZM447.967 432.36C448.592 432.36 449.106 432.169 449.507 431.786C449.908 431.394 450.109 430.867 450.109 430.204C450.109 429.504 449.913 428.939 449.521 428.51C449.129 428.081 448.578 427.866 447.869 427.866C447.216 427.866 446.693 428.071 446.301 428.482C445.918 428.893 445.727 429.434 445.727 430.106C445.727 430.787 445.918 431.333 446.301 431.744C446.684 432.155 447.239 432.36 447.967 432.36Z"
              fill="#686868"
            />
          </g>
          <g filter="url(#filter126_d_BONEDMI)">
            <path
              d="M441.29 451.935V450.773H443.922V460.895H442.634V451.935H441.29ZM446.111 455.729C446.111 454.123 446.372 452.873 446.895 451.977C447.417 451.071 448.332 450.619 449.639 450.619C450.936 450.619 451.846 451.071 452.369 451.977C452.891 452.873 453.153 454.123 453.153 455.729C453.153 457.362 452.891 458.631 452.369 459.537C451.846 460.442 450.936 460.895 449.639 460.895C448.332 460.895 447.417 460.442 446.895 459.537C446.372 458.631 446.111 457.362 446.111 455.729ZM451.893 455.729C451.893 454.917 451.837 454.231 451.725 453.671C451.622 453.101 451.403 452.644 451.067 452.299C450.74 451.953 450.264 451.781 449.639 451.781C449.004 451.781 448.519 451.953 448.183 452.299C447.856 452.644 447.637 453.101 447.525 453.671C447.422 454.231 447.371 454.917 447.371 455.729C447.371 456.569 447.422 457.273 447.525 457.843C447.637 458.412 447.856 458.869 448.183 459.215C448.519 459.56 449.004 459.733 449.639 459.733C450.264 459.733 450.74 459.56 451.067 459.215C451.403 458.869 451.622 458.412 451.725 457.843C451.837 457.273 451.893 456.569 451.893 455.729Z"
              fill="#686868"
            />
          </g>
          <g filter="url(#filter127_d_BONEDMI)">
            <path
              d="M452.001 472.593V471.431H454.633V481.553H453.345V472.593H452.001ZM456.486 472.593V471.431H459.118V481.553H457.83V472.593H456.486Z"
              fill="#686868"
            />
          </g>
          <g filter="url(#filter128_d_BONEDMI)">
            <path
              d="M466.763 487.593V486.431H469.395V496.553H468.107V487.593H466.763ZM471.429 495.531C472.615 494.579 473.543 493.799 474.215 493.193C474.887 492.577 475.452 491.937 475.909 491.275C476.376 490.603 476.609 489.945 476.609 489.301C476.609 488.694 476.46 488.218 476.161 487.873C475.872 487.518 475.401 487.341 474.747 487.341C474.113 487.341 473.618 487.541 473.263 487.943C472.918 488.335 472.731 488.862 472.703 489.525H471.471C471.509 488.479 471.826 487.672 472.423 487.103C473.021 486.533 473.791 486.249 474.733 486.249C475.695 486.249 476.455 486.515 477.015 487.047C477.585 487.579 477.869 488.311 477.869 489.245C477.869 490.019 477.636 490.775 477.169 491.513C476.712 492.241 476.189 492.885 475.601 493.445C475.013 493.995 474.262 494.639 473.347 495.377H478.163V496.441H471.429V495.531Z"
              fill="#686868"
            />
          </g>
          <g id="Hand blur 1" filter="url(#filter129_f_BONEDMI)">
            <ellipse
              cx={85.573}
              cy={452.118}
              rx={33.4477}
              ry={54.7341}
              fill="white"
            />
          </g>
          <g id="Leg blur" filter="url(#filter130_f_BONEDMI)">
            <rect
              x={14}
              y={716.654}
              width={934.569}
              height={50.8068}
              fill="white"
            />
          </g>
          <g id="Group 29" filter="url(#filter131_d_BONEDMI)">
            <g filter="url(#filter132_d_BONEDMI)">
              <path
                d="M151.519 248.912V247.75H154.151V257.872H152.863V248.912H151.519Z"
                fill="#686868"
              />
            </g>
            <g filter="url(#filter133_d_BONEDMI)">
              <path
                d="M132.739 288.281C133.924 287.329 134.853 286.55 135.525 285.943C136.197 285.327 136.761 284.688 137.219 284.025C137.685 283.353 137.919 282.695 137.919 282.051C137.919 281.444 137.769 280.968 137.471 280.623C137.181 280.268 136.71 280.091 136.057 280.091C135.422 280.091 134.927 280.292 134.573 280.693C134.227 281.085 134.041 281.612 134.013 282.275H132.781C132.818 281.23 133.135 280.422 133.733 279.853C134.33 279.284 135.1 278.999 136.043 278.999C137.004 278.999 137.765 279.265 138.325 279.797C138.894 280.329 139.179 281.062 139.179 281.995C139.179 282.77 138.945 283.526 138.479 284.263C138.021 284.991 137.499 285.635 136.911 286.195C136.323 286.746 135.571 287.39 134.657 288.127H139.473V289.191H132.739V288.281Z"
                fill="#686868"
              />
            </g>
            <g filter="url(#filter134_d_BONEDMI)">
              <path
                d="M122.621 301.388C122.686 300.529 123.018 299.857 123.615 299.372C124.212 298.886 124.987 298.644 125.939 298.644C126.574 298.644 127.12 298.76 127.577 298.994C128.044 299.218 128.394 299.526 128.627 299.918C128.87 300.31 128.991 300.753 128.991 301.248C128.991 301.826 128.823 302.326 128.487 302.746C128.16 303.166 127.731 303.436 127.199 303.558V303.628C127.806 303.777 128.286 304.071 128.641 304.51C128.996 304.948 129.173 305.522 129.173 306.232C129.173 306.764 129.052 307.244 128.809 307.674C128.566 308.094 128.202 308.425 127.717 308.668C127.232 308.91 126.648 309.032 125.967 309.032C124.978 309.032 124.166 308.775 123.531 308.262C122.896 307.739 122.542 307.002 122.467 306.05H123.699C123.764 306.61 123.993 307.067 124.385 307.422C124.777 307.776 125.3 307.954 125.953 307.954C126.606 307.954 127.101 307.786 127.437 307.45C127.782 307.104 127.955 306.661 127.955 306.12C127.955 305.42 127.722 304.916 127.255 304.608C126.788 304.3 126.084 304.146 125.141 304.146H124.819V303.082H125.155C126.014 303.072 126.662 302.932 127.101 302.662C127.54 302.382 127.759 301.952 127.759 301.374C127.759 300.879 127.596 300.482 127.269 300.184C126.952 299.885 126.494 299.736 125.897 299.736C125.318 299.736 124.852 299.885 124.497 300.184C124.142 300.482 123.932 300.884 123.867 301.388H122.621Z"
                fill="#686868"
              />
            </g>
            <g filter="url(#filter135_d_BONEDMI)">
              <path
                d="M113.842 326.904V325.938L118.756 319.134H120.282V325.798H121.682V326.904H120.282V329.158H119.022V326.904H113.842ZM119.078 320.464L115.312 325.798H119.078V320.464Z"
                fill="#686868"
              />
            </g>
            <g filter="url(#filter136_d_BONEDMI)">
              <path
                d="M116.016 343.38H111.102V346.572C111.317 346.273 111.634 346.03 112.054 345.844C112.474 345.648 112.927 345.55 113.412 345.55C114.187 345.55 114.817 345.713 115.302 346.04C115.787 346.357 116.133 346.772 116.338 347.286C116.553 347.79 116.66 348.326 116.66 348.896C116.66 349.568 116.534 350.17 116.282 350.702C116.03 351.234 115.643 351.654 115.12 351.962C114.607 352.27 113.967 352.424 113.202 352.424C112.222 352.424 111.429 352.172 110.822 351.668C110.215 351.164 109.847 350.492 109.716 349.652H110.962C111.083 350.184 111.34 350.599 111.732 350.898C112.124 351.196 112.619 351.346 113.216 351.346C113.953 351.346 114.509 351.126 114.882 350.688C115.255 350.24 115.442 349.652 115.442 348.924C115.442 348.196 115.255 347.636 114.882 347.244C114.509 346.842 113.958 346.642 113.23 346.642C112.735 346.642 112.301 346.763 111.928 347.006C111.564 347.239 111.298 347.561 111.13 347.972H109.926V342.26H116.016V343.38Z"
                fill="#686868"
              />
            </g>
            <g filter="url(#filter137_d_BONEDMI)">
              <path
                d="M112.424 369.075C112.219 368.039 111.579 367.521 110.506 367.521C109.675 367.521 109.055 367.843 108.644 368.487C108.233 369.121 108.033 370.171 108.042 371.637C108.257 371.151 108.611 370.773 109.106 370.503C109.61 370.223 110.17 370.083 110.786 370.083C111.747 370.083 112.513 370.381 113.082 370.979C113.661 371.576 113.95 372.402 113.95 373.457C113.95 374.091 113.824 374.661 113.572 375.165C113.329 375.669 112.956 376.07 112.452 376.369C111.957 376.667 111.355 376.817 110.646 376.817C109.685 376.817 108.933 376.602 108.392 376.173C107.851 375.743 107.473 375.151 107.258 374.395C107.043 373.639 106.936 372.705 106.936 371.595C106.936 368.169 108.131 366.457 110.52 366.457C111.435 366.457 112.153 366.704 112.676 367.199C113.199 367.693 113.507 368.319 113.6 369.075H112.424ZM110.52 371.161C110.119 371.161 109.741 371.245 109.386 371.413C109.031 371.571 108.742 371.819 108.518 372.155C108.303 372.481 108.196 372.883 108.196 373.359C108.196 374.068 108.401 374.647 108.812 375.095C109.223 375.533 109.811 375.753 110.576 375.753C111.229 375.753 111.747 375.552 112.13 375.151C112.522 374.74 112.718 374.189 112.718 373.499C112.718 372.771 112.531 372.201 112.158 371.791C111.785 371.371 111.239 371.161 110.52 371.161Z"
                fill="#686868"
              />
            </g>
            <g filter="url(#filter138_d_BONEDMI)">
              <path
                d="M115.484 393.1L111.592 402.228H110.304L114.252 393.226H108.848V392.134H115.484V393.1Z"
                fill="#686868"
              />
            </g>
            <g id="8_2" filter="url(#filter139_d_BONEDMI)">
              <path
                d="M113.145 421.669C112.623 421.464 112.221 421.165 111.941 420.773C111.661 420.381 111.521 419.905 111.521 419.345C111.521 418.841 111.647 418.389 111.899 417.987C112.151 417.577 112.525 417.255 113.019 417.021C113.523 416.779 114.13 416.657 114.839 416.657C115.549 416.657 116.151 416.779 116.645 417.021C117.149 417.255 117.527 417.577 117.779 417.987C118.041 418.389 118.171 418.841 118.171 419.345C118.171 419.887 118.027 420.363 117.737 420.773C117.448 421.175 117.051 421.473 116.547 421.669C117.126 421.847 117.583 422.159 117.919 422.607C118.265 423.046 118.437 423.578 118.437 424.203C118.437 424.81 118.288 425.342 117.989 425.799C117.691 426.247 117.266 426.597 116.715 426.849C116.174 427.092 115.549 427.213 114.839 427.213C114.13 427.213 113.505 427.092 112.963 426.849C112.431 426.597 112.016 426.247 111.717 425.799C111.419 425.342 111.269 424.81 111.269 424.203C111.269 423.578 111.437 423.041 111.773 422.593C112.109 422.145 112.567 421.837 113.145 421.669ZM116.939 419.499C116.939 418.93 116.753 418.491 116.379 418.183C116.006 417.875 115.493 417.721 114.839 417.721C114.195 417.721 113.687 417.875 113.313 418.183C112.94 418.491 112.753 418.935 112.753 419.513C112.753 420.036 112.945 420.456 113.327 420.773C113.719 421.091 114.223 421.249 114.839 421.249C115.465 421.249 115.969 421.091 116.351 420.773C116.743 420.447 116.939 420.022 116.939 419.499ZM114.839 422.229C114.149 422.229 113.584 422.393 113.145 422.719C112.707 423.037 112.487 423.517 112.487 424.161C112.487 424.759 112.697 425.239 113.117 425.603C113.547 425.967 114.121 426.149 114.839 426.149C115.558 426.149 116.127 425.967 116.547 425.603C116.967 425.239 117.177 424.759 117.177 424.161C117.177 423.536 116.963 423.06 116.533 422.733C116.104 422.397 115.539 422.229 114.839 422.229Z"
                fill="#686868"
              />
            </g>
            <g id="9_2" filter="url(#filter140_d_BONEDMI)">
              <path
                d="M114.572 452.194C114.666 452.726 114.88 453.137 115.216 453.426C115.562 453.716 116.024 453.86 116.602 453.86C117.377 453.86 117.946 453.557 118.31 452.95C118.684 452.344 118.861 451.322 118.842 449.884C118.646 450.304 118.32 450.636 117.862 450.878C117.405 451.112 116.896 451.228 116.336 451.228C115.711 451.228 115.151 451.102 114.656 450.85C114.171 450.589 113.788 450.211 113.508 449.716C113.228 449.222 113.088 448.624 113.088 447.924C113.088 446.926 113.378 446.123 113.956 445.516C114.535 444.9 115.356 444.592 116.42 444.592C117.727 444.592 118.642 445.017 119.164 445.866C119.696 446.716 119.962 447.98 119.962 449.66C119.962 450.836 119.855 451.807 119.64 452.572C119.435 453.338 119.08 453.921 118.576 454.322C118.082 454.724 117.4 454.924 116.532 454.924C115.58 454.924 114.838 454.668 114.306 454.154C113.774 453.641 113.471 452.988 113.396 452.194H114.572ZM116.546 450.15C117.172 450.15 117.685 449.959 118.086 449.576C118.488 449.184 118.688 448.657 118.688 447.994C118.688 447.294 118.492 446.73 118.1 446.3C117.708 445.871 117.158 445.656 116.448 445.656C115.795 445.656 115.272 445.862 114.88 446.272C114.498 446.683 114.306 447.224 114.306 447.896C114.306 448.578 114.498 449.124 114.88 449.534C115.263 449.945 115.818 450.15 116.546 450.15Z"
                fill="#686868"
              />
            </g>
            <g id="10_2" filter="url(#filter141_d_BONEDMI)">
              <path
                d="M114.37 474.01V472.848H117.002V482.97H115.714V474.01H114.37ZM119.19 477.804C119.19 476.198 119.451 474.948 119.974 474.052C120.497 473.146 121.411 472.694 122.718 472.694C124.015 472.694 124.925 473.146 125.448 474.052C125.971 474.948 126.232 476.198 126.232 477.804C126.232 479.437 125.971 480.706 125.448 481.612C124.925 482.517 124.015 482.97 122.718 482.97C121.411 482.97 120.497 482.517 119.974 481.612C119.451 480.706 119.19 479.437 119.19 477.804ZM124.972 477.804C124.972 476.992 124.916 476.306 124.804 475.746C124.701 475.176 124.482 474.719 124.146 474.374C123.819 474.028 123.343 473.856 122.718 473.856C122.083 473.856 121.598 474.028 121.262 474.374C120.935 474.719 120.716 475.176 120.604 475.746C120.501 476.306 120.45 476.992 120.45 477.804C120.45 478.644 120.501 479.348 120.604 479.918C120.716 480.487 120.935 480.944 121.262 481.29C121.598 481.635 122.083 481.808 122.718 481.808C123.343 481.808 123.819 481.635 124.146 481.29C124.482 480.944 124.701 480.487 124.804 479.918C124.916 479.348 124.972 478.644 124.972 477.804Z"
                fill="#686868"
              />
            </g>
          </g>
        </g>
        <rect
          id="Rectangle 56"
          y={657.576}
          width={1024}
          height={110.588}
          fill="url(#paint100_linear_BONEDMI)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_BONEDMI"
          x={445.186}
          y={109.115}
          width={231.622}
          height={538.224}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5}
            result="effect1_foregroundBlur_BONEDMI"
          />
        </filter>
        <filter
          id="filter1_f_BONEDMI"
          x={342.431}
          y={45.0029}
          width={428.567}
          height={710.255}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5}
            result="effect1_foregroundBlur_BONEDMI"
          />
        </filter>
        <filter
          id="filter2_d_BONEDMI"
          x={444.879}
          y={385.321}
          width={152.772}
          height={146.815}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_BONEDMI"
          x={524.343}
          y={385.321}
          width={152.772}
          height={146.815}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_BONEDMI"
          x={366.794}
          y={241.858}
          width={126.182}
          height={258.739}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_BONEDMI"
          x={629.018}
          y={241.858}
          width={126.182}
          height={258.739}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_BONEDMI"
          x={515.182}
          y={17.2078}
          width={145.562}
          height={200.056}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_BONEDMI"
          x={459.608}
          y={17.2078}
          width={145.562}
          height={200.056}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d_BONEDMI"
          x={477.129}
          y={71.8644}
          width={166.097}
          height={149.953}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_d_BONEDMI"
          x={419.247}
          y={309.979}
          width={172.275}
          height={164.309}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter10_d_BONEDMI"
          x={530.472}
          y={309.979}
          width={172.275}
          height={164.309}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter11_d_BONEDMI"
          x={422.453}
          y={330.28}
          width={172.275}
          height={164.508}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter12_d_BONEDMI"
          x={527.267}
          y={330.28}
          width={172.275}
          height={164.508}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter13_d_BONEDMI"
          x={426.727}
          y={347.377}
          width={171.207}
          height={164.808}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter14_d_BONEDMI"
          x={524.061}
          y={347.377}
          width={171.207}
          height={164.808}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter15_d_BONEDMI"
          x={431.001}
          y={368.746}
          width={166.932}
          height={153.042}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter16_d_BONEDMI"
          x={524.061}
          y={368.746}
          width={166.932}
          height={153.042}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter17_d_BONEDMI"
          x={395.74}
          y={230.586}
          width={176.549}
          height={212.878}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter18_d_BONEDMI"
          x={549.705}
          y={230.586}
          width={176.549}
          height={212.878}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter19_f_BONEDMI"
          x={91.4989}
          y={129.773}
          width={263.375}
          height={520.388}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5}
            result="effect1_foregroundBlur_BONEDMI"
          />
        </filter>
        <filter
          id="filter20_f_BONEDMI"
          x={4}
          y={40.7297}
          width={428.567}
          height={710.255}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5}
            result="effect1_foregroundBlur_BONEDMI"
          />
        </filter>
        <filter
          id="filter21_d_BONEDMI"
          x={28.7229}
          y={236.415}
          width={132.886}
          height={267.59}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter22_d_BONEDMI"
          x={284.765}
          y={236.415}
          width={132.885}
          height={267.589}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter23_d_BONEDMI"
          x={135.173}
          y={119.89}
          width={177.26}
          height={152.341}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter24_d_BONEDMI"
          x={154.726}
          y={138.126}
          width={135.029}
          height={115.008}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter25_d_BONEDMI"
          x={121.151}
          y={16.1395}
          width={201.666}
          height={221.282}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter26_d_BONEDMI"
          x={152.083}
          y={118.39}
          width={97.5064}
          height={112.859}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.27403} />
          <feGaussianBlur stdDeviation={22.9729} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter27_d_BONEDMI"
          x={144.951}
          y={130.918}
          width={96.9272}
          height={120.118}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.27403} />
          <feGaussianBlur stdDeviation={22.9729} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter28_d_BONEDMI"
          x={205.592}
          y={131.206}
          width={96.9271}
          height={120.117}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.27403} />
          <feGaussianBlur stdDeviation={22.9729} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter29_d_BONEDMI"
          x={194.407}
          y={118.366}
          width={97.5061}
          height={112.859}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.27403} />
          <feGaussianBlur stdDeviation={22.9729} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter30_d_BONEDMI"
          x={92.0884}
          y={419.125}
          width={137.364}
          height={115.903}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter31_d_BONEDMI"
          x={216.394}
          y={419.125}
          width={137.364}
          height={115.903}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter32_d_BONEDMI"
          x={87.2339}
          y={385.489}
          width={157.286}
          height={136.154}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter33_d_BONEDMI"
          x={201.326}
          y={385.489}
          width={157.286}
          height={136.154}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter34_d_BONEDMI"
          x={84.6586}
          y={364.002}
          width={171.198}
          height={139.42}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter35_d_BONEDMI"
          x={189.991}
          y={364.002}
          width={171.198}
          height={139.42}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter36_d_BONEDMI"
          x={82.274}
          y={344.299}
          width={181.83}
          height={138.211}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter37_d_BONEDMI"
          x={181.743}
          y={344.299}
          width={181.83}
          height={138.211}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter38_d_BONEDMI"
          x={80.9633}
          y={324.921}
          width={184.85}
          height={132.573}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter39_d_BONEDMI"
          x={180.033}
          y={324.921}
          width={184.85}
          height={132.573}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter40_d_BONEDMI"
          x={80.8193}
          y={299.861}
          width={183.126}
          height={132.291}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter41_d_BONEDMI"
          x={181.902}
          y={299.861}
          width={183.126}
          height={132.291}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter42_d_BONEDMI"
          x={85.7931}
          y={273.837}
          width={178.148}
          height={135.767}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter43_d_BONEDMI"
          x={181.905}
          y={273.837}
          width={178.148}
          height={135.767}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter44_d_BONEDMI"
          x={94.5067}
          y={256.917}
          width={163.259}
          height={129.956}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter45_d_BONEDMI"
          x={188.081}
          y={256.917}
          width={163.259}
          height={129.956}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter46_d_BONEDMI"
          x={106.012}
          y={234.696}
          width={159.023}
          height={131.48}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter47_d_BONEDMI"
          x={180.811}
          y={234.654}
          width={159.023}
          height={131.521}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter48_d_BONEDMI"
          x={123.419}
          y={209.449}
          width={136.916}
          height={137.085}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter49_d_BONEDMI"
          x={185.512}
          y={209.449}
          width={136.883}
          height={137.085}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter50_d_BONEDMI"
          x={76.0718}
          y={220.973}
          width={185.081}
          height={111.355}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter51_d_BONEDMI"
          x={184.694}
          y={220.973}
          width={185.081}
          height={111.355}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter52_d_BONEDMI"
          x={161.19}
          y={237.234}
          width={123.466}
          height={223.206}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter53_i_BONEDMI"
          x={199.811}
          y={181.701}
          width={44.861}
          height={14.5524}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={2.87272} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_BONEDMI"
          />
        </filter>
        <filter
          id="filter54_f_BONEDMI"
          x={826.746}
          y={549.035}
          width={67.1746}
          height={189.259}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={6}
            result="effect1_foregroundBlur_BONEDMI"
          />
        </filter>
        <filter
          id="filter55_f_BONEDMI"
          x={754.267}
          y={201.846}
          width={168.539}
          height={468.553}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={6.41104}
            result="effect1_foregroundBlur_BONEDMI"
          />
        </filter>
        <filter
          id="filter56_f_BONEDMI"
          x={737.69}
          y={-53.7681}
          width={220.879}
          height={831.932}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5}
            result="effect1_foregroundBlur_BONEDMI"
          />
        </filter>
        <filter
          id="filter57_d_BONEDMI"
          x={800.811}
          y={112.481}
          width={141.843}
          height={110.442}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter58_d_BONEDMI"
          x={802.664}
          y={133.837}
          width={138.605}
          height={104.593}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter59_d_BONEDMI"
          x={806.91}
          y={146.982}
          width={142.917}
          height={109.508}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter60_d_BONEDMI"
          x={813.235}
          y={164.034}
          width={146.454}
          height={109.793}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter61_d_BONEDMI"
          x={819.149}
          y={181.155}
          width={148.107}
          height={111.665}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter62_d_BONEDMI"
          x={826.516}
          y={197.625}
          width={148.58}
          height={119.706}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter63_d_BONEDMI"
          x={831.9}
          y={218.975}
          width={148.62}
          height={122.557}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter64_d_BONEDMI"
          x={834.391}
          y={237.16}
          width={141.958}
          height={131.299}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter65_d_BONEDMI"
          x={834.354}
          y={256.303}
          width={140.161}
          height={137.294}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter66_d_BONEDMI"
          x={834.331}
          y={276.957}
          width={139.613}
          height={141.099}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter67_d_BONEDMI"
          x={831.812}
          y={303.147}
          width={140.268}
          height={140.826}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter68_d_BONEDMI"
          x={826.396}
          y={326.763}
          width={137.94}
          height={136.547}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter69_d_BONEDMI"
          x={823.137}
          y={350.303}
          width={139.664}
          height={132.761}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter70_d_BONEDMI"
          x={816.451}
          y={369.117}
          width={144.114}
          height={134.173}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter71_d_BONEDMI"
          x={810.536}
          y={393.223}
          width={146.592}
          height={128.351}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter72_d_BONEDMI"
          x={804.717}
          y={417.916}
          width={151.352}
          height={126.072}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter73_d_BONEDMI"
          x={798.084}
          y={440.469}
          width={154.216}
          height={129.457}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter74_d_BONEDMI"
          x={792.636}
          y={464.021}
          width={156.317}
          height={128.457}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter75_d_BONEDMI"
          x={790.42}
          y={492.152}
          width={156.351}
          height={120.854}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter76_d_BONEDMI"
          x={791.589}
          y={519.744}
          width={161.583}
          height={115.831}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter77_d_BONEDMI"
          x={799.024}
          y={542.306}
          width={157.484}
          height={205.126}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter78_d_BONEDMI"
          x={800.338}
          y={92.472}
          width={132.403}
          height={109.339}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter79_d_BONEDMI"
          x={806.23}
          y={40.6709}
          width={117.911}
          height={105.949}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter80_d_BONEDMI"
          x={803.24}
          y={53.6284}
          width={129.873}
          height={111.93}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter81_d_BONEDMI"
          x={801.58}
          y={72.2739}
          width={129.425}
          height={111.297}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter82_d_BONEDMI"
          x={799.158}
          y={63.4254}
          width={55.5883}
          height={52.4179}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter83_d_BONEDMI"
          x={792.39}
          y={81.0605}
          width={59.8723}
          height={52.5999}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter84_d_BONEDMI"
          x={789.804}
          y={98.9886}
          width={59.8163}
          height={52.6139}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter85_d_BONEDMI"
          x={788.526}
          y={119.22}
          width={60.8244}
          height={52.3199}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter86_d_BONEDMI"
          x={789.53}
          y={139.042}
          width={60.3903}
          height={52.4319}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter87_d_BONEDMI"
          x={792.473}
          y={158.786}
          width={60.4603}
          height={52.6279}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter88_d_BONEDMI"
          x={797.579}
          y={176.968}
          width={59.5224}
          height={52.3899}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter89_d_BONEDMI"
          x={809.106}
          y={195.877}
          width={52.4741}
          height={52.3339}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter90_d_BONEDMI"
          x={810.301}
          y={213.639}
          width={56.7582}
          height={52.5159}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter91_d_BONEDMI"
          x={815.456}
          y={231.023}
          width={56.7022}
          height={52.5999}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter92_d_BONEDMI"
          x={821.404}
          y={249.804}
          width={57.7102}
          height={52.2359}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter93_d_BONEDMI"
          x={822.241}
          y={266.547}
          width={57.2761}
          height={52.3759}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter94_d_BONEDMI"
          x={821.818}
          y={284.661}
          width={57.3462}
          height={52.5719}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter95_d_BONEDMI"
          x={821.868}
          y={308.187}
          width={56.4082}
          height={52.3059}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter96_d_BONEDMI"
          x={819.411}
          y={330.365}
          width={57.3183}
          height={52.768}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter97_d_BONEDMI"
          x={813.72}
          y={352.721}
          width={57.2062}
          height={52.5439}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter98_d_BONEDMI"
          x={803.708}
          y={374.813}
          width={61.7046}
          height={52.4879}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter99_d_BONEDMI"
          x={799.945}
          y={396.925}
          width={56.9585}
          height={52.3339}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter100_d_BONEDMI"
          x={791.836}
          y={419.826}
          width={61.2426}
          height={52.516}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter101_d_BONEDMI"
          x={796.145}
          y={443.091}
          width={50.3408}
          height={52.3339}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter102_d_BONEDMI"
          x={787.099}
          y={466.772}
          width={54.6249}
          height={52.5159}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter103_d_BONEDMI"
          x={781.991}
          y={494.185}
          width={54.5689}
          height={52.5999}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter104_d_BONEDMI"
          x={778.536}
          y={522.936}
          width={55.5769}
          height={52.236}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter105_d_BONEDMI"
          x={782.218}
          y={554.064}
          width={55.1428}
          height={52.3759}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter106_d_BONEDMI"
          x={69.1637}
          y={546.399}
          width={143.596}
          height={235.522}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter107_d_BONEDMI"
          x={228.867}
          y={546.399}
          width={143.596}
          height={235.522}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter108_d_BONEDMI"
          x={86.9845}
          y={472.392}
          width={160.733}
          height={180.706}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter109_d_BONEDMI"
          x={193.909}
          y={472.392}
          width={160.733}
          height={180.706}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter110_d_BONEDMI"
          x={116.015}
          y={568.964}
          width={144.684}
          height={129.804}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter111_d_BONEDMI"
          x={180.928}
          y={568.964}
          width={144.684}
          height={129.804}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter112_d_BONEDMI"
          x={113.229}
          y={551.752}
          width={151.703}
          height={142.051}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter113_d_BONEDMI"
          x={176.695}
          y={551.752}
          width={151.703}
          height={142.051}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter114_d_BONEDMI"
          x={489.26}
          y={572.832}
          width={114.016}
          height={128.013}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter115_d_BONEDMI"
          x={518.719}
          y={572.832}
          width={114.016}
          height={128.013}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter116_d_BONEDMI"
          x={422.453}
          y={472.392}
          width={160.283}
          height={171.476}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter117_d_BONEDMI"
          x={539.259}
          y={472.392}
          width={160.283}
          height={171.476}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter118_d_BONEDMI"
          x={414.973}
          y={558.6}
          width={141.99}
          height={226.727}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter119_d_BONEDMI"
          x={565.031}
          y={558.6}
          width={141.99}
          height={226.81}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter120_d_BONEDMI"
          x={444.474}
          y={547.936}
          width={142.638}
          height={154.536}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter121_d_BONEDMI"
          x={534.882}
          y={547.936}
          width={142.638}
          height={154.536}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={22.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter122_f_BONEDMI"
          x={636.808}
          y={367.384}
          width={126.895}
          height={169.468}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={15}
            result="effect1_foregroundBlur_BONEDMI"
          />
        </filter>
        <filter
          id="filter123_f_BONEDMI"
          x={302.738}
          y={367.35}
          width={178.927}
          height={186.013}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={15}
            result="effect1_foregroundBlur_BONEDMI"
          />
        </filter>
        <filter
          id="filter124_d_BONEDMI"
          x={423.214}
          y={385.801}
          width={49.38}
          height={52.768}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter125_d_BONEDMI"
          x={423.403}
          y={409.534}
          width={49.086}
          height={52.5439}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter126_d_BONEDMI"
          x={420.184}
          y={433.35}
          width={54.0744}
          height={52.4879}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter127_d_BONEDMI"
          x={430.895}
          y={454.162}
          width={49.3283}
          height={52.3339}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter128_d_BONEDMI"
          x={445.657}
          y={468.98}
          width={53.6123}
          height={52.5159}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter129_f_BONEDMI"
          x={22.1253}
          y={367.384}
          width={126.895}
          height={169.468}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={15}
            result="effect1_foregroundBlur_BONEDMI"
          />
        </filter>
        <filter
          id="filter130_f_BONEDMI"
          x={-16}
          y={686.654}
          width={994.569}
          height={110.807}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={15}
            result="effect1_foregroundBlur_BONEDMI"
          />
        </filter>
        <filter
          id="filter131_d_BONEDMI"
          x={85.8299}
          y={230.481}
          width={89.4267}
          height={277.432}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter132_d_BONEDMI"
          x={130.413}
          y={230.481}
          width={44.844}
          height={52.3339}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter133_d_BONEDMI"
          x={111.633}
          y={261.73}
          width={48.9459}
          height={52.4039}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter134_d_BONEDMI"
          x={101.361}
          y={281.375}
          width={48.918}
          height={52.5999}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter135_d_BONEDMI"
          x={92.736}
          y={301.865}
          width={50.052}
          height={52.2359}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter136_d_BONEDMI"
          x={88.6101}
          y={324.991}
          width={49.156}
          height={52.3759}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter137_d_BONEDMI"
          x={85.8299}
          y={349.188}
          width={49.226}
          height={52.5719}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter138_d_BONEDMI"
          x={87.7419}
          y={374.866}
          width={48.848}
          height={52.3059}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter139_d_BONEDMI"
          x={90.1633}
          y={399.389}
          width={49.3799}
          height={52.768}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter140_d_BONEDMI"
          x={91.9822}
          y={427.324}
          width={49.086}
          height={52.544}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <filter
          id="filter141_d_BONEDMI"
          x={93.2637}
          y={455.425}
          width={54.0743}
          height={52.4879}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.83745} />
          <feGaussianBlur stdDeviation={10.553} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_BONEDMI"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_BONEDMI"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(556.406 1.57759) rotate(90) scale(784.805 185.342)"
        >
          <stop stopColor="#F6F6F6" />
          <stop offset={1} stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint1_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(521.266 454.727) rotate(80.2459) scale(23.6469 34.9307)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(600.728 454.727) rotate(99.7541) scale(23.6469 34.9307)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(429.885 367.228) rotate(90) scale(84.3696 18.0912)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(692.11 367.228) rotate(90) scale(84.3695 18.0912)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(587.963 113.236) rotate(90) scale(55.0281 27.7812)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(532.389 113.236) rotate(90) scale(55.0281 27.7812)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(560.178 142.841) rotate(90) scale(29.9767 38.0483)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(505.385 388.134) rotate(90) scale(37.1544 41.1375)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(505.385 388.134) rotate(90) scale(37.1544 41.1375)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(616.61 388.134) rotate(90) scale(37.1545 41.1375)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(616.61 388.134) rotate(90) scale(37.1545 41.1375)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(508.59 408.534) rotate(90) scale(37.2542 41.1375)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(613.404 408.534) rotate(90) scale(37.2542 41.1375)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint14_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(512.33 425.781) rotate(90) scale(37.4041 40.6033)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint15_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(609.664 425.781) rotate(90) scale(37.4041 40.6033)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint16_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(514.467 441.267) rotate(90) scale(31.521 38.4662)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint17_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(607.528 441.267) rotate(90) scale(31.521 38.4662)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint18_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(484.015 333.025) rotate(90) scale(61.4391 43.2745)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint19_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(637.98 333.025) rotate(90) scale(61.4391 43.2745)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint20_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(217.976 -2.6956) rotate(90) scale(784.804 185.342)"
        >
          <stop stopColor="#F6F6F6" />
          <stop offset={1} stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint21_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(95.1658 366.21) rotate(90.0001) scale(88.7949 21.4428)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint22_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(351.208 366.21) rotate(90.0001) scale(88.7946 21.4427)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint23_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(223.802 190.89) rotate(90) scale(32.3414 44.9964)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint24_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(222.255 191.166) rotate(90) scale(12.9677 22.5748)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint25_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(221.984 122.78) rotate(90) scale(65.6409 55.833)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <linearGradient
          id="paint26_linear_BONEDMI"
          x1={200.836}
          y1={160.297}
          x2={200.836}
          y2={180.951}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E7E7E7" stopOpacity={0} />
          <stop offset={0.71875} stopColor="#CECECE" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_BONEDMI"
          x1={193.412}
          y1={172.666}
          x2={193.412}
          y2={200.614}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.307292} stopColor="#D0D0D0" />
          <stop offset={1} stopColor="#E7E7E7" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint28_linear_BONEDMI"
          x1={254.058}
          y1={172.955}
          x2={254.058}
          y2={200.902}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.307292} stopColor="#D0D0D0" />
          <stop offset={1} stopColor="#E7E7E7" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint29_linear_BONEDMI"
          x1={243.16}
          y1={160.272}
          x2={243.16}
          y2={180.926}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E7E7E7" stopOpacity={0} />
          <stop offset={0.71875} stopColor="#CECECE" />
        </linearGradient>
        <radialGradient
          id="paint30_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(160.77 473.077) rotate(90) scale(12.9514 23.682)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint31_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(285.076 473.077) rotate(90) scale(12.9513 23.682)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint32_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(165.877 449.566) rotate(90) scale(23.0768 33.6433)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint33_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(279.97 449.566) rotate(90) scale(23.0768 33.6433)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint34_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(170.257 429.712) rotate(90) scale(24.7098 40.5988)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint35_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(275.589 429.712) rotate(90) scale(24.7098 40.5988)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint36_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(173.189 409.405) rotate(90) scale(24.1057 45.9148)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint37_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(272.658 409.405) rotate(90) scale(24.1057 45.9148)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint38_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(173.388 387.207) rotate(90) scale(21.2863 47.4251)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint39_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(272.458 387.207) rotate(90) scale(21.2863 47.4251)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint40_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(172.382 362.007) rotate(90) scale(21.1457 46.5629)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint41_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(273.465 362.007) rotate(90) scale(21.1457 46.5629)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint42_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(174.867 337.72) rotate(90) scale(22.8835 44.0742)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint43_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(270.98 337.72) rotate(90) scale(22.8835 44.0742)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint44_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(176.136 317.895) rotate(90) scale(19.9781 36.6295)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint45_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(269.711 317.895) rotate(90) scale(19.9781 36.6295)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint46_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(185.524 296.436) rotate(90) scale(20.7399 34.5117)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint47_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(260.322 296.415) rotate(90) scale(20.7607 34.5117)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint48_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(191.877 273.991) rotate(90) scale(23.5427 23.4579)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint49_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(191.877 273.991) rotate(90) scale(23.5427 23.4579)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint50_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(253.953 273.991) rotate(90) scale(23.5427 23.4415)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint51_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(253.953 273.991) rotate(90) scale(23.5427 23.4415)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint52_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(168.612 272.651) rotate(90) scale(10.6777 47.5405)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint53_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(277.234 272.651) rotate(90) scale(10.6777 47.5405)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint54_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(222.923 344.837) rotate(90) scale(66.603 16.7331)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint55_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(222.212 188.977) rotate(90) scale(7.27688 22.5747)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <linearGradient
          id="paint56_linear_BONEDMI"
          x1={860.333}
          y1={561.035}
          x2={860.333}
          y2={726.294}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.727333} stopColor="#F0F0F0" />
          <stop offset={1} stopColor="#F0F0F0" stopOpacity={0} />
        </linearGradient>
        <radialGradient
          id="paint57_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(847.978 -106.611) rotate(90) scale(923.148 130.27)"
        >
          <stop stopColor="#F6F6F6" />
          <stop offset={1} stopOpacity={0} />
        </radialGradient>
        <linearGradient
          id="paint58_linear_BONEDMI"
          x1={848.129}
          y1={-43.7681}
          x2={848.129}
          y2={768.164}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.097861} stopColor="white" />
          <stop offset={0.206656} stopColor="white" stopOpacity={0} />
        </linearGradient>
        <radialGradient
          id="paint59_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(871.111 164.116) rotate(80.8652) scale(15.6528 25.3076)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint60_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(871.852 182.726) rotate(80.8423) scale(12.1594 23.6223)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint61_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(878.282 198.118) rotate(80.8397) scale(13.0009 25.7337)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint62_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(886.373 216.128) rotate(80.838) scale(13.6989 27.4421)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint63_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(893.118 234.892) rotate(80.8515) scale(15.4608 28.0048)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint64_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(900.657 255.31) rotate(80.8785) scale(19.5321 27.6608)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint65_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(906.192 276.462) rotate(88.9758) scale(16.9128 29.1036)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint66_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(905.291 299.074) rotate(88.9769) scale(21.1209 25.7575)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint67_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(904.35 321.248) rotate(88.9772) scale(24.0544 24.8119)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint68_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(904.004 343.75) rotate(88.9773) scale(26.003 24.5518)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint69_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(902.279 368.8) rotate(92.6341) scale(24.3332 25.8134)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint70_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(896.246 389.854) rotate(96.7071) scale(20.1494 25.4022)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint71_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(893.7 412.065) rotate(98.9396) scale(16.1141 26.7336)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint72_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(890.194 431.893) rotate(103.984) scale(12.9139 29.3256)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint73_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(885.229 454.236) rotate(104.021) scale(10.9458 29.8358)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint74_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(881.439 477.503) rotate(101.489) scale(10.2726 31.9193)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint75_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(876.602 500.344) rotate(101.494) scale(11.2313 33.585)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint76_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(871.897 524.126) rotate(97.8309) scale(12.544 33.9582)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint77_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(868.676 548.066) rotate(94.4329) scale(12.92 33.9649)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint78_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(872.349 572.45) rotate(86.8004) scale(14.7527 35.334)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint79_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(879.041 641.571) rotate(86.8222) scale(58.5627 32.3311)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint80_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(866.086 143.349) rotate(83.4744) scale(12.9002 20.8932)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint81_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(865.185 89.6455) rotate(90) scale(7.97464 13.9556)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint82_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(868.176 105.594) rotate(90) scale(10.9651 19.9366)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint83_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(866.064 124.028) rotate(86.7446) scale(12.1876 19.5307)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint84_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(140.962 660.16) rotate(90) scale(72.7608 26.7981)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint85_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(300.665 660.16) rotate(90) scale(72.7608 26.7981)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint86_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(167.351 558.745) rotate(90) scale(45.3531 35.3665)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint87_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(274.276 558.745) rotate(90) scale(45.3531 35.3665)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint88_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(188.357 629.866) rotate(90) scale(19.9018 27.3419)"
        >
          <stop stopColor="#FFC9BD" />
          <stop offset={1} stopColor="#F95A37" />
        </radialGradient>
        <radialGradient
          id="paint89_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(253.27 629.866) rotate(90) scale(19.9018 27.3419)"
        >
          <stop stopColor="#FFC9BD" />
          <stop offset={1} stopColor="#F95A37" />
        </radialGradient>
        <radialGradient
          id="paint90_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(189.08 618.778) rotate(90) scale(26.0257 30.8514)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint91_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(252.546 618.778) rotate(90) scale(26.0257 30.8514)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint92_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(546.268 632.838) rotate(90) scale(19.0066 12.0078)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint93_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(575.727 632.838) rotate(90) scale(19.0066 12.0078)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint94_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(502.594 554.13) rotate(90) scale(40.7378 35.1415)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint95_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(619.4 554.13) rotate(90) scale(40.7378 35.1415)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint96_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(485.968 667.964) rotate(90) scale(68.3634 25.9952)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint97_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(636.026 668.005) rotate(90) scale(68.4048 25.9952)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint98_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(515.794 621.204) rotate(90) scale(32.2681 26.3192)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <radialGradient
          id="paint99_radial_BONEDMI"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(606.201 621.204) rotate(90) scale(32.2681 26.3192)"
        >
          <stop offset={0.546875} stopColor="#F7341D" />
          <stop offset={1} stopColor="#F3A998" />
        </radialGradient>
        <linearGradient
          id="paint100_linear_BONEDMI"
          x1={512}
          y1={657.576}
          x2={512}
          y2={768.164}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFEFE" stopOpacity={0} />
          <stop offset={0.635417} stopColor="#FFFEFE" />
        </linearGradient>
        <clipPath id="clip0_BONEDMI">
          <rect width={1024} height={768} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

BoneMetastasesDMIImage.displayName = "BoneMetastasesDMIImage";
export default BoneMetastasesDMIImage;
